import * as i0 from '@angular/core';
import { Pipe, InjectionToken, Inject, Optional, Injectable, isDevMode, Component, Input, EventEmitter, ViewContainerRef, ViewChild, Output, HostListener, Directive, ViewChildren, TemplateRef, ContentChildren, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i1$3 from '@angular/common';
import { CommonModule as CommonModule$1, CurrencyPipe } from '@angular/common';
import * as i1 from '@angular/router';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DateTime } from 'luxon';
import * as i1$1 from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { of, tap, map, firstValueFrom, switchMap, catchError, shareReplay, filter, mergeMap, Subject, BehaviorSubject, isObservable, throwError, takeUntil, merge, combineLatest, Subscription, fromEvent, Observable, ReplaySubject, animationFrameScheduler, interval, takeWhile, endWith, distinctUntilChanged, from, finalize } from 'rxjs';
import * as _ from 'lodash';
import { validate, version, v4 } from 'uuid';
import { toODataString, isCompositeFilterDescriptor, process } from '@progress/kendo-data-query';
import { subject } from '@casl/ability';
import { PermissionManager, PermissionActions } from '@pl/permission-manager';
import * as i2 from '@angular/common/http';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import * as i3 from 'angular-oauth2-oidc';
import { __decorate, __param } from 'tslib';
import * as i3$1 from '@pl/pl-lib/errors';
import * as i1$2 from '@progress/kendo-angular-notification';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { diff_match_patch } from 'diff-match-patch';
import * as Diff2Html from 'diff2html';
import * as i2$1 from '@ngx-translate/core';
import { TranslatePipe, TranslateModule } from '@ngx-translate/core';
import * as i4 from '@angular/forms';
import * as i5 from '@progress/kendo-angular-dialog';
import * as i2$2 from '@progress/kendo-angular-buttons';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import * as i3$2 from '@progress/kendo-angular-grid';
import { ExcelModule } from '@progress/kendo-angular-grid';
import * as i2$3 from '@progress/kendo-angular-tooltip';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { throttleTime, map as map$1 } from 'rxjs/operators';
import * as i2$4 from 'ngx-markdown';
import { MarkdownModule } from 'ngx-markdown';
import * as i2$5 from '@progress/kendo-angular-layout';
import { LayoutModule } from '@progress/kendo-angular-layout';
import * as i4$1 from '@progress/kendo-angular-filter';
import { FilterModule } from '@progress/kendo-angular-filter';
import 'prismjs';
import 'prismjs/components/prism-json.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import { trigger, transition, query, style, stagger, animate, state } from '@angular/animations';
import * as i3$3 from '@progress/kendo-angular-ripple';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';

class DisplayDataResolverConfig {
    displayDataResolversMap;
}

class DynamicLabelConfig {
    dynamicLabelHandler;
}

class AuthConfig {
    /**
     * Route to redirect to when user is not authenticated
     */
    unauthenticatedRoute;
    /**
     * Query parameters of the redirect route to when user is not authenticated
     */
    unauthenticatedQueryParams;
    /**
     * Route to redirect to when user is authenticated
     */
    authenticatedRoute;
    /**
     * Route to redirect to when user tries to access a forbidden resource
     */
    forbiddenRoute;
}

class PermissionManagerConfig {
    /**
     * Route to redirect to when user is authenticated
     */
    fetchPermissionsFunction;
    usePlac;
    placUrl;
    // Either ApplicationId or ApplicationName has to be provider. Id has precedence
    placApplicationId;
    placApplicationName;
    ttl = 60000;
    setSubjectNameToDbModelMapFunction;
    dbEngineName;
    dynamicResolversGetter;
    missingIncludesHydraterGetter;
}

class DynamicLabelPipe {
    config;
    subType;
    constructor(route, config) {
        this.config = config;
        this.subType = route.snapshot.queryParams['type'];
    }
    transform(value, type, subType) {
        if (!type) {
            return value;
        }
        if (!subType && this.subType) {
            subType = this.subType;
        }
        return this.config.dynamicLabelHandler(value, type, subType);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicLabelPipe, deps: [{ token: i1.ActivatedRoute }, { token: DynamicLabelConfig }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DynamicLabelPipe, name: "dynamicLabel" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DynamicLabelPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'dynamicLabel' }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }, { type: DynamicLabelConfig }]; } });

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = [
    'Bytes',
    'Kilobytes',
    'Megabytes',
    'Gigabytes',
    'Pettabytes',
    'Exabytes',
    'Zettabytes',
    'Yottabytes'
];
class FormatFileSizePipe {
    transform(sizeInBytes, longForm = false) {
        if (!sizeInBytes) {
            return '0 B';
        }
        const units = longForm ? FILE_SIZE_UNITS_LONG : FILE_SIZE_UNITS;
        let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, units.length - 1);
        const size = sizeInBytes / Math.pow(1024, power); // size in new units
        const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        const unit = units[power];
        return `${formattedSize} ${unit}`;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatFileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormatFileSizePipe, name: "formatFileSize" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatFileSizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'formatFileSize'
                }]
        }] });

class LuxonRelativePipe {
    transform(value, style) {
        if (!value)
            return '';
        // Convert the input to a Luxon DateTime object
        const date = typeof value === 'string'
            ? DateTime.fromISO(value)
            : DateTime.fromJSDate(value);
        // Return the relative time string
        return date.toRelative(style ? {
            style
        } : undefined) ?? '';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LuxonRelativePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: LuxonRelativePipe, name: "luxonRelative" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LuxonRelativePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'luxonRelative'
                }]
        }] });

class SafePipe {
    sanitizer;
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`SafePipe unable to bypass security for invalid type: ${type}`);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, name: "safe" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safe' }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class SplitPascalCasePipe {
    transform(value) {
        if (!value) {
            return '';
        }
        return value.replace(/([a-z])([A-Z])/g, '$1 $2');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SplitPascalCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SplitPascalCasePipe, name: "splitPascalCase" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SplitPascalCasePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'splitPascalCase'
                }]
        }] });

class StripHTMLPipe {
    transform(value) {
        if (!value) {
            return '';
        }
        if (!value.replace) {
            return value;
        }
        return value.replace(/(<([^>]+)>)/gi, '');
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StripHTMLPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: StripHTMLPipe, name: "stripHTML" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StripHTMLPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'stripHTML' }]
        }] });

class TrimToFieldNamePipe {
    transform(value) {
        if (!value)
            return '';
        return value.split('.').pop() || value;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TrimToFieldNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TrimToFieldNamePipe, name: "trimToFieldName" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TrimToFieldNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'trimToFieldName' }]
        }] });

class TruncatePipe {
    transform(value, args) {
        const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
        const trail = args.length > 1 ? args[1] : '…';
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
    static ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TruncatePipe, name: "truncate" });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truncate'
                }]
        }] });

const WINDOW = new InjectionToken('window');
const windowProvider = {
    provide: WINDOW,
    useFactory: () => window
};
const WINDOW_PROVIDERS = [windowProvider];

class BaseNotificationService {
    constructor() { }
}

class BaseDataService {
    apiService;
    _current;
    set current(value) {
        this._current = value;
    }
    constructor(apiService) {
        this.apiService = apiService;
    }
    getCurrent(id, force = false) {
        if (this._current && !force && this._current.id === id) {
            return of(this._current);
        }
        return this.apiService.get(id);
    }
    get(state) {
        return this.apiService.getAll(state);
    }
    getPaginated(state) {
        return this.apiService.getAllPaginated(state);
    }
    create(dto, files) {
        return files
            ? this.apiService.createWithFiles(dto, files)
            : this.apiService.create(dto);
    }
    update(dto, files) {
        return (files
            ? this.apiService.updateWithFiles(dto, files)
            : this.apiService.update(dto)).pipe(tap((e) => (this._current = e)));
    }
    delete(id) {
        return this.apiService.delete(id);
    }
    count(state) {
        return this.apiService.count(state);
    }
}

class BaseAuditableDataService extends BaseDataService {
    getHistory(id) {
        return this.apiService.getHistory(id);
    }
}

const isUuidV1 = (s) => validate(s) && version(s) === 1;
const isUuidV4 = (s) => validate(s) && version(s) === 4;

/**
 * TODO: use kendo function directly if possible
 *
 * Most of the functions below are direct copy from kendo libraries.
 * When tried to use them directly following error would appear on the library user app
 *
 *
 * ./node_modules/@pl/pl-lib/fesm2015/pl-pl-lib-data-grids.mjs:5:0-63 - Error: Module not found: Error: Can't resolve '@progress/kendo-angular-grid/utils' in '/Users/lukaszsalamon/Repos/PremierLeague/pl-admin-centre/application/node_modules/@pl/pl-lib/fesm2015'
 *
 */
const isPresent = (value) => value !== null && value !== undefined;
const handleCollectionFilters = (descriptor, replacements) => {
    if (typeof descriptor.field == 'string' &&
        descriptor.subType === 'Collection') {
        const oldValue = descriptor.value;
        descriptor.operator = 'eq';
        descriptor.value = ('temporary' + Math.random()).replace('.', '');
        // const replacement : string = oldOperator sa= 'containsobject'
        //     ? //     '${descriptor.field} /any(c:c/Id eq SoldValue.id))°
        //     : oldoperator === 'doesnotcontainobject' ? ${descriptor.field)/all(c:c/Id ne $oldvalue.idl): 'not suponted';
        const replacement = `${descriptor.field}/${descriptor.operatorName}${oldValue}`;
        replacements.push({
            pattern: `${descriptor.field} eq '${descriptor.value}'`,
            replacement
        });
    }
};
const convertToODataString = (state) => {
    let kendoString = kendoConvertToODataString(state);
    if (state.expand && state.expand !== '') {
        kendoString = `${kendoString !== '' ? kendoString + '&' : ''}$expand=${state.expand}`;
    }
    if (state.select) {
        kendoString = `${kendoString !== '' ? kendoString + '&' : ''}$select=${state.select}`;
    }
    return kendoString;
};
const kendoConvertToODataString = (state) => {
    if (!state.filter) {
        return toODataString(state);
    }
    state = _.cloneDeep(state);
    const allCustomFilters = flatten(state.filter).filter((f) => f.custom);
    if (allCustomFilters.length === 0) {
        return toODataString(state);
    }
    const replacements = [];
    allCustomFilters.forEach((f) => {
        handleCollectionFilters(f, replacements);
    });
    let stateOData = toODataString(state);
    replacements.forEach((r) => (stateOData = stateOData.replace(new RegExp(r.pattern, 'g'), r.replacement)));
    return stateOData;
};
const insertDefaultFilter = (index, rootFilter, filter) => {
    rootFilter = rootFilter || { filters: [], logic: 'and' };
    rootFilter.filters[index] = filter;
    return filter;
};
const setFilter = (index, filter, field, defaultOperator) => {
    if (isPresent(filter) &&
        isPresent(filter.filters) &&
        filter.filters.length > index) {
        return filter.filters[index];
    }
    else {
        return insertDefaultFilter(index, filter, {
            field,
            operator: defaultOperator
        });
    }
};
const flatten = (filter) => {
    if (isPresent(filter.filters)) {
        return filter.filters.reduce((acc, curr) => acc.concat(isCompositeFilterDescriptor(curr) ? flatten(curr) : [curr]), []);
    }
    return [];
};
const trimFilterByField = (filter, field) => {
    if (isPresent(filter) && isPresent(filter.filters)) {
        filter.filters = filter.filters.filter((x) => {
            if (isCompositeFilterDescriptor(x)) {
                trimFilterByField(x, field);
                return x.filters.length;
            }
            else {
                return x.field !== field;
            }
        });
    }
};
const filtersByField = (filter, field) => flatten(filter || {}).filter((x) => x.field === field);
const filterByField = (filter, field) => {
    let [currentFilter] = filtersByField(filter, field);
    return currentFilter;
};
const removeFilter = (filter, field) => {
    trimFilterByField(filter, field);
    return filter;
};
/**
 Makes sure that <param>state</param> filter property contains <param>filter</param> in it's root filters.
 Updates <param>state</param> object.
 Returns <param>state</param>
 */
function setMandatoryFilter(state, filter) {
    if (!state.filter) {
        state.filter = filter.logic
            ? filter
            : { logic: 'and', filters: [filter] };
        return state;
    }
    if (flatten(state.filter).length === 0) {
        state.filter.filters = [filter];
        return state;
    }
    if (!_.isEqual(state.filter, filter) &&
        (state.filter.logic != 'and' ||
            state.filter.filters.filter((f) => _.isEqual(f, filter)).length == 0)) {
        state.filter = { logic: 'and', filters: [filter, state.filter] };
        return state;
    }
    return state;
}

class MultiPropertyCache {
    keysToGenerate;
    mainPropertyName;
    caches = { id: {} };
    cacheKeys = {};
    constructor(keysToGenerate, mainPropertyName = 'id') {
        this.keysToGenerate = keysToGenerate;
        this.mainPropertyName = mainPropertyName;
    }
    isKeyCaseSensitive(property) {
        if (property === this.mainPropertyName) {
            return true;
        }
        const key = this.keysToGenerate
            .filter(k => typeof k === 'string' ? k === property : k.key === property)[0];
        if (!key) {
            throw new Error(`Property ${property} not present in keys to generate array`);
        }
        return typeof key === 'string' || !key.ignoreCase;
    }
    addToCache(u, generateKeys = true) {
        const mainKey = u[this.mainPropertyName];
        this.caches[this.mainPropertyName][mainKey] = u;
        if (generateKeys) {
            this.generateKeys();
        }
    }
    addMultipleToCache(u) {
        u.forEach((uu) => this.addToCache(uu, false));
        this.generateKeys();
    }
    getCached(ids, cachePropertyName = this.mainPropertyName, getAction) {
        const idsToUse = this.isKeyCaseSensitive(cachePropertyName) ? ids : ids.map(e => e ? e.toLowerCase() : e);
        const missingKeys = _.difference(idsToUse, this.cacheKeys[cachePropertyName]);
        const existingKeys = _.difference(idsToUse, missingKeys);
        const existing = _.map(existingKeys, (i) => this.caches[cachePropertyName][i]);
        if (missingKeys.length === 0) {
            return of(existing);
        }
        return getAction(missingKeys, existing, cachePropertyName);
    }
    getAll() {
        return of(_.values(this.caches[this.mainPropertyName]));
    }
    clear() {
        this.caches = { [this.mainPropertyName]: {} };
        this.cacheKeys = {};
    }
    generateKeys() {
        this.cacheKeys[this.mainPropertyName] = _.keys(this.caches[this.mainPropertyName]);
        for (const keysToGenerateElement of this.keysToGenerate) {
            const property = typeof keysToGenerateElement === 'string' ? keysToGenerateElement : keysToGenerateElement.key;
            this.caches[property] = _.keyBy(this.caches[this.mainPropertyName], typeof keysToGenerateElement === 'string'
                ? property
                : (e) => e[property] ? e[property].toLowerCase() : e[property]);
            this.cacheKeys[property] = _.keys(this.caches[property]);
        }
    }
}

const getDistanceToBottom = (elementRef) => {
    const element = elementRef.nativeElement;
    const rect = element.getBoundingClientRect();
    const elementBottom = rect.top + rect.height;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return windowHeight - elementBottom;
};

class BaseNonEntityApiService {
    apiEndpoint;
    http;
    environmentService;
    /**
     * State that will be applied to all Get requests.
     *
     * For getAll: it will be applied in GetAllInternal. The state passed as parameter will be merged onto this forcedState value.
     * For get(id): only the value of `expand` and `select` properties will be used
     * @protected
     */
    forcedState = undefined;
    constructor(apiEndpoint, http, environmentService) {
        this.apiEndpoint = apiEndpoint;
        this.http = http;
        this.environmentService = environmentService;
    }
    buildUrl(action) {
        return this.environmentService.buildApiUrl(`${this.apiEndpoint}${action || ''}`);
    }
    getODataQueryString(state) {
        return state ? `/?${convertToODataString(state)}` : '';
    }
    /**
     * Calculates the state based on the {@link state} and {@link forcedState} field.
     * Then it calls @{@link getODataQueryString}
     * @param state
     * @protected
     */
    getODataQueryStringIncludingForcedState(state, updateStateCallback) {
        let calculatedState = state || this.forcedState;
        if (this.forcedState && state) {
            calculatedState = _.merge({}, this.forcedState, state);
        }
        if (updateStateCallback && calculatedState) {
            calculatedState = updateStateCallback(calculatedState);
        }
        return this.getODataQueryString(calculatedState);
    }
}

class BaseApiService extends BaseNonEntityApiService {
    userService;
    uploadAlwaysAsMultipleFiles = false;
    httpOptions = {};
    constructor(apiEndpoint, http, environmentService, userService) {
        super(apiEndpoint, http, environmentService);
        this.userService = userService;
    }
    /**
     * Gets all records according to {@link state}.
     *
     * Can return partial result if API has a limit on number of items returned.
     * @param state
     */
    getAll(state) {
        return this.getAllInternal(undefined, state).pipe(map((r) => r.data));
    }
    /**
     * Gets all records according to {@link state}
     *
     * Will return all possible records even if API has a limit on number of items returned. In that case it will make multiple requests to get all records.
     *
     * @param state
     */
    async getAllRecursive(state) {
        if (state) {
            state = _.cloneDeep(state);
        }
        const originalStateSkip = state?.skip || 0;
        let resultData;
        while (!resultData || resultData.data.length < resultData.count) {
            const lastDataLength = resultData?.data.length;
            resultData = await firstValueFrom(this.getAllInternal(undefined, state).pipe(map((e) => {
                return {
                    data: (resultData?.data || []).concat(e.data),
                    count: e.count
                };
            })));
            state = state || {};
            state.skip = originalStateSkip + resultData.data.length;
            if (lastDataLength === resultData.data.length ||
                resultData.data.length === state.take) {
                break;
            }
        }
        return resultData.data;
    }
    getAllPaginated(state) {
        return this.getAllInternal(undefined, state);
    }
    count(state) {
        return this.http.get(this.buildUrl(`/count${this.getODataQueryStringIncludingForcedState(state, (s) => {
            delete s.expand;
            delete s.select;
            return s;
        })}`), (this.httpOptions['get'] || this.httpOptions['all']));
    }
    get(id) {
        let stateString = '';
        if (this.forcedState) {
            stateString = this.getODataQueryString({
                expand: this.forcedState.expand,
                select: this.forcedState.select
            });
        }
        return this.http.get(this.buildUrl(`/${id}${stateString}`), (this.httpOptions['get'] || this.httpOptions['all'])).pipe(switchMap((data) => {
            if (this.userService) {
                return this.hydrateData([data]).pipe(map((hydratedData) => this.convert(hydratedData[0])));
            }
            return of(this.convert(data));
        }));
    }
    create(item) {
        return this.http.post(this.buildUrl(), item, (this.httpOptions['post'] || this.httpOptions['all'])).pipe(map(this.convert));
    }
    update(item) {
        return this.http
            .put(this.buildUrl(`/${item.id}`), item, (this.httpOptions['put'] || this.httpOptions['all']))
            .pipe(map(this.convert));
    }
    delete(id) {
        return this.http.delete(this.buildUrl(`/${id}`), (this.httpOptions['delete'] || this.httpOptions['all']));
    }
    createWithFiles(item, files) {
        return this.create(this.createFormData(item, files));
    }
    updateWithFiles(item, files) {
        return this.update(this.createFormData(item, files));
    }
    convert(input) {
        return input;
    }
    getAllInternalUrl(urlBuilder, state) {
        return urlBuilder
            ? urlBuilder()
            : this.buildUrl(this.getODataQueryStringIncludingForcedState(state));
    }
    getAllInternal(urlBuilder, state) {
        const url = this.getAllInternalUrl(urlBuilder, state);
        return this.http.get(url, (this.httpOptions['get'] || this.httpOptions['all'])).pipe(switchMap((result) => {
            const data = Array.isArray(result) ? result : result.data;
            const count = Array.isArray(result) ? result.length : result.count;
            if (this.userService) {
                return this.hydrateData(data).pipe(map((hydratedData) => ({
                    data: hydratedData.map(this.convert),
                    count,
                    sourceUrl: url
                })));
            }
            return of({ data: data.map(this.convert), count, sourceUrl: url });
        }));
    }
    createFormData(item, files) {
        const formData = new FormData();
        if (files.length === 1 && !this.uploadAlwaysAsMultipleFiles) {
            formData.append('file', files[0], files[0].name);
        }
        else {
            for (let i = 0; i < files.length; i++) {
                formData.append(i.toString(), files[i], files[i].name);
            }
        }
        formData.append('data', JSON.stringify(item));
        return formData;
    }
    populateAuthorData(propertyName, authorData, entity, authorsMap) {
        if (!entity[propertyName]) {
            return;
        }
        if (entity[propertyName].startsWith('SYSTEM-') && authorsMap.has(entity[propertyName].replace('SYSTEM-', ''))) {
            const author = authorsMap.get(entity[propertyName].replace('SYSTEM-', ''));
            authorData[propertyName + 'Name'] = `SYSTEM on behalf of ${author.name}`;
            authorData[propertyName] = author;
        }
        else if (entity[propertyName] === 'PLAC_USER_SYNC_HANDLER') {
            authorData[propertyName + 'Name'] = 'System User Sync';
        }
        else if (authorsMap.has(entity[propertyName])) {
            authorData[propertyName] = authorsMap.get(entity[propertyName]);
            authorData[propertyName + 'Name'] = authorsMap.get(entity[propertyName])
                ?.name;
        }
    }
    hydrateData(data, userIdProperties, updateOriginal = false) {
        if (!this) {
            return of(data);
        }
        const propertyNames = userIdProperties || ['createdBy', 'updatedBy'];
        const ids = _.uniq(data
            .map((e) => propertyNames.map((p) => e[p] ? e[p].replace('SYSTEM-', '') : e[p]))
            .flat()).filter((id) => !!id && isUuidV4(id));
        return this.userService.resolveAuthors(ids).pipe(map((authors) => {
            const authorsMap = new Map(authors.map((user) => [user.id, user]));
            return data.map((entity) => {
                const authorData = {};
                for (const userIdProperty of propertyNames) {
                    this.populateAuthorData(userIdProperty, authorData, entity, authorsMap);
                }
                if (updateOriginal) {
                    entity.authors = authorData;
                    return entity;
                }
                return { ...entity, authors: authorData };
            });
        }));
    }
}

class BaseAuditableApiService extends BaseApiService {
    static getHistory(http, environmentService, apiEndpoint, id, userService, hydrateData) {
        return http
            .get(environmentService.buildApiUrl(`${apiEndpoint}/${id}/history`))
            .pipe(switchMap((result) => {
            if (userService && hydrateData) {
                return hydrateData(result, ['changeUserId'], true);
            }
            return of(result);
        }));
    }
    getHistory(id) {
        return BaseAuditableApiService.getHistory(this.http, this.environmentService, this.apiEndpoint, id, this.userService, this.hydrateData);
    }
}

const configLocation = '/assets/config/environment.json';
let BaseEnvironmentService = class BaseEnvironmentService {
    http;
    window;
    errorService;
    authConfig;
    apiHostUrl;
    placApiHostUrl;
    placApplicationId;
    placApplicationName;
    additionalUrlsToSetAuthTokensOn;
    constructor(http, window, errorService) {
        this.http = http;
        this.window = window;
        this.errorService = errorService;
    }
    load() {
        return this.http
            .get(configLocation)
            .pipe(tap((c) => this.setConfig(c)));
    }
    /***
     * calls {@link load} method and uses ErrorsService to handle errors which can produce error 'Env-1'.
     *
     * Checks if authConfig was loaded if not it redirects to error page with error 'Env-2'.
     *
     * Errors: Env-1, Env-2
     */
    async loadAndHandleErrors() {
        if (!this.errorService) {
            throw new Error('Error service is not present in Injector. Please make sure that ErrorsModule is imported or please call load() method directly.');
        }
        let r = await firstValueFrom(this.load().pipe(catchError(this.errorService.handleObservableCatchError('Env', '1'))));
        if (!r) {
            return false;
        }
        if (!this.authConfig) {
            await this.errorService.redirectToError({ category: 'Env', code: '2' });
            return false;
        }
        return true;
    }
    setConfig(c) {
        this.authConfig = c.authConfig;
        this.authConfig.redirectUri = this.resolveHostUri(this.authConfig.redirectUri, '/');
        this.authConfig.postLogoutRedirectUri = this.resolveHostUri(this.authConfig.postLogoutRedirectUri, '/logout');
        this.apiHostUrl = this.trimTrailingSlashes(c.apiHostUrl);
        this.placApiHostUrl = this.trimTrailingSlashes(c.placApiHostUrl);
        this.placApplicationId = c.placApplicationId;
        this.placApplicationName = c.placApplicationName;
    }
    resolveHostUri(uri, pathSuffix) {
        if (!uri) {
            throw new Error('URI is undefined.');
        }
        if (uri === 'CURRENT_HOST') {
            let resolvedUri = `${window.location.protocol}//${window.location.hostname}`;
            if (window.location.port)
                resolvedUri += `:${window.location.port}`;
            resolvedUri += pathSuffix;
            return resolvedUri;
        }
        return uri;
    }
    trimTrailingSlashes(url) {
        return url.replace(/\/+$/g, '');
    }
    buildApiUrl(url) {
        return this.apiHostUrl + '/' + url.replace(/^\/+/g, '');
    }
};
BaseEnvironmentService = __decorate([
    __param(1, Inject(WINDOW)),
    __param(2, Optional())
], BaseEnvironmentService);

class AuthenticationService {
    oauthService;
    environmentService;
    errorService;
    _isAuthenticated;
    get isAuthenticated() {
        return this._isAuthenticated;
    }
    set isAuthenticated(isAuthenticated) {
        this._isAuthenticated = isAuthenticated;
    }
    constructor(oauthService, environmentService, errorService) {
        this.oauthService = oauthService;
        this.environmentService = environmentService;
        this.errorService = errorService;
    }
    async refreshTokenOrLogout() {
        try {
            await this.oauthService.refreshToken();
            return true;
        }
        catch (e) {
            await this.oauthService.revokeTokenAndLogout();
            return false;
        }
    }
    canRefreshToken() {
        return this.oauthService.getRefreshToken();
    }
    async init(permissionsService) {
        if (!this.errorService) {
            throw new Error('Error service is not present in Injector. Please make sure that ErrorsModule is imported or please call load() method directly.');
        }
        try {
            this.isAuthenticated = false;
            // AuthService
            this.oauthService.configure(this.environmentService.authConfig);
            this.oauthService.setupAutomaticSilentRefresh();
            await this.login();
            if (this.oauthService.getAccessToken()) {
                if (!await permissionsService.initAndHandleErrors(this.oauthService)) {
                    return false;
                }
            }
            this.oauthService.events.subscribe(async (_) => {
                if (_.type === 'token_received') {
                    await this.oauthService.loadUserProfile();
                    if (!await permissionsService.initAndHandleErrors(this.oauthService)) {
                        return;
                    }
                }
                if (_.type === 'discovery_document_loaded' &&
                    this.oauthService.getAccessToken()) {
                    if (!await permissionsService.initAndHandleErrors(this.oauthService)) {
                        return;
                    }
                }
            });
            this.isAuthenticated = true;
            return true;
        }
        catch (e) {
            await this.errorService?.handleException(e, 'Authentication', '1');
            return false;
        }
    }
    async login() {
        if (await this.oauthService.loadDiscoveryDocumentAndLogin()) {
            // We've got valid token. Let's just check if we need to redirect
            const redirectUrl = sessionStorage.getItem('redirectUrl');
            const requestedUrl = sessionStorage.getItem('authentication-requestedUrl');
            if (requestedUrl || redirectUrl) {
                sessionStorage.removeItem('redirectUrl');
                sessionStorage.removeItem('authentication-requestedUrl');
                console.log('authentication - removed redirectUrl');
                location.replace(requestedUrl || redirectUrl);
            }
        }
        else {
            // We don't have a valid token and the initFlowLogin was initialised.
            // Let's set return url.
            const requestedUrl = sessionStorage.getItem('authentication-requestedUrl');
            if (!requestedUrl) {
                const currentUrl = location.pathname + location.search;
                sessionStorage.setItem('redirectUrl', currentUrl);
                sessionStorage.setItem('authentication-requestedUrl', currentUrl);
                console.log('authentication - Added redirectUrl');
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthenticationService, deps: [{ token: i3.OAuthService }, { token: BaseEnvironmentService }, { token: i3$1.ErrorsService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthenticationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthenticationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i3.OAuthService }, { type: BaseEnvironmentService }, { type: i3$1.ErrorsService, decorators: [{
                    type: Optional
                }] }]; } });

class PermissionsService {
    permissionManagerConfig;
    http;
    authService;
    errorService;
    permissionManager;
    initialized;
    constructor(permissionManagerConfig, http, authService, errorService) {
        this.permissionManagerConfig = permissionManagerConfig;
        this.http = http;
        this.authService = authService;
        this.errorService = errorService;
    }
    invalidate() {
        this.permissionManager?.invalidate?.();
    }
    async forceRefresh() {
        await this.permissionManager?.forceRefresh?.();
    }
    needsFieldLevelSecurity(entityForPermissionChecks, action, modelName) {
        const model = entityForPermissionChecks.typeName || modelName;
        if (!model) {
            throw new Error(`NeedFieldLevelSecurity requires model name. It usually should be provided by 'typeName' property on entity or as a 'modelName' optional parameter.`);
        }
        try {
            return this.permissionManager?.needsFieldSecurityForActionAndModel(model, action);
        }
        catch (error) {
            if (error.message.indexOf('Cannot find any subjects for model') !== -1) {
                throw new Error(`${error.message}. If error happen in BaseEntityDetail it usually caused by displayDataResolver.displayTypeName being set to something else then actual model name. To solve please populate displayDataResolver.typeName with model name.`);
            }
            throw error;
        }
    }
    /**
     * Calls {@link init} method.
     *
     * if init method comes back with 403 will attempt to fix token by calling refreshToken. If that fails will try to fix it by calling revokeTokenAndLogout.
     * If none of the above works will redirect to error 'PermissionService-1'
     *
     * Errors: PermissionService-1
     * @param oAuthService
     * @param tryRelogin
     */
    async initAndHandleErrors(oAuthService, tryRelogin = true) {
        if (!this.errorService) {
            throw new Error('Error service is not present in Injector. Please make sure that ErrorsModule is imported or please call load() method directly.');
        }
        //TODO: Deal with user not in db error .
        try {
            await this.init();
        }
        catch (e) {
            if (tryRelogin &&
                (e.status === 403 ||
                    e.internalError?.internalError?.status ===
                        403) &&
                this.authService.canRefreshToken()) {
                const item = sessionStorage.getItem('APP-INIT-REPAIR-PERMISSION-MANAGER-ATTEMPTED');
                if (!item) {
                    if (!await this.authService.refreshTokenOrLogout()) {
                        sessionStorage.setItem('APP-INIT-REPAIR-PERMISSION-MANAGER-ATTEMPTED', '1');
                        return;
                    }
                    await this.initAndHandleErrors(oAuthService, false);
                    return;
                }
            }
            await this.errorService.handleException(e, 'PermissionService', '1');
            sessionStorage.removeItem('APP-INIT-REPAIR-PERMISSION-MANAGER-ATTEMPTED');
            return;
        }
        sessionStorage.removeItem('APP-INIT-REPAIR-PERMISSION-MANAGER-ATTEMPTED');
        return true;
    }
    async init(force = false) {
        if (this.initialized && !force) {
            return;
        }
        if (!this.permissionManagerConfig.usePlac &&
            !this.permissionManagerConfig.fetchPermissionsFunction) {
            throw new Error('When usePlac is not set fetchPermissionsFunction is required.');
        }
        if (this.permissionManagerConfig.usePlac &&
            (!this.permissionManagerConfig.placUrl ||
                (!this.permissionManagerConfig.placApplicationId &&
                    !this.permissionManagerConfig.placApplicationName))) {
            throw new Error('When usePlac is set both placUrl and (placApplicationId or placApplicationName) are required.');
        }
        this.permissionManager = new PermissionManager(this.permissionManagerConfig.usePlac
            ? PermissionManager.getPlacFetchFunction(this.permissionManagerConfig.placUrl, {
                id: this.permissionManagerConfig.placApplicationId,
                name: this.permissionManagerConfig.placApplicationName
            }, (url) => firstValueFrom(this.http.get(url)))
            : this.permissionManagerConfig.fetchPermissionsFunction, this.permissionManagerConfig.ttl, this.permissionManagerConfig.dbEngineName, this.permissionManagerConfig.setSubjectNameToDbModelMapFunction, this.permissionManagerConfig.dynamicResolversGetter, this.permissionManagerConfig.missingIncludesHydraterGetter, this.permissionManagerConfig.placApplicationName);
        await this.permissionManager.init();
        isDevMode() && localStorage.setItem('debug', '*');
        this.initialized = true;
    }
    async validatePermissionAwareItem(item) {
        let hasPermission = true;
        if (item.permissionOrEntity && item.permissionAction) {
            if (Array.isArray(item.permissionOrEntity)) {
                hasPermission = (await Promise.all(item.permissionOrEntity
                    .filter((e) => !!e)
                    .map(async (s) => await this.hasPermission(s, item.permissionAction, item.permissionField, item.permissionSubjectName, item.permissionEntityModel)))).reduce((p, c) => p && c, true);
            }
            else {
                hasPermission = await this.hasPermission(item.permissionOrEntity, item.permissionAction, item.permissionField, item.permissionSubjectName, item.permissionEntityModel);
            }
        }
        return hasPermission;
    }
    async hasPermission(entityOrSubject, action, field, subjectName, modelName) {
        if (!this.permissionManager) {
            return false;
        }
        if (typeof entityOrSubject === 'string') {
            return await this.permissionManager.hasPermission(entityOrSubject, action, field);
        }
        let subjects = subjectName ? [subjectName] : undefined;
        if (!subjects) {
            const modelNameCalculated = modelName || entityOrSubject.typeName;
            if (!modelNameCalculated) {
                throw new Error('Either entityOrSubject have to have typeName property holding entities modelName or subjectName or modelName have to be provided.');
            }
            subjects =
                this.permissionManager.getSubjectNamesForModel(modelNameCalculated);
            if (subjects === undefined) {
                throw new Error(`Cannot find subject name for model '${modelNameCalculated}'. Please make sure that it is included in subjectNamesToModel mappings.`);
            }
        }
        for (const subjectsKey in subjects) {
            if (await this.permissionManager.hasPermission(subject(subjects[subjectsKey], _.assign({}, entityOrSubject)), action, field)) {
                return true;
            }
        }
        // Make sure that defaultInclude has all the resource properties from CASL rules included. If some of them are missing
        // this will be returned as no rule can be matched.
        return false;
    }
    destroy() {
        this.permissionManager = undefined;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissionsService, deps: [{ token: PermissionManagerConfig }, { token: i2.HttpClient }, { token: AuthenticationService }, { token: i3$1.ErrorsService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissionsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PermissionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: PermissionManagerConfig }, { type: i2.HttpClient }, { type: AuthenticationService }, { type: i3$1.ErrorsService, decorators: [{
                    type: Optional
                }] }]; } });

class KendoNotificationService extends BaseNotificationService {
    kendoNotificationService;
    defaultSettings = {
        animation: { type: 'slide', duration: 100 },
        position: { horizontal: 'center', vertical: 'top' }
    };
    constructor(kendoNotificationService) {
        super();
        this.kendoNotificationService = kendoNotificationService;
    }
    show(content, type, settings = this.defaultSettings, container) {
        return this.kendoNotificationService.show({
            ..._.merge({ appendTo: container }, settings),
            content,
            type: { style: type }
        });
    }
    showSuccess(content, settings = this.defaultSettings, container) {
        return this.show(content, 'success', settings, container);
    }
    showInfo(content, settings = this.defaultSettings, container) {
        return this.show(content, 'info', settings, container);
    }
    showWarning(content, settings = this.defaultSettings, container) {
        return this.show(content, 'warning', settings, container);
    }
    showError(content, settings = this.defaultSettings, container) {
        return this.show(content, 'error', settings, container);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KendoNotificationService, deps: [{ token: i1$2.NotificationService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KendoNotificationService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: KendoNotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NotificationService }]; } });

/**
 * Caches all(almost) items that are returned from api in cache property.
 *
 * If state property of the request contains 'groupBy', 'expand' or 'select' items WILL NOT be cached.
 *
 */
class BaseCacheableApiService extends BaseApiService {
    mainPropertyName;
    /**
     * stores url of all cached results.
     * @protected
     */
    cachedRequests = new Map();
    cache;
    /**
     * if set to true that means the getAll was called and it either:
     *      returned all data without pagination
     *      it was called from getAllRecursive (getting all server data for entity)
     * @protected
     */
    loadedAllRecords;
    pendingRequests = new Map();
    constructor(apiEndpoint, http, environmentService, keysToGenerate, mainPropertyName = 'id', userService) {
        super(apiEndpoint, http, environmentService, userService);
        this.mainPropertyName = mainPropertyName;
        this.cache = new MultiPropertyCache(keysToGenerate, mainPropertyName);
    }
    get(id) {
        return super.get(id).pipe(tap((u) => this.cache.addToCache(u)));
    }
    clearCache() {
        this.cachedRequests.clear();
        this.cache.clear();
        this.loadedAllRecords = false;
    }
    /**
     * If {@link loadedAllRecords} is set then returns all cached items
     * If {@link loadedAllRecords} is NOT set then will call getAllRecursive method with empty state (not filters)
     *      and then will apply state on the result.
     *
     * @param state - state to be applied to cached items.
     *                  It cannot contain any select or expand properties.
     * @param forceRefresh - if set to true the getAllRecursive method will be called.
     */
    getAllRecursiveCached(state, forceRefresh = false) {
        let result;
        if (this.loadedAllRecords && !forceRefresh) {
            result = this.cache.getAll();
        }
        else {
            result = fromPromise(this.getAllRecursive());
        }
        return result.pipe(map((d) => {
            const r = process(d, state || {});
            return { data: r.data, count: r.total };
        }));
    }
    /**
     * If {@link loadedAllRecords} is set then returns from cached items (applying state on top of it)
     * If {@link loadedAllRecords} is NOT set then will check if given state was resolved already
     *    if it was then return from cached items (applying state)
     *    if it wasn't then execute request and add to cache
     *
     * @param state - state to be applied to cached items.
     *                  It cannot contain any select or expand properties.
     * @param forceRefresh - if set to true the getAllRecursive method will be called.
     */
    getAllCached(state, forceRefresh = false) {
        const url = this.getAllInternalUrl(undefined, state);
        const cachedRequest = this.cachedRequests.get(url);
        if ((!this.loadedAllRecords && !cachedRequest) || forceRefresh) {
            return this.getAllPaginated(state);
        }
        return this.cache.getAll().pipe(map((d) => {
            const r = process(d, state || {});
            return {
                data: r.data,
                count: cachedRequest?.total || r.total,
                sourceUrl: url
            };
        }));
    }
    getCached(ids, cachePropertyName = 'id') {
        const key = ids.join() + cachePropertyName;
        const pending = this.pendingRequests.get(key);
        if (pending) {
            return pending;
        }
        const ignoreCase = this.cache.isKeyCaseSensitive(cachePropertyName) ? undefined : true;
        const obs$ = this.cache.getCached(ids, cachePropertyName, (missingKeys, existing, propertyName) => this.getAll({
            filter: {
                filters: missingKeys.map((k) => ({
                    field: propertyName,
                    operator: 'eq',
                    value: k,
                    ignoreCase
                })),
                logic: 'or'
            }
        })
            .pipe(map((n) => n.concat(existing)), shareReplay({ bufferSize: 1, refCount: true }), tap(r => {
            this.pendingRequests.delete(key);
        })));
        this.pendingRequests.set(key, obs$);
        return obs$;
    }
    async getAllRecursive(state) {
        const u = await super.getAllRecursive(state);
        this.loadedAllRecords = !state?.filter || state.filter.filters.length === 0;
        return u;
    }
    getAllInternal(urlBuilder, state) {
        if ((state?.group && state?.group.length > 0) ||
            (state?.select && state?.select !== '') ||
            (state?.expand && state?.expand !== '')) {
            return super.getAllInternal(urlBuilder, state);
        }
        return super.getAllInternal(urlBuilder, state).pipe(tap((u) => {
            if (u.sourceUrl) {
                this.cachedRequests.set(u.sourceUrl, { total: u.count });
            }
            this.cache.addMultipleToCache(u.data);
            this.loadedAllRecords =
                this.loadedAllRecords ||
                    (u.data?.length === u.count &&
                        (!state?.filter || state.filter.filters.length === 0));
        }));
    }
}

class BaseAuditableCacheableApiService extends BaseCacheableApiService {
    constructor(apiEndpoint, http, environmentService, keysToGenerate, mainPropertyName = 'id', userService) {
        super(apiEndpoint, http, environmentService, keysToGenerate, mainPropertyName, userService);
    }
    getHistory(id) {
        return BaseAuditableApiService.getHistory(this.http, this.environmentService, this.apiEndpoint, id);
    }
}

/**
 * Base implementation of a service connecting to pl-api-nest permissions controller.
 */
class BaseApiPermissionsService {
    http;
    environmentService;
    constructor(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    getSubjectToEntityTypeMap() {
        return this.http.get(this.environmentService.buildApiUrl(`permissions/subjectToEntityMap`));
    }
    getDynamicResolverValue(resolverName, parameters) {
        return this.http
            .get(this.environmentService.buildApiUrl(`permissions/dynamicResolverValue/${resolverName}${parameters ? '/' + parameters : ''}`), {
            observe: 'response',
            responseType: 'text'
        })
            .pipe(map((res) => {
            //To handle both JSON and string response types from the dynamicResolvers, we need to try to parse it first.
            //if the parsing fails, the plaintext string is returned.
            try {
                return res.body && JSON.parse(res.body);
            }
            catch (e) {
                return res.body;
            }
        }));
    }
    /**
     * Will call permissions/hydrate endpoint on pl-api-nest permissions controller.
     *
     * Can be overridden in application to handle custom hydration mechanisms in angular.
     * @param args
     */
    hydrate(args) {
        const body = { ...args };
        console.log('Hydration called for following args. Api will be called to resolve.', body);
        delete body.permissionManager;
        return this.http.post(this.environmentService.buildApiUrl(`permissions/hydrate`), body);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseApiPermissionsService, deps: [{ token: i2.HttpClient }, { token: BaseEnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseApiPermissionsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseApiPermissionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.HttpClient }, { type: BaseEnvironmentService }]; } });

let appInjectorRef;
const appInjector = (injector) => {
    if (injector) {
        appInjectorRef = injector;
    }
    if (!appInjectorRef) {
        throw new Error('AppInjector called but it was not initialised. Please call appInjector(injector) in you app.initializer first.');
    }
    return appInjectorRef;
};

class TemplateLibraryService {
    templates = {};
    constructor() { }
    add(context, templates, overrideExisting) {
        templates.forEach((t) => {
            t.keys.forEach((key) => {
                this.templates[context] = this.templates[context] || {};
                if (this.templates[context][key] && !overrideExisting) {
                    throw new Error(`Template with key ${key} already exists in context ${context}`);
                }
                this.templates[context][key] = t.template;
            });
        });
    }
    get(context, key) {
        if (!this.templates[context]) {
            throw new Error(`Context ${context} has not been created yet.`);
        }
        return this.templates[context][key];
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplateLibraryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplateLibraryService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplateLibraryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AppTitleService {
    title;
    router;
    applicationName;
    isInitialised = false;
    constructor(title, router) {
        this.title = title;
        this.router = router;
        // This is just a temporary solution to set a static title from route data
        // TODO: once we upgrade to angular 14, we can set directly the title from the route as described here:
        //  https://dev.to/brandontroberts/setting-page-titles-natively-with-the-angular-router-393j
        router.events
            .pipe(filter((event) => event instanceof NavigationEnd), map(() => {
            let route = this.router.routerState.root;
            let routeTitle = '';
            while (route.firstChild) {
                route = route.firstChild;
            }
            if (route.snapshot.data['title']) {
                routeTitle = route.snapshot.data['title'];
            }
            return routeTitle;
        }))
            .subscribe((title) => {
            if (title) {
                this.setPageTitle(title);
            }
        });
    }
    init(applicationName) {
        // If the application name is not provided, then we get the title from index.html
        this.applicationName = applicationName || this.title.getTitle();
        this.title.setTitle(this.applicationName);
        this.isInitialised = true;
    }
    setPageTitle(title) {
        if (this.isInitialised) {
            this.title.setTitle(`${this.applicationName} | ${title}`);
        }
        else {
            console.warn('AppTitleService has not been initialized. Make sure to first call the init() method. Guidance for this can be found in the release/0.4.0-breaking.md file.');
        }
    }
}

/**
 * Extends BaseCacheableApiService
 * contains special resolveAuthors function that recursively fetches an array of users
 */
class BaseUserCacheableApiService extends BaseCacheableApiService {
    currentUserApiEndpoint;
    currentAppUser;
    isLoaded = false;
    currentUserObservable;
    requestedUserIds = new Set();
    constructor(apiEndpoint, http, environmentService, currentUserApiEndpoint, keysToGenerate, mainPropertyName = 'id') {
        super(apiEndpoint, http, environmentService, keysToGenerate, mainPropertyName);
        this.currentUserApiEndpoint = currentUserApiEndpoint;
        this.cache = new MultiPropertyCache(keysToGenerate, mainPropertyName);
    }
    getCurrentUser(refresh = false) {
        if (this.currentUserObservable && !refresh) {
            return this.currentUserObservable;
        }
        return (this.currentUserObservable =
            refresh || !this.currentUserObservable
                ? this.http
                    .get(this.environmentService.buildApiUrl(this.currentUserApiEndpoint), (this.httpOptions['getCurrentUser'] || this.httpOptions['get'] || this.httpOptions['all']))
                    .pipe(shareReplay(), tap((user) => {
                    this.setAppUser(user);
                }))
                : this.currentUserObservable);
    }
    resolveAuthors(idsOfRequiredUsers) {
        // Filter out IDs that have already been requested
        const newIds = idsOfRequiredUsers.filter((id) => !this.requestedUserIds.has(id));
        // Mark the new IDs as requested
        newIds.forEach((id) => this.requestedUserIds.add(id));
        // Fetch the user data for the new IDs
        return this.getCached(newIds).pipe(mergeMap((users) => {
            // Extract additional user IDs from the fetched users
            const additionalUserIds = users
                .flatMap((user) => user.id || [])
                .filter((id) => !this.requestedUserIds.has(id));
            // If there are additional user IDs to fetch, fetch them recursively
            if (additionalUserIds.length > 0) {
                return this.resolveAuthors(additionalUserIds).pipe(map((additionalUsers) => [...users, ...additionalUsers]));
            }
            // Otherwise, return the fetched users
            this.requestedUserIds.clear(); // Clear the set just before returning the final result
            return of(users);
        }));
    }
    setAppUser(c) {
        this.currentAppUser = c;
        this.isLoaded = true;
    }
}

class BaseUserAuditableCacheableApiService extends BaseUserCacheableApiService {
    getHistory(id) {
        return BaseAuditableApiService.getHistory(this.http, this.environmentService, this.apiEndpoint, id);
    }
}

class CodeDiffService {
    constructor() { }
    getDiff(text1, text2, filename = '') {
        const dmp = new diff_match_patch();
        const chars = dmp.diff_linesToChars_(text1, text2);
        const lineText1 = chars.chars1;
        const lineText2 = chars.chars2;
        const lineArray = chars.lineArray;
        const diffs = dmp.diff_main(lineText1, lineText2, false);
        dmp.diff_charsToLines_(diffs, lineArray);
        const patchMake = dmp.patch_make(text1, diffs);
        const patchToText = dmp.patch_toText(patchMake);
        // Make it look more like a unified diff style
        let lines = patchToText.split('\n');
        lines.forEach((line, index) => {
            if (line.startsWith('-')) {
                lines[index] = line.replace(/%0A(.)/g, '%0A-$1');
            }
            else if (line.startsWith('+')) {
                lines[index] = line.replace(/%0A(.)/g, '%0A+$1');
            }
        });
        const unifiedDiff = lines.join('\n');
        const strInput = '--- ' + filename + ' \n+++ ' + filename + ' \n' + unifiedDiff;
        return decodeURIComponent(strInput);
    }
    diffToHTML(diff, format = 'side-by-side', style = 'word') {
        return Diff2Html.html(diff, {
            drawFileList: false,
            matching: 'lines',
            outputFormat: format,
            diffStyle: style
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CodeDiffService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CodeDiffService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CodeDiffService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/**
 * EntityMetadataService
 *
 * Service that stores and provides metadata about entities.
 *
 * @ Registering entities:
 *      In order to register entity the {@link registerEntity} method should be called on entities module initialisation.
 *      It can be done by implementing constructor for module like:
 *            constructor(metadataService:EntityMetadataService) {
 *                 metadataService.registerEntity({modelName: 'QuestionFramework', routePath:'question-frameworks' ,detailComponentType: QuestionFrameworkDetailComponent});
 *            }
 *      BE AWARE that this constructor will only be called when the module is loaded. If application uses lazy loaded modules
 *      developer has to make sure that all required features modules are loaded before the use of this service. Mode details on how to preload module in section 'Module Preloading'
 *
 *  @ Module Preloading
 *      Registering of the entity will usually happen in the entity feature module. This means entity will only be registered if module itself is loaded.
 *      In our applications we use laze loaded modules. That means it can happen that entity will not be registered before EntityMetadataService is asked to provide it's metadata.
 *      It's in app developer responsibility to make sure that EntityMetadataService has all required entities registered before use.
 *      This can be achieved by preloading all or required modules. Angular gives as this ability with use of 'preloadingStrategy' option while registering routes:
 *
 *           @NgModule({
 *             imports: [RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules })],
 *             exports: [RouterModule],
 *             providers:[AppCustomPreloader]
 *             })
 *             export class AppRoutingModule {}
 *      In example above we've used 'PreloadAllModules' strategy supplied by Angular. This is fine for small apps but might be overkill in some cases.
 *      A nicer solution would be to use custom Preloader in place of 'PreloadAllModules'. This will allow to choose which modules/routes to preload.
 *      Example from AuditCore application:
 *
 *      export class AppCustomPreloader implements PreloadingStrategy {
 *          preload(route: Route, load: Function): Observable<any> {
 *            const modulesConfig = dynamicModulesConfigs[config.authConfig.clientId];
 *            const defaultConfig = dynamicModulesConfigs['default'];
 *            const modulesToLoad = (!modulesConfig || modulesConfig.includeDefault ? defaultConfig.modulesToPreload: []).concat(modulesConfig?.modulesToPreload || []);
 *            const shouldPreload = route.data && route.data["preload"] || modulesToLoad.indexOf(route.path)>=0;
 *            if (shouldPreload) {
 *              console.log('Preloading route: ', route);
 *              return load();
 *            }
 *            return of(null);
 *          }
 *      }
 *
 */
class EntityMetadataService {
    /**
     * stores metadata configs for each model/entity by its model name e.g. User, Organisation
     * @private
     */
    metadataSetByModelName = new Map;
    /**
     * stores metadata configs for each model/entity by route path in application e.g. users, organisations, user-groups
     * @private
     */
    metadataSetByRoutePath = new Map;
    /**
     * Registers metadata for entity.
     * Should be called once from the feature module. For more details please check documentation for EntityMetadataService 'Registering entities' section
     * @param metadata
     */
    registerEntity(metadata) {
        if (!metadata.modelName) {
            throw new Error('Model name is required in entity metadata');
        }
        this.metadataSetByModelName.set(metadata.modelName, metadata);
        if (metadata.routePath) {
            this.metadataSetByRoutePath.set(metadata.routePath, metadata);
        }
    }
    /**
     * Gets metadata for entity based on entities modelName.
     * Throws exception if entity with modelName doesn't exist.
     * Possible reasons for exception:
     *              - entity with model doesn't exist (maybe a typo in modelName)
     *              - the registerEntity method has not been called (usually called when the feature module is loaded -  check documentation for EntityMetadataService 'Registering entities' section)
     *              - the feature module in the application has not been loaded yet - in that case feature module should be preloaded, check documentation for EntityMetadataService 'Module Preloading' section
     */
    getEntityMetadataByModelName(modelName) {
        const result = this.metadataSetByModelName.get(modelName);
        if (!result) {
            throw new Error(`Entity with model name ${modelName} has not been registered. It either:
             - doesn't exists
             - the registerEntity method has not been called (usually called when the feature module is loaded -  check documentation for EntityMetadataService 'Registering entities' section)
             - the feature module in the application has not been loaded yet - in that case feature module should be preloaded, check documentation for EntityMetadataService 'Module Preloading' section
             `);
        }
        return result;
    }
    /**
     * Gets metadata for entity based on entities routePath used in application.
     * Throws exception if entity with routePath doesn't exist.
     * Possible reasons for exception:
     *              - entity with routePath doesn't exist (maybe a typo in routePath)
     *              - the provided metadata object didn't contain routePath
     *              - the registerEntity method has not been called (usually called when the feature module is loaded -  check documentation for EntityMetadataService 'Registering entities' section)
     *              - the feature module in the application has not been loaded yet - in that case feature module should be preloaded, check documentation for EntityMetadataService 'Module Preloading' section
     */
    getEntityMetadataByRoutePath(routePath) {
        const result = this.metadataSetByRoutePath.get(routePath);
        if (!result) {
            throw new Error(`Entity with route path ${routePath} has not been registered. It either:
             - doesn't exists
             - the provided metadata object didn't contain routePath
             - the registerEntity method has not been called (usually called when the feature module is loaded - check documentation for registerEntity method)
             - the feature module in the application has not been loaded yet - in that case feature module should be preloaded, check documentation for EntityMetadataService 'Module Preloading' section
             `);
        }
        return result;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EntityMetadataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EntityMetadataService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EntityMetadataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class EntityMetadata {
    static DETAIL_COMPONENT_TYPE_NAME = 'defaultEntityDetails';
    static DROPDOWN_COMPONENT_TYPE_NAME = 'dropdownComponent';
    static MULTISELECT_DROPDOWN_COMPONENT_TYPE_NAME = 'multiselectComponent';
    static DEFAULT_DROPDOWN_CONFIGURATOR_TYPE_NAME = 'defaultDropdownConfigurator';
    modelName;
    routePath;
    components = {};
    configurators = {};
    apiServiceType;
    displayDataResolverType;
    apiService;
    displayDataResolver;
    constructor(options) {
        this.modelName = options.modelName;
        this.routePath = options.routePath;
        this.components = options.components || {};
        this.configurators = options.configurators || {};
        this.apiServiceType = options.apiServiceType;
        this.displayDataResolverType = options.displayDataResolverType;
        this.defaultDropdownConfigurator = options.defaultDropdownConfigurator;
        this.detailComponentType = options.detailComponentType;
        this.dropdownComponentType = options.dropdownComponentType;
        this.multiselectDropdownComponentType = options.multiselectDropdownComponentType;
    }
    get defaultDropdownConfigurator() {
        return this.configurators[EntityMetadata.DEFAULT_DROPDOWN_CONFIGURATOR_TYPE_NAME];
    }
    ;
    set defaultDropdownConfigurator(value) {
        this.configurators[EntityMetadata.DEFAULT_DROPDOWN_CONFIGURATOR_TYPE_NAME] = value;
    }
    get dropdownComponentType() {
        return this.components[EntityMetadata.DROPDOWN_COMPONENT_TYPE_NAME];
    }
    ;
    set dropdownComponentType(value) {
        this.components[EntityMetadata.DROPDOWN_COMPONENT_TYPE_NAME] = value;
    }
    get multiselectDropdownComponentType() {
        return this.components[EntityMetadata.MULTISELECT_DROPDOWN_COMPONENT_TYPE_NAME];
    }
    ;
    set multiselectDropdownComponentType(value) {
        this.components[EntityMetadata.MULTISELECT_DROPDOWN_COMPONENT_TYPE_NAME] = value;
    }
    get detailComponentType() {
        return this.components[EntityMetadata.DETAIL_COMPONENT_TYPE_NAME];
    }
    ;
    set detailComponentType(value) {
        this.components[EntityMetadata.DETAIL_COMPONENT_TYPE_NAME] = value;
    }
    resolveApiService() {
        this.apiService = this.apiService || appInjector().get(this.apiServiceType);
        return this.apiService;
    }
    resolveDisplayDataResolverType() {
        this.displayDataResolver = this.displayDataResolver || appInjector().get(this.displayDataResolverType);
        return this.displayDataResolver;
    }
}

class PlIconComponent {
    type = 'kendo';
    icon = 'k-i-help';
    size = '16px';
    color = 'unset';
    src;
    constructor() { }
    ngOnInit() {
        this.resolveIconAndType();
    }
    ngOnChanges(changes) {
        if (changes['icon'] && !changes['icon'].firstChange) {
            this.icon = changes['icon'].currentValue;
            this.resolveIconAndType();
        }
    }
    resolveIconAndType() {
        this.type = this.iconType(this.icon);
        if (this.icon.startsWith('m-o-')) {
            this.icon = this.icon.replace('m-o-', '');
        }
    }
    iconType(icon) {
        return icon.startsWith('k-i-')
            ? 'kendo'
            : icon === 'image'
                ? 'image'
                : icon.startsWith('m-o-')
                    ? 'material-outline'
                    : 'material';
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlIconComponent, selector: "pl-icon", inputs: { type: "type", icon: "icon", size: "size", color: "color", src: "src" }, usesOnChanges: true, ngImport: i0, template: "<span *ngIf=\"type == 'kendo'\" class=\"k-icon {{icon}}\" [style.font-size]=\"size\" [style.color]=\"color\"></span>\n<span *ngIf=\"type == 'material'\" class=\"material-icons\" [style.font-size]=\"size\" [style.color]=\"color\">{{icon}}</span>\n<span *ngIf=\"type == 'material-outline'\" class=\"material-symbols-outlined\" [style.font-size]=\"size\" [style.color]=\"color\">{{icon}}</span>\n<img *ngIf=\"type == 'image'\" [src]=\"src\" [style.width]=\"size\" />\n", styles: [":host{flex:none;display:inline-flex;align-items:center;font-style:normal;line-height:0;text-align:center;text-transform:none;text-rendering:optimizeLegibility}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-icon', template: "<span *ngIf=\"type == 'kendo'\" class=\"k-icon {{icon}}\" [style.font-size]=\"size\" [style.color]=\"color\"></span>\n<span *ngIf=\"type == 'material'\" class=\"material-icons\" [style.font-size]=\"size\" [style.color]=\"color\">{{icon}}</span>\n<span *ngIf=\"type == 'material-outline'\" class=\"material-symbols-outlined\" [style.font-size]=\"size\" [style.color]=\"color\">{{icon}}</span>\n<img *ngIf=\"type == 'image'\" [src]=\"src\" [style.width]=\"size\" />\n", styles: [":host{flex:none;display:inline-flex;align-items:center;font-style:normal;line-height:0;text-align:center;text-transform:none;text-rendering:optimizeLegibility}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { type: [{
                type: Input
            }], icon: [{
                type: Input
            }], size: [{
                type: Input
            }], color: [{
                type: Input
            }], src: [{
                type: Input
            }] } });

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["SaveSuccess"] = 0] = "SaveSuccess";
    NotificationType[NotificationType["SaveError"] = 1] = "SaveError";
    NotificationType[NotificationType["DeleteSuccess"] = 2] = "DeleteSuccess";
    NotificationType[NotificationType["DeleteError"] = 3] = "DeleteError";
})(NotificationType || (NotificationType = {}));
class BaseDetailComponent {
    service;
    route;
    router;
    translateService;
    displayDataResolver;
    notificationService;
    formBuilder;
    permissionsService;
    dialogService;
    appTitleService;
    allowDelete;
    subscribeToRouteData;
    entityType;
    hasHistoryPermission;
    redirectOnNewUrl;
    saveAction = {
        text: 'Save',
        themeColor: 'primary',
        icon: 'save',
        onClick: () => this.save(),
        preventMultipeClicks: true,
    };
    cancelAction = {
        text: 'Cancel',
        onClick: () => this.handleCancel()
    };
    deleteAction = {
        text: 'Delete',
        icon: 'delete',
        onClick: () => this.delete()
    };
    actions = [this.saveAction];
    isNew = false;
    isEntityDetailsRouteHandler = false;
    /// a way to notify all child components of change to entity.
    /// useful for example when related links are added and history has to refresh
    /// by default emitted on save
    entityChanged$ = new Subject();
    savingInProgress$ = new BehaviorSubject(false);
    deletingInProgress$ = new BehaviorSubject(false);
    notificationsContainer;
    saving = new EventEmitter();
    saved = new EventEmitter();
    deleted = new EventEmitter();
    cancel = new EventEmitter();
    destroyed$ = new Subject();
    generatedTitle;
    constructor(service, route, router, translateService, displayDataResolver, notificationService, formBuilder, permissionsService, dialogService, appTitleService, allowDelete, subscribeToRouteData = true) {
        this.service = service;
        this.route = route;
        this.router = router;
        this.translateService = translateService;
        this.displayDataResolver = displayDataResolver;
        this.notificationService = notificationService;
        this.formBuilder = formBuilder;
        this.permissionsService = permissionsService;
        this.dialogService = dialogService;
        this.appTitleService = appTitleService;
        this.allowDelete = allowDelete;
        this.subscribeToRouteData = subscribeToRouteData;
        this.entityType =
            displayDataResolver?.typeName || displayDataResolver?.typeDisplayName;
        if (subscribeToRouteData) {
            this.route.data.subscribe((data) => {
                const routeData = data['entityDetailsRouteData'];
                if (routeData && routeData.entityDetailsRoute) {
                    if (this.entityType?.toLocaleLowerCase() !==
                        routeData.entityType?.toLocaleLowerCase()) {
                        const message = `DisplayDataResolver type name doesn't not match routeData entity type. Got : ${this.entityType?.toLocaleLowerCase()} and ${routeData.entityType?.toLocaleLowerCase()}`;
                        notificationService.showError(message, undefined, this.notificationsContainer);
                        return;
                    }
                    if (routeData.entity === undefined) {
                        throw new Error("Route data doesn't contain property name 'entity'. Make sure that resolvers in routing.module are setting entity property.");
                    }
                    this.validateRouteData(routeData, data);
                    this.isEntityDetailsRouteHandler = true;
                    this.entity = routeData.entity;
                }
            });
        }
    }
    _entity;
    get entity() {
        return this._entity;
    }
    set entity(value) {
        this._entity = value;
        this.entityType = this._entity?.typeName || this.entityType;
        this.init();
    }
    _form;
    get form() {
        return this._form;
    }
    set form(value) {
        this._form = value;
    }
    _title;
    get title() {
        return this._title || this.generatedTitle;
    }
    set title(value) {
        this._title = value;
    }
    get hasChanges() {
        return this.form.dirty;
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
    handleCancel() {
        this.cancel.emit();
    }
    checkOtherValidations() {
        return true;
    }
    notificationSettings(notificationType) {
        return undefined;
    }
    saveErrorMessage(error) {
        return error.error?.message || error.message;
    }
    deleteErrorMessage(e) {
        return e.error?.message || e.message;
    }
    saveSuccessMessage() {
        return `${this.displayDataResolver.getTitle(this.entity)} saved successfully`;
    }
    deleteSuccessMessage() {
        return `${this.displayDataResolver.getShortTitle(this.entity)} deleted successfully`;
    }
    save() {
        this.form.markAllAsTouched();
        if (this.checkOtherValidations() && this.form.valid) {
            const files = this.mapFiles();
            const dto = this.isNew
                ? this.mapFormToCreateDto()
                : this.mapFormToUpdateDto();
            let result = (isObservable(dto)
                ? dto.pipe(switchMap((dto) => this.getSaveObservable(dto, files)))
                : this.getSaveObservable(dto, files)).pipe(catchError((error) => {
                this.showErrorNotification(this.saveErrorMessage(error), this.notificationSettings(NotificationType.SaveError), this.notificationsContainer);
                this.updateSaveActionIcon(false);
                this.savingInProgress$.next(false);
                return throwError(() => error);
            }));
            result = this.changeSaveObservable(result).pipe(shareReplay({ refCount: true }));
            this.saving.emit(this.entity || undefined);
            this.updateSaveActionIcon(true);
            this.savingInProgress$.next(true);
            result.subscribe((entity) => {
                this.handleRedirect();
                this.entity = entity;
                this.showSuccessNotification(this.saveSuccessMessage(), this.notificationSettings(NotificationType.SaveSuccess), this.notificationsContainer);
                this.saved.emit(this.entity);
                this.entityChanged$.next();
                this.updateSaveActionIcon(false);
                this.savingInProgress$.next(false);
            });
            return result;
        }
        return null;
    }
    delete() {
        // TODO: replace with dialogService.showDeleteModal
        this.dialogService
            .open({
            title: 'Confirm deletion',
            content: `Are you sure you want to delete ${this.displayDataResolver.getShortTitle(this.entity)}?`,
            actions: [{ text: 'Cancel' }, { text: 'Delete', themeColor: 'error' }]
        })
            .result.subscribe((e) => {
            if (e.text === 'Delete') {
                this.deletingInProgress$.next(true);
                this.service.delete(this.entity.id).subscribe({
                    next: () => {
                        this.showSuccessNotification(this.deleteSuccessMessage(), this.notificationSettings(NotificationType.DeleteSuccess), this.notificationsContainer);
                        this.deleted.emit(this.entity);
                        this.entityChanged$.next();
                        this.router.navigate([this.redirectOnNewUrl]);
                    },
                    error: (e) => {
                        this.showErrorNotification(this.deleteErrorMessage(e), this.notificationSettings(NotificationType.DeleteError), this.notificationsContainer);
                    },
                    complete: () => {
                        this.deletingInProgress$.next(false);
                    }
                });
            }
        });
    }
    showErrorNotification(errorMessage, settings, container) {
        this.notificationService.showError(errorMessage, settings, container || this.notificationsContainer);
    }
    showSuccessNotification(successMessage, settings, container) {
        this.notificationService.showSuccess(successMessage, settings, container || this.notificationsContainer);
    }
    initIsNew() {
        this.isNew = !this.entity || !this.entity.id;
    }
    initTitle() {
        this.generatedTitle = !this.isNew
            ? this.displayDataResolver.getTitle(this.entity)
            : 'Create new ' + this.displayDataResolver.typeDisplayName;
    }
    init() {
        this.initIsNew();
        this.initTitle();
        this.initDependencies();
        this.form = this.initForm();
        this.setListeners();
        if (isDevMode() && this.form === undefined) {
            throw new Error(`Form is not initialized in initForm method. Please override initForm method in your component ${this.constructor.name}`);
        }
        this.form.get('metadata')?.disable();
        this.secureForWrite();
        this.secureForDelete();
        this.permissionsService
            .hasPermission('SafeguardingPlatform.Audit.History', 'Read')
            .then((e) => {
            this.hasHistoryPermission = e;
        });
        if (this.isEntityDetailsRouteHandler) {
            this.appTitleService.setPageTitle(this.title);
        }
    }
    setListeners() { }
    changeSaveObservable(result) {
        return result;
    }
    handleRedirect(urlOverride) {
        if (!this.isEntityDetailsRouteHandler && !urlOverride) {
            return;
        }
        if (urlOverride) {
            this.router.navigate([urlOverride]);
        }
        else if (this.isNew && this.redirectOnNewUrl) {
            this.router.navigate([this.redirectOnNewUrl]);
        }
    }
    /// Returns true when user has write access
    async secureForWrite() {
        if (this.entity &&
            !this.isNew &&
            !(this.entity.typeName &&
                (await this.permissionsService.hasPermission(this.entity, 'Write')))) {
            this.actions = this.actions.filter((r) => r !== this.saveAction);
            this.form.disable();
            return false;
        }
        return true;
    }
    async secureForDelete() {
        if (this.entity &&
            this.entity.typeName &&
            !this.isNew &&
            this.allowDelete &&
            !this.actions.map((a) => a.text).includes('Delete') &&
            (await this.permissionsService.hasPermission(this.entity, 'Delete'))) {
            this.actions.unshift(this.deleteAction);
            return true;
        }
        return false;
    }
    validateRouteData(entityRouteData, data) { }
    mapFiles() {
        return undefined;
    }
    initDependencies() { }
    getSaveObservable(dto, files) {
        return this.isNew
            ? this.service.create(dto, files)
            : this.service.update(dto, files);
    }
    updateSaveActionIcon(loading) {
        this.saveAction.oldIcon =
            this.saveAction.oldIcon || this.saveAction.icon;
        this.saveAction.icon = loading
            ? 'loading'
            : this.saveAction.oldIcon;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseDetailComponent, deps: [{ token: 'EMPTY_SERVICE' }, { token: i1.ActivatedRoute }, { token: i1.Router }, { token: i2$1.TranslateService }, { token: 'EMPTY_SERVICE' }, { token: BaseNotificationService }, { token: i4.FormBuilder }, { token: PermissionsService }, { token: i5.DialogService }, { token: AppTitleService }, { token: false }, { token: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseDetailComponent, selector: "app-base-entity-detail", inputs: { entity: "entity" }, outputs: { saving: "saving", saved: "saved", deleted: "deleted", cancel: "cancel" }, viewQueries: [{ propertyName: "notificationsContainer", first: true, predicate: ["notificationsContainer"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: '<div>Base Details Component. Override template in your implementation!!!.</div>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-entity-detail',
                    template: '<div>Base Details Component. Override template in your implementation!!!.</div>'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['EMPTY_SERVICE']
                }] }, { type: i1.ActivatedRoute }, { type: i1.Router }, { type: i2$1.TranslateService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['EMPTY_SERVICE']
                }] }, { type: BaseNotificationService }, { type: i4.FormBuilder }, { type: PermissionsService }, { type: i5.DialogService }, { type: AppTitleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [false]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [true]
                }] }]; }, propDecorators: { notificationsContainer: [{
                type: ViewChild,
                args: ['notificationsContainer', {
                        read: ViewContainerRef,
                        static: false
                    }]
            }], saving: [{
                type: Output
            }], saved: [{
                type: Output
            }], deleted: [{
                type: Output
            }], cancel: [{
                type: Output
            }], entity: [{
                type: Input
            }] } });

class PlButtonComponent {
    themeColor = 'base';
    fillMode = 'outline';
    disabled = false;
    size = 'small';
    rounded = 'small';
    icon;
    title;
    ignoreBreakpoint = false;
    hoverMode = 'default';
    tooltip;
    ignoreMobileStyle = false;
    onClick = new EventEmitter();
    isMobile;
    onResize() {
        this.isMobile = !this.ignoreBreakpoint &&
            !!this.icon &&
            this.shouldHideContent();
        if (this.ignoreMobileStyle) {
            this.isMobile = false;
        }
    }
    shouldHideContent() {
        const hideConentWidthThreshold = 768; // button contents hidden below this width. Only icon will show
        return window.innerWidth < hideConentWidthThreshold;
    }
    ngOnInit() {
        this.onResize();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlButtonComponent, selector: "pl-button", inputs: { themeColor: "themeColor", fillMode: "fillMode", disabled: "disabled", size: "size", rounded: "rounded", icon: "icon", title: "title", ignoreBreakpoint: "ignoreBreakpoint", hoverMode: "hoverMode", tooltip: "tooltip", ignoreMobileStyle: "ignoreMobileStyle" }, outputs: { onClick: "onClick" }, host: { listeners: { "window:resize": "onResize()" } }, ngImport: i0, template: "<ng-container *ngIf=\"tooltip else button\">\n  <div kendoTooltip title=\"{{tooltip}}\">\n    <ng-container *ngTemplateOutlet=\"button\"></ng-container>\n  </div>\n</ng-container>\n<ng-template #button>\n  <button\n    kendoButton\n    [themeColor]=\"themeColor\"\n    [fillMode]=\"fillMode\"\n    [icon]=\"icon\"\n    title=\"{{title || ''}}\"\n    [disabled]=\"disabled\"\n    [rounded]=\"rounded\"\n    [size]=\"isMobile ? 'medium' : size\"\n    (click)=\"onClick.emit($event)\"\n    [ngClass]=\"{'gradient-hover': hoverMode === 'gradient'}\"\n  >\n    <ng-container *ngIf=\"!isMobile\">\n      <ng-content></ng-content>\n    </ng-container>\n  </button>\n\n</ng-template>", styles: [":host button.gradient-hover{z-index:1;overflow:hidden;position:relative;transition:.2s linear}:host button.gradient-hover:before{position:absolute;content:\"\";top:0;bottom:0;left:-100%;width:100%;background-image:var(--kendo-button-bg);z-index:-1;transition:.2s linear;opacity:0}:host button.gradient-hover:after{position:absolute;content:\"\";inset:0 -1px;background-image:linear-gradient(270deg,var(--kendo-button-bg) 25%,var(--kendo-button-hover-gradient-bg, #37003c) 100%);z-index:-1;transition:.2s linear;transition-delay:.2s;opacity:0}:host button.gradient-hover:hover{background:var(--kendo-button-bg);border-color:var(--kendo-button-bg)}:host button.gradient-hover:hover:before,:host button.gradient-hover:hover:after{opacity:1;left:0}div{height:100%}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$2.Button, selector: "button[kendoButton], span[kendoButton], kendo-button", inputs: ["toggleable", "togglable", "selected", "tabIndex", "imageUrl", "iconClass", "icon", "disabled", "size", "rounded", "fillMode", "themeColor", "svgIcon", "role", "primary", "look"], outputs: ["selectedChange", "click"], exportAs: ["kendoButton"] }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-button', template: "<ng-container *ngIf=\"tooltip else button\">\n  <div kendoTooltip title=\"{{tooltip}}\">\n    <ng-container *ngTemplateOutlet=\"button\"></ng-container>\n  </div>\n</ng-container>\n<ng-template #button>\n  <button\n    kendoButton\n    [themeColor]=\"themeColor\"\n    [fillMode]=\"fillMode\"\n    [icon]=\"icon\"\n    title=\"{{title || ''}}\"\n    [disabled]=\"disabled\"\n    [rounded]=\"rounded\"\n    [size]=\"isMobile ? 'medium' : size\"\n    (click)=\"onClick.emit($event)\"\n    [ngClass]=\"{'gradient-hover': hoverMode === 'gradient'}\"\n  >\n    <ng-container *ngIf=\"!isMobile\">\n      <ng-content></ng-content>\n    </ng-container>\n  </button>\n\n</ng-template>", styles: [":host button.gradient-hover{z-index:1;overflow:hidden;position:relative;transition:.2s linear}:host button.gradient-hover:before{position:absolute;content:\"\";top:0;bottom:0;left:-100%;width:100%;background-image:var(--kendo-button-bg);z-index:-1;transition:.2s linear;opacity:0}:host button.gradient-hover:after{position:absolute;content:\"\";inset:0 -1px;background-image:linear-gradient(270deg,var(--kendo-button-bg) 25%,var(--kendo-button-hover-gradient-bg, #37003c) 100%);z-index:-1;transition:.2s linear;transition-delay:.2s;opacity:0}:host button.gradient-hover:hover{background:var(--kendo-button-bg);border-color:var(--kendo-button-bg)}:host button.gradient-hover:hover:before,:host button.gradient-hover:hover:after{opacity:1;left:0}div{height:100%}\n"] }]
        }], propDecorators: { themeColor: [{
                type: Input
            }], fillMode: [{
                type: Input
            }], disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], rounded: [{
                type: Input
            }], icon: [{
                type: Input
            }], title: [{
                type: Input
            }], ignoreBreakpoint: [{
                type: Input
            }], hoverMode: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], ignoreMobileStyle: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', []]
            }] } });

class HasPermissionDirective {
    templateRef;
    viewContainer;
    permissionService;
    hasView = false;
    subject;
    action;
    filed;
    shouldDisable;
    shouldCheck = true;
    initialized;
    viewRef;
    modelName;
    subjectName;
    constructor(templateRef, viewContainer, permissionService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.permissionService = permissionService;
    }
    set hasPermissionShouldCheck(shouldCheck) {
        this.shouldCheck = shouldCheck === undefined ? true : shouldCheck;
        this.checkCondition();
    }
    set hasPermissionShouldDisable(shouldDisable) {
        this.shouldDisable = !!shouldDisable;
        this.checkCondition();
    }
    set hasPermissionSubjectName(filed) {
        this.subjectName = filed;
        this.checkCondition();
    }
    set hasPermissionModelName(filed) {
        this.modelName = filed;
        this.checkCondition();
    }
    set hasPermissionField(filed) {
        this.filed = filed;
        this.checkCondition();
    }
    set hasPermissionAction(action) {
        this.action = action;
        this.checkCondition();
    }
    set hasPermission(subject) {
        this.subject = subject;
        this.checkCondition();
    }
    async ngOnInit() {
        this.initialized = true;
        await this.checkCondition();
    }
    async checkCondition() {
        if (!this.initialized) {
            return;
        }
        let hasPermission = !this.shouldCheck;
        if (this.shouldCheck && this.subject && this.action) {
            hasPermission = await this.permissionService.validatePermissionAwareItem({
                permissionOrEntity: this.subject,
                permissionEntityModel: this.modelName,
                permissionAction: this.action,
                permissionField: this.filed,
                permissionSubjectName: this.subjectName,
                permissionShouldDisable: this.shouldDisable
            });
        }
        if (this.shouldDisable) {
            if (!this.hasView) {
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            }
            this.viewRef.rootNodes.forEach((n) => (n.disabled = !hasPermission));
        }
        else {
            if (hasPermission && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            }
            else if (!hasPermission && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HasPermissionDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: PermissionsService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: HasPermissionDirective, selector: "[hasPermission]", inputs: { hasPermissionShouldCheck: "hasPermissionShouldCheck", hasPermissionShouldDisable: "hasPermissionShouldDisable", hasPermissionSubjectName: "hasPermissionSubjectName", hasPermissionModelName: "hasPermissionModelName", hasPermissionField: "hasPermissionField", hasPermissionAction: "hasPermissionAction", hasPermission: "hasPermission" }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HasPermissionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hasPermission]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: PermissionsService }]; }, propDecorators: { hasPermissionShouldCheck: [{
                type: Input
            }], hasPermissionShouldDisable: [{
                type: Input
            }], hasPermissionSubjectName: [{
                type: Input
            }], hasPermissionModelName: [{
                type: Input
            }], hasPermissionField: [{
                type: Input
            }], hasPermissionAction: [{
                type: Input
            }], hasPermission: [{
                type: Input
            }] } });

class PreventMultipleClickDirective {
    throttleTime = 500;
    throttledClick = new EventEmitter();
    clicks = new Subject();
    subscription;
    constructor() { }
    ngOnInit() {
        this.subscription = this.clicks
            .pipe(throttleTime(this.throttleTime))
            .subscribe((e) => this.emitThrottledClick(e));
    }
    emitThrottledClick(e) {
        this.throttledClick.emit(e);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreventMultipleClickDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PreventMultipleClickDirective, selector: "[preventMultipleClick]", inputs: { throttleTime: "throttleTime" }, outputs: { throttledClick: "throttledClick" }, host: { listeners: { "click": "clickEvent($event)" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreventMultipleClickDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[preventMultipleClick]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { throttleTime: [{
                type: Input
            }], throttledClick: [{
                type: Output
            }], clickEvent: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class ActionButtonsSectionComponent {
    actions;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionButtonsSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ActionButtonsSectionComponent, selector: "pl-lib-action-buttons-section", inputs: { actions: "actions" }, ngImport: i0, template: "<div class=\"content\">\n  <ng-container *ngFor=\"let action of actions\">\n    <ng-container\n      *hasPermission=\"\n        action.permissionOrEntity;\n        action: action.permissionAction;\n        field: action.permissionField;\n        shouldDisable: action.permissionShouldDisable;\n        shouldCheck: !!action.permissionOrEntity\n      \"\n    >\n      <ng-container *ngIf=\"action.type === 'button' || !action.type\">\n        <pl-button\n          preventMultipleClick\n          [themeColor]=\"action.themeColor ?? 'base'\"\n          [fillMode]=\"action.fillMode ?? 'solid'\"\n          [icon]=\"action.icon ?? ''\"\n          [disabled]=\"action.disabled || false\"\n          [tooltip]=\"action.tooltip\"\n          [size]=\"action.size ?? 'large'\"\n          (onClick)=\"!action.preventMultipeClicks && action.onClick()\"\n          [title]=\"(action.title ?? '') | translate\"\n          (throttledClick)=\"action.preventMultipeClicks ? action.onClick() : {}\"\n          [ignoreMobileStyle]=\"$any(action).ignoreMobileStyle ?? false\"\n        >\n          {{ (action.text ?? '') | translate }}\n        </pl-button>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'export'\">\n            <button\n              kendoTooltip\n              [title]=\"(action.title ?? 'Export to Excel') | translate\"\n              [fillMode]=\"action.fillMode ?? 'solid'\"\n              [disabled]=\"action.disabled || false\"\n              [size]=\"action.size ?? 'large'\"\n              [themeColor]=\"action.themeColor ?? 'base'\"\n              [icon]=\"action.icon ?? ''\"\n              kendoGridExcelCommand\n            ></button>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'dropdown-button'\">\n        <kendo-dropdownbutton\n          [data]=\"action.dropdownItems\"\n          [themeColor]=\"action.themeColor ?? 'base'\"\n          [fillMode]=\"action.fillMode ?? 'solid'\"\n          [icon]=\"action.icon ?? ''\"\n          [disabled]=\"action.disabled || false\"\n          [size]=\"action.size ?? 'large'\"\n          (itemClick)=\"action.onClick($event)\"\n        >\n          {{ action.text ?? '' | translate }}\n        </kendo-dropdownbutton>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'custom'\">\n        <ng-container\n          *ngComponentOutlet=\"action.component!; inputs: action.componentInputs\"\n        ></ng-container>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".content{display:flex;align-items:center;justify-content:flex-end;gap:4px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$2.DropDownButtonComponent, selector: "kendo-dropdownbutton", inputs: ["icon", "svgIcon", "iconClass", "imageUrl", "textField", "data", "size", "rounded", "fillMode", "themeColor"], outputs: ["itemClick", "focus", "blur"], exportAs: ["kendoDropDownButton"] }, { kind: "component", type: i3$2.ExcelCommandDirective, selector: "[kendoGridExcelCommand]" }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "component", type: PlButtonComponent, selector: "pl-button", inputs: ["themeColor", "fillMode", "disabled", "size", "rounded", "icon", "title", "ignoreBreakpoint", "hoverMode", "tooltip", "ignoreMobileStyle"], outputs: ["onClick"] }, { kind: "directive", type: HasPermissionDirective, selector: "[hasPermission]", inputs: ["hasPermissionShouldCheck", "hasPermissionShouldDisable", "hasPermissionSubjectName", "hasPermissionModelName", "hasPermissionField", "hasPermissionAction", "hasPermission"] }, { kind: "directive", type: PreventMultipleClickDirective, selector: "[preventMultipleClick]", inputs: ["throttleTime"], outputs: ["throttledClick"] }, { kind: "pipe", type: i2$1.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionButtonsSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lib-action-buttons-section', template: "<div class=\"content\">\n  <ng-container *ngFor=\"let action of actions\">\n    <ng-container\n      *hasPermission=\"\n        action.permissionOrEntity;\n        action: action.permissionAction;\n        field: action.permissionField;\n        shouldDisable: action.permissionShouldDisable;\n        shouldCheck: !!action.permissionOrEntity\n      \"\n    >\n      <ng-container *ngIf=\"action.type === 'button' || !action.type\">\n        <pl-button\n          preventMultipleClick\n          [themeColor]=\"action.themeColor ?? 'base'\"\n          [fillMode]=\"action.fillMode ?? 'solid'\"\n          [icon]=\"action.icon ?? ''\"\n          [disabled]=\"action.disabled || false\"\n          [tooltip]=\"action.tooltip\"\n          [size]=\"action.size ?? 'large'\"\n          (onClick)=\"!action.preventMultipeClicks && action.onClick()\"\n          [title]=\"(action.title ?? '') | translate\"\n          (throttledClick)=\"action.preventMultipeClicks ? action.onClick() : {}\"\n          [ignoreMobileStyle]=\"$any(action).ignoreMobileStyle ?? false\"\n        >\n          {{ (action.text ?? '') | translate }}\n        </pl-button>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'export'\">\n            <button\n              kendoTooltip\n              [title]=\"(action.title ?? 'Export to Excel') | translate\"\n              [fillMode]=\"action.fillMode ?? 'solid'\"\n              [disabled]=\"action.disabled || false\"\n              [size]=\"action.size ?? 'large'\"\n              [themeColor]=\"action.themeColor ?? 'base'\"\n              [icon]=\"action.icon ?? ''\"\n              kendoGridExcelCommand\n            ></button>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'dropdown-button'\">\n        <kendo-dropdownbutton\n          [data]=\"action.dropdownItems\"\n          [themeColor]=\"action.themeColor ?? 'base'\"\n          [fillMode]=\"action.fillMode ?? 'solid'\"\n          [icon]=\"action.icon ?? ''\"\n          [disabled]=\"action.disabled || false\"\n          [size]=\"action.size ?? 'large'\"\n          (itemClick)=\"action.onClick($event)\"\n        >\n          {{ action.text ?? '' | translate }}\n        </kendo-dropdownbutton>\n      </ng-container>\n      <ng-container *ngIf=\"action.type === 'custom'\">\n        <ng-container\n          *ngComponentOutlet=\"action.component!; inputs: action.componentInputs\"\n        ></ng-container>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".content{display:flex;align-items:center;justify-content:flex-end;gap:4px}\n"] }]
        }], propDecorators: { actions: [{
                type: Input
            }] } });

class DisplayDataResolverGetterService {
    map;
    constructor(injector, config) {
        this.map = _.mapValues(config.displayDataResolversMap, (k) => injector.get(k));
    }
    get(typeName, throwOnEmpty = true) {
        const resolver = this.map[typeName];
        if (!resolver) {
            if (throwOnEmpty) {
                throw new Error(`Resolver for type ${typeName} is not found. Please register it with DisplayDataResolverMap from DisplayDataResolverGetterService`);
            }
            console.error(`Resolver for type ${typeName} is not found. Please register it with DisplayDataResolverMap from DisplayDataResolverGetterService`);
        }
        return resolver;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DisplayDataResolverGetterService, deps: [{ token: i0.Injector }, { token: DisplayDataResolverConfig }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DisplayDataResolverGetterService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DisplayDataResolverGetterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: DisplayDataResolverConfig }]; } });

/**
 * should only be used on routes that lead to EntityDetails or Entity List
 */
class BaseResolver {
    service;
    entityType;
    globalFiltersService;
    constructor(service, entityType, globalFiltersService) {
        this.service = service;
        this.entityType = entityType;
        this.globalFiltersService = globalFiltersService;
    }
    async resolve(route, state) {
        const id = route.paramMap.get('id');
        console.log(state, route);
        if (id) {
            if (id !== 'new') {
                return {
                    entityType: this.entityType,
                    entityDetailsRoute: true,
                    entity: await firstValueFrom(this.getItem(id))
                };
            }
            return {
                entityType: this.entityType,
                entityDetailsRoute: true,
                entity: null
            };
        }
        const query = route.queryParamMap.get('query');
        let filters;
        if (query) {
            filters = await this.globalFiltersService.getFiltersForModelAndQuery(query, this.entityType);
        }
        return {
            entityType: this.entityType,
            entityDetailsRoute: false,
            entityListRoute: true,
            entity: null,
            query: query,
            filters
        };
    }
    getItem(id) {
        return this.service.get(id);
    }
}

class EntityPanelComponent {
    resolverGetter;
    fullActions;
    deleteAction = {
        id: 'delete',
        text: '',
        icon: 'delete',
        fillMode: 'flat',
        themeColor: 'error',
        onClick: () => this.onDelete.emit(this.entity)
    };
    entityDisplayData;
    _entity;
    get entity() {
        return this._entity;
    }
    set entity(value) {
        this._entity = value;
        this.entityDisplayData = this.getEntityDisplayData();
    }
    showDeleteButton = true;
    actions = [this.deleteAction];
    showTitleAsALink = true;
    subLabel;
    onDelete = new EventEmitter();
    /**
     * @deprecated to be removed in the next major version. Use `customActions` instead.
     */
    onCustomActionExecuted = new EventEmitter();
    customActions = new EventEmitter();
    constructor(resolverGetter) {
        this.resolverGetter = resolverGetter;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.setFullActions();
        });
        if (this.customActions.observed && this.onCustomActionExecuted.observed) {
            throw new Error('The onCustomActionExecuted output is deprecated. Please use the customActions output instead.');
        }
    }
    getEntityDisplayData() {
        if (!this.entity?.typeName) {
            return;
        }
        const displayDataResolver = this.resolverGetter.get(this.entity.typeName);
        return {
            label: displayDataResolver.getTitle(this.entity),
            id: this.entity.id,
            subLabel: this.subLabel ||
                displayDataResolver.getSubTitle(this.entity)?.substring(0, 100),
            icon: displayDataResolver.getIcon(this.entity),
            item: this.entity,
            url: displayDataResolver.getItemHref(this.entity),
            isDeleted: this.entity.isDeleted
        };
    }
    resolveAction(e) {
        switch (e) {
            case 'delete':
                return this.deleteAction;
            default:
                throw new Error(`Action ${e} not found.`);
        }
    }
    setOnClick(button) {
        const overridenButton = button;
        if (overridenButton.onClickOverriden)
            return overridenButton;
        const customButton = { ...overridenButton };
        if (!button.onClick) {
            if (this.onCustomActionExecuted.observed) {
                customButton.onClick = () => this.onCustomActionExecuted.emit(this.entity);
            }
            else if (this.customActions.observed) {
                customButton.onClick = () => this.customActions.emit({ action: button.text, entity: this.entity });
            }
            else {
                console.warn('No output is subscribed to customActions or onCustomActionExecuted.');
            }
        }
        else {
            customButton.onClick = (...args) => button.onClick(...args, this.entity);
            customButton.onClickOverriden = true;
        }
        return customButton;
    }
    setFullActions() {
        const fullActions = this.actions.map((e) => typeof e === 'string' ? this.resolveAction(e) : this.setOnClick(e));
        if (this.entityDisplayData?.isDeleted === true) {
            this.fullActions = [];
        }
        this.fullActions = this.showDeleteButton
            ? fullActions
            : fullActions.filter((e) => e.id != this.deleteAction.id);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EntityPanelComponent, deps: [{ token: DisplayDataResolverGetterService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EntityPanelComponent, selector: "pl-entity-panel", inputs: { entity: "entity", showDeleteButton: "showDeleteButton", actions: "actions", showTitleAsALink: "showTitleAsALink", subLabel: "subLabel" }, outputs: { onDelete: "onDelete", onCustomActionExecuted: "onCustomActionExecuted", customActions: "customActions" }, ngImport: i0, template: "<div class=\"content\" *ngIf=\"entityDisplayData\">\n  <span class=\"icon k-icon {{entityDisplayData.icon}}\"></span>\n  <div class=\"title\" [ngClass]=\"{'deleted':entityDisplayData.isDeleted}\">\n    <a *ngIf=\"showTitleAsALink && !entityDisplayData.isDeleted\" [routerLink]=\"entityDisplayData.url\">{{entityDisplayData.label| stripHTML}}</a>\n    <span *ngIf=\"!showTitleAsALink || entityDisplayData.isDeleted\">{{entityDisplayData.label| stripHTML}}</span>\n    <div class=\"subTitle\">{{entityDisplayData.subLabel | stripHTML}}</div>\n  </div>\n  <pl-lib-action-buttons-section  [actions]=\"fullActions\"></pl-lib-action-buttons-section>\n</div>\n<div class=\"content\" *ngIf=\"!entityDisplayData\">\n  <span>No entity data found.</span>\n</div>", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.content{display:flex;gap:16px;align-items:center}.content .title{flex:1}.content .title.deleted{text-decoration:line-through}.content .title .subTitle{color:#8f8f8f;font-size:smaller}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: ActionButtonsSectionComponent, selector: "pl-lib-action-buttons-section", inputs: ["actions"] }, { kind: "pipe", type: StripHTMLPipe, name: "stripHTML" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EntityPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-entity-panel', template: "<div class=\"content\" *ngIf=\"entityDisplayData\">\n  <span class=\"icon k-icon {{entityDisplayData.icon}}\"></span>\n  <div class=\"title\" [ngClass]=\"{'deleted':entityDisplayData.isDeleted}\">\n    <a *ngIf=\"showTitleAsALink && !entityDisplayData.isDeleted\" [routerLink]=\"entityDisplayData.url\">{{entityDisplayData.label| stripHTML}}</a>\n    <span *ngIf=\"!showTitleAsALink || entityDisplayData.isDeleted\">{{entityDisplayData.label| stripHTML}}</span>\n    <div class=\"subTitle\">{{entityDisplayData.subLabel | stripHTML}}</div>\n  </div>\n  <pl-lib-action-buttons-section  [actions]=\"fullActions\"></pl-lib-action-buttons-section>\n</div>\n<div class=\"content\" *ngIf=\"!entityDisplayData\">\n  <span>No entity data found.</span>\n</div>", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.content{display:flex;gap:16px;align-items:center}.content .title{flex:1}.content .title.deleted{text-decoration:line-through}.content .title .subTitle{color:#8f8f8f;font-size:smaller}\n"] }]
        }], ctorParameters: function () { return [{ type: DisplayDataResolverGetterService }]; }, propDecorators: { entity: [{
                type: Input
            }], showDeleteButton: [{
                type: Input
            }], actions: [{
                type: Input
            }], showTitleAsALink: [{
                type: Input
            }], subLabel: [{
                type: Input
            }], onDelete: [{
                type: Output
            }], onCustomActionExecuted: [{
                type: Output
            }], customActions: [{
                type: Output
            }] } });

class FeedbackMessageComponent {
    _message;
    get message() {
        return this._message;
    }
    set message(value) {
        this._message = value;
    }
    onDismiss = new EventEmitter();
    constructor() { }
    ngOnInit() { }
    getIcon() {
        switch (this._message.status) {
            case 'error':
                return 'k-i-error';
            case 'warning':
                return 'k-i-warning-triangle';
            case 'success':
                return 'k-i-success';
            case 'info':
                return 'k-i-info';
            case 'inProgress':
                return 'k-i-loading';
        }
    }
    dismiss() {
        this.onDismiss.emit(this.message);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FeedbackMessageComponent, selector: "pl-feedback-message", inputs: { message: "message" }, outputs: { onDismiss: "onDismiss" }, ngImport: i0, template: "<div class=\"message\" *ngIf=\"message\" [ngClass]=\"message.class?[message.status, message.class]:message.status\">\n    <div class=\"icon\">\n        <span class=\"k-icon\" [ngClass]=\"getIcon()\"></span>\n    </div>\n    <div class=\"content\">\n        <markdown [data]=\"message.message\"></markdown>\n        <pre *ngIf=\"message.details\"> {{ message.details}}</pre>\n    </div>\n    <div class=\"actions\" *ngIf=\"message.actions && message.actions.length>0\">\n        <pl-lib-action-buttons-section [actions]=\"message.actions\"></pl-lib-action-buttons-section>\n    </div>\n    <div class=\"closeAction\" [ngClass]=\"{'noCloseButton':message.hideDismissButton}\">\n        <a class=\"k-icon k-i-close\" *ngIf=\"!message.hideDismissButton\" title=\"Close\" (click)=\"dismiss()\"></a>\n    </div>\n</div>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.message{display:flex;gap:16px;min-height:30px;border-radius:.125rem;border-style:solid;border-width:1px;overflow:hidden;background-color:#e9ecef;align-items:center}.message.error{background-color:#e90052;color:#fff}.message.info{background-color:#05f0ff}.message.warning{background-color:#ff6900}.message.success{background-color:#00ff87}.message.notification{background-color:#fff;border-color:#e9ecef;box-shadow:1px 1px #e9ecef}.message .actions,.message .closeAction{min-width:32px;align-items:center;display:flex}.message .closeAction.noCloseButton{min-width:0px}.message .closeAction .k-i-close{cursor:pointer}.message .icon{min-width:32px;align-items:center;display:flex;padding-left:16px}.message .content{display:flex;flex:1;flex-direction:column;padding:16px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.MarkdownComponent, selector: "markdown, [markdown]", inputs: ["data", "src", "disableSanitizer", "inline", "srcRelativeLink", "clipboard", "clipboardButtonComponent", "clipboardButtonTemplate", "emoji", "katex", "katexOptions", "mermaid", "mermaidOptions", "lineHighlight", "line", "lineOffset", "lineNumbers", "start", "commandLine", "filterOutput", "host", "prompt", "output", "user"], outputs: ["error", "load", "ready"] }, { kind: "component", type: ActionButtonsSectionComponent, selector: "pl-lib-action-buttons-section", inputs: ["actions"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-feedback-message', template: "<div class=\"message\" *ngIf=\"message\" [ngClass]=\"message.class?[message.status, message.class]:message.status\">\n    <div class=\"icon\">\n        <span class=\"k-icon\" [ngClass]=\"getIcon()\"></span>\n    </div>\n    <div class=\"content\">\n        <markdown [data]=\"message.message\"></markdown>\n        <pre *ngIf=\"message.details\"> {{ message.details}}</pre>\n    </div>\n    <div class=\"actions\" *ngIf=\"message.actions && message.actions.length>0\">\n        <pl-lib-action-buttons-section [actions]=\"message.actions\"></pl-lib-action-buttons-section>\n    </div>\n    <div class=\"closeAction\" [ngClass]=\"{'noCloseButton':message.hideDismissButton}\">\n        <a class=\"k-icon k-i-close\" *ngIf=\"!message.hideDismissButton\" title=\"Close\" (click)=\"dismiss()\"></a>\n    </div>\n</div>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.message{display:flex;gap:16px;min-height:30px;border-radius:.125rem;border-style:solid;border-width:1px;overflow:hidden;background-color:#e9ecef;align-items:center}.message.error{background-color:#e90052;color:#fff}.message.info{background-color:#05f0ff}.message.warning{background-color:#ff6900}.message.success{background-color:#00ff87}.message.notification{background-color:#fff;border-color:#e9ecef;box-shadow:1px 1px #e9ecef}.message .actions,.message .closeAction{min-width:32px;align-items:center;display:flex}.message .closeAction.noCloseButton{min-width:0px}.message .closeAction .k-i-close{cursor:pointer}.message .icon{min-width:32px;align-items:center;display:flex;padding-left:16px}.message .content{display:flex;flex:1;flex-direction:column;padding:16px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { message: [{
                type: Input
            }], onDismiss: [{
                type: Output
            }] } });

class FeedbackBarComponent {
    get messages() {
        return this._messages;
    }
    set messages(value) {
        if (!value) {
            this._messages = [];
        }
        else {
            this._messages = value.filter ? value.filter((e) => !!e) : [value];
        }
    }
    _messages;
    constructor() { }
    ngOnInit() { }
    dismiss(e) {
        this._messages = this._messages.filter((m) => m != e);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FeedbackBarComponent, selector: "pl-feedback-bar", inputs: { messages: "messages" }, ngImport: i0, template: "<pl-feedback-message [message]=\"e\" *ngFor=\"let e of messages\" (onDismiss)=\"dismiss($event)\">\n</pl-feedback-message>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}:host{display:flex;flex-direction:column;gap:.4rem}:host pl-feedback-message:last-child{margin-bottom:1rem}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: FeedbackMessageComponent, selector: "pl-feedback-message", inputs: ["message"], outputs: ["onDismiss"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeedbackBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-feedback-bar', template: "<pl-feedback-message [message]=\"e\" *ngFor=\"let e of messages\" (onDismiss)=\"dismiss($event)\">\n</pl-feedback-message>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}:host{display:flex;flex-direction:column;gap:.4rem}:host pl-feedback-message:last-child{margin-bottom:1rem}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { messages: [{
                type: Input
            }] } });

class LoaderComponent {
    fullPage = true;
    noShading = false;
    constructor() { }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoaderComponent, selector: "pl-loader", inputs: { fullPage: "fullPage", noShading: "noShading" }, ngImport: i0, template: "<div class=\"k-loading-panel\" [class.full]=\"fullPage\">\n  <div class=\"k-loading-panel-mask\" [class.full]=\"fullPage\" [class.noShading]=\"noShading\"></div>\n  <div class=\"k-loading-panel-wrapper\">\n    <span class=\"k-icon k-i-loading\"></span>\n  </div>\n</div>", styles: [".k-loading-panel{display:flex;align-items:center;justify-content:center;z-index:100;height:100%}.k-loading-panel.full{width:100%;position:absolute;top:0;left:0}.k-loading-panel-mask{background-color:#00000010;opacity:.8}.k-loading-panel-mask.noShading{background-color:inherit;opacity:0}.k-loading-panel-mask.full{width:100%;height:100%;position:absolute;top:0;left:0}.k-loading-panel-wrapper{position:relative;z-index:2}.k-icon.k-i-loading{font-size:36px}\n"] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-loader', template: "<div class=\"k-loading-panel\" [class.full]=\"fullPage\">\n  <div class=\"k-loading-panel-mask\" [class.full]=\"fullPage\" [class.noShading]=\"noShading\"></div>\n  <div class=\"k-loading-panel-wrapper\">\n    <span class=\"k-icon k-i-loading\"></span>\n  </div>\n</div>", styles: [".k-loading-panel{display:flex;align-items:center;justify-content:center;z-index:100;height:100%}.k-loading-panel.full{width:100%;position:absolute;top:0;left:0}.k-loading-panel-mask{background-color:#00000010;opacity:.8}.k-loading-panel-mask.noShading{background-color:inherit;opacity:0}.k-loading-panel-mask.full{width:100%;height:100%;position:absolute;top:0;left:0}.k-loading-panel-wrapper{position:relative;z-index:2}.k-icon.k-i-loading{font-size:36px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { fullPage: [{
                type: Input
            }], noShading: [{
                type: Input
            }] } });

class PlCollapsableSectionComponent {
    headerTemplate;
    actionsTemplate;
    noHeader;
    hideExpandIndicator;
    title;
    icon;
    iconExtra;
    iconExtraTooltip;
    iconExtraColor;
    count;
    countLoading;
    items;
    loading;
    isLoaded = false;
    expandDisabled = false;
    _isExpanded = false;
    isExpandedChange = new EventEmitter();
    set isExpanded(value) {
        this._isExpanded = value;
        this.isExpandedChange.emit(this.isExpanded);
    }
    get isExpanded() {
        return this._isExpanded;
    }
    constructor() { }
    ngOnInit() {
        this.isExpanded = this.noHeader ? true : this.isExpanded;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCollapsableSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlCollapsableSectionComponent, selector: "pl-collapsable-section", inputs: { headerTemplate: "headerTemplate", actionsTemplate: "actionsTemplate", noHeader: "noHeader", hideExpandIndicator: "hideExpandIndicator", title: "title", icon: "icon", iconExtra: "iconExtra", iconExtraTooltip: "iconExtraTooltip", iconExtraColor: "iconExtraColor", count: "count", countLoading: "countLoading", items: "items", loading: "loading", isLoaded: "isLoaded", expandDisabled: "expandDisabled", isExpanded: "isExpanded" }, outputs: { isExpandedChange: "isExpandedChange" }, ngImport: i0, template: "<kendo-expansionpanel\n  [class]=\"{\n    'no-header': noHeader,\n    'no-expand-indicator': hideExpandIndicator,\n    'expandDisabled': expandDisabled\n  }\"\n  [(expanded)]=\"isExpanded\"\n>\n  <ng-template kendoExpansionPanelTitleDirective>\n    <div class=\"panel-header-wrapper\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          headerTemplate ? headerTemplate : defaultHeader;\n          context: {\n            title,\n            items,\n            count,\n            loaded: isLoaded,\n            loading,\n            countLoading,\n            icon\n          }\n        \"\n      ></ng-container>\n\n      <div class=\"actions\">\n        <ng-container\n          *ngTemplateOutlet=\"actionsTemplate ? actionsTemplate : defaultActions\"\n        >\n        </ng-container>\n      </div>\n    </div>\n  </ng-template>\n  <ng-content></ng-content>\n</kendo-expansionpanel>\n\n<ng-template #defaultHeader>\n  <div class=\"header\">\n    <pl-icon *ngIf=\"icon\" [icon]=\"icon\"></pl-icon>\n    <span>{{title}}</span>\n    <pl-icon *ngIf=\"iconExtra\" [icon]=\"iconExtra\"\n             [ngStyle]=\"{'color': iconExtraColor}\"\n             kendoTooltip\n             [title]=\"iconExtraTooltip ?? ''\"\n    ></pl-icon>\n  </div>\n</ng-template>\n\n<ng-template #defaultActions></ng-template>\n", styles: [":host ::ng-deep .no-header .k-expander-header{display:none}:host ::ng-deep .no-expand-indicator .k-expander-indicator{display:none}.header{display:flex;gap:8px;align-items:center}.panel-header-wrapper{width:100%;display:flex;justify-content:space-between;align-items:center}.expandDisabled{pointer-events:none}.expandDisabled .actions{pointer-events:all!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i2$5.ExpansionPanelComponent, selector: "kendo-expansionpanel", inputs: ["title", "subtitle", "disabled", "expanded", "svgExpandIcon", "svgCollapseIcon", "expandIcon", "collapseIcon", "animation"], outputs: ["expandedChange", "action", "expand", "collapse"], exportAs: ["kendoExpansionPanel"] }, { kind: "directive", type: i2$5.ExpansionPanelTitleDirective, selector: "[kendoExpansionPanelTitleDirective]" }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "component", type: PlIconComponent, selector: "pl-icon", inputs: ["type", "icon", "size", "color", "src"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCollapsableSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-collapsable-section', template: "<kendo-expansionpanel\n  [class]=\"{\n    'no-header': noHeader,\n    'no-expand-indicator': hideExpandIndicator,\n    'expandDisabled': expandDisabled\n  }\"\n  [(expanded)]=\"isExpanded\"\n>\n  <ng-template kendoExpansionPanelTitleDirective>\n    <div class=\"panel-header-wrapper\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          headerTemplate ? headerTemplate : defaultHeader;\n          context: {\n            title,\n            items,\n            count,\n            loaded: isLoaded,\n            loading,\n            countLoading,\n            icon\n          }\n        \"\n      ></ng-container>\n\n      <div class=\"actions\">\n        <ng-container\n          *ngTemplateOutlet=\"actionsTemplate ? actionsTemplate : defaultActions\"\n        >\n        </ng-container>\n      </div>\n    </div>\n  </ng-template>\n  <ng-content></ng-content>\n</kendo-expansionpanel>\n\n<ng-template #defaultHeader>\n  <div class=\"header\">\n    <pl-icon *ngIf=\"icon\" [icon]=\"icon\"></pl-icon>\n    <span>{{title}}</span>\n    <pl-icon *ngIf=\"iconExtra\" [icon]=\"iconExtra\"\n             [ngStyle]=\"{'color': iconExtraColor}\"\n             kendoTooltip\n             [title]=\"iconExtraTooltip ?? ''\"\n    ></pl-icon>\n  </div>\n</ng-template>\n\n<ng-template #defaultActions></ng-template>\n", styles: [":host ::ng-deep .no-header .k-expander-header{display:none}:host ::ng-deep .no-expand-indicator .k-expander-indicator{display:none}.header{display:flex;gap:8px;align-items:center}.panel-header-wrapper{width:100%;display:flex;justify-content:space-between;align-items:center}.expandDisabled{pointer-events:none}.expandDisabled .actions{pointer-events:all!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { headerTemplate: [{
                type: Input
            }], actionsTemplate: [{
                type: Input
            }], noHeader: [{
                type: Input
            }], hideExpandIndicator: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconExtra: [{
                type: Input
            }], iconExtraTooltip: [{
                type: Input
            }], iconExtraColor: [{
                type: Input
            }], count: [{
                type: Input
            }], countLoading: [{
                type: Input
            }], items: [{
                type: Input
            }], loading: [{
                type: Input
            }], isLoaded: [{
                type: Input
            }], expandDisabled: [{
                type: Input
            }], isExpandedChange: [{
                type: Output
            }], isExpanded: [{
                type: Input
            }] } });

class LazyLoadExpansionPanelComponent {
    destroyed$ = new Subject();
    _isExpanded = false;
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value) {
        this._isExpanded = value;
        if (value && this.lazyLoad && !this.isLoaded) {
            this.getAndSetData();
        }
    }
    noHeader;
    refreshTrigger;
    lazyLoad = true;
    headerTemplate;
    bodyTemplate;
    actionsTemplate;
    title;
    errors;
    icon;
    loadingContainerMinHeight;
    itemsGetter;
    itemsLoaded = new EventEmitter();
    isLoaded = false;
    loading;
    items;
    itemsCounterConfig = {
        type: 'default'
    };
    countLoading = false;
    count;
    constructor() { }
    ngOnDestroy() {
        this.destroyed$.next();
    }
    ngOnInit() {
        if (this.itemsCounterConfig.type === 'custom' &&
            !this.itemsCounterConfig.getter) {
            throw new Error('To use a CUSTOM itemsCount getter within the list, you need to provide a itemsCounterConfig.getter function.');
        }
        if (!this.lazyLoad) {
            this.getAndSetData();
        }
        else if (this.itemsCounterConfig.type === 'custom') {
            this.getAndSetCount();
        }
        this.refreshTrigger?.pipe(takeUntil(this.destroyed$)).subscribe(() => {
            if (this.isExpanded || !this.lazyLoad) {
                this.getAndSetData();
            }
            else {
                this.isLoaded = false;
            }
        });
    }
    runGetterAndSetter(getter, setter, setLoading, setLoaded) {
        if (!getter) {
            return;
        }
        setLoading();
        getter()
            .pipe(catchError((e) => {
            this.countLoading = false;
            this.loading = false;
            this.errors = [{ message: e }];
            return throwError(e);
        }))
            .subscribe((e) => {
            setLoaded();
            setter(e);
        });
    }
    getAndSetCount() {
        if (!this.itemsCounterConfig.getter)
            throw new Error('Attempted to execute the itemsCounterConfig.getter without it being provided.');
        this.runGetterAndSetter(this.itemsCounterConfig.getter, (res) => (this.count = res), () => {
            this.countLoading = true;
        }, () => {
            this.countLoading = false;
        });
    }
    getAndSetData() {
        if (this.itemsCounterConfig.type === 'custom' &&
            this.itemsCounterConfig.run === 'always')
            this.getAndSetCount();
        this.runGetterAndSetter(this.itemsGetter, (res) => {
            if (this.itemsCounterConfig.type === 'default' ||
                (this.itemsCounterConfig.type === 'custom' &&
                    this.itemsCounterConfig.run !== 'always')) {
                if (Array.isArray(res))
                    this.count = res.length;
                if (res.count)
                    this.count = res.count;
            }
            this.items = res;
            this.itemsLoaded.emit(this.items);
        }, () => {
            this.loading = true;
            this.isLoaded = false;
        }, () => {
            this.loading = false;
            this.isLoaded = true;
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LazyLoadExpansionPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LazyLoadExpansionPanelComponent, selector: "pl-lazy-load-expansion-panel", inputs: { isExpanded: "isExpanded", noHeader: "noHeader", refreshTrigger: "refreshTrigger", lazyLoad: "lazyLoad", headerTemplate: "headerTemplate", bodyTemplate: "bodyTemplate", actionsTemplate: "actionsTemplate", title: "title", errors: "errors", icon: "icon", loadingContainerMinHeight: "loadingContainerMinHeight", itemsGetter: "itemsGetter", itemsCounterConfig: "itemsCounterConfig" }, outputs: { itemsLoaded: "itemsLoaded" }, ngImport: i0, template: "<pl-collapsable-section\n  [(isExpanded)]=\"isExpanded\"\n  [headerTemplate]=\"headerTemplate\"\n  [actionsTemplate]=\"actionsTemplate\"\n  [icon]=\"icon\"\n  [items]=\"items\"\n  [loading]=\"loading\"\n  [count]=\"count\"\n  [countLoading]=\"countLoading\"\n  [isLoaded]=\"isLoaded\"\n  [noHeader]=\"noHeader || false\"\n>\n  <div class=\"content\" [ngStyle]=\"loadingContainerMinHeight && loading ? {'min-height': loadingContainerMinHeight} : {}\">\n    <pl-loader *ngIf=\"loading\"></pl-loader>\n    <pl-feedback-bar [messages]=\"errors\"></pl-feedback-bar>\n    <ng-container *ngTemplateOutlet=\"bodyTemplate ? bodyTemplate : defaultBody; context:{ items, loaded: isLoaded, loading }\"></ng-container>\n  </div>\n</pl-collapsable-section>\n\n<ng-template #defaultBody>\n  <span *ngFor=\"let i of items\">item:{{ i|json }}</span>\n</ng-template>\n", styles: [".content{position:relative}.content.loading{padding:20px 0}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: LoaderComponent, selector: "pl-loader", inputs: ["fullPage", "noShading"] }, { kind: "component", type: PlCollapsableSectionComponent, selector: "pl-collapsable-section", inputs: ["headerTemplate", "actionsTemplate", "noHeader", "hideExpandIndicator", "title", "icon", "iconExtra", "iconExtraTooltip", "iconExtraColor", "count", "countLoading", "items", "loading", "isLoaded", "expandDisabled", "isExpanded"], outputs: ["isExpandedChange"] }, { kind: "component", type: FeedbackBarComponent, selector: "pl-feedback-bar", inputs: ["messages"] }, { kind: "pipe", type: i1$3.JsonPipe, name: "json" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LazyLoadExpansionPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lazy-load-expansion-panel', template: "<pl-collapsable-section\n  [(isExpanded)]=\"isExpanded\"\n  [headerTemplate]=\"headerTemplate\"\n  [actionsTemplate]=\"actionsTemplate\"\n  [icon]=\"icon\"\n  [items]=\"items\"\n  [loading]=\"loading\"\n  [count]=\"count\"\n  [countLoading]=\"countLoading\"\n  [isLoaded]=\"isLoaded\"\n  [noHeader]=\"noHeader || false\"\n>\n  <div class=\"content\" [ngStyle]=\"loadingContainerMinHeight && loading ? {'min-height': loadingContainerMinHeight} : {}\">\n    <pl-loader *ngIf=\"loading\"></pl-loader>\n    <pl-feedback-bar [messages]=\"errors\"></pl-feedback-bar>\n    <ng-container *ngTemplateOutlet=\"bodyTemplate ? bodyTemplate : defaultBody; context:{ items, loaded: isLoaded, loading }\"></ng-container>\n  </div>\n</pl-collapsable-section>\n\n<ng-template #defaultBody>\n  <span *ngFor=\"let i of items\">item:{{ i|json }}</span>\n</ng-template>\n", styles: [".content{position:relative}.content.loading{padding:20px 0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { isExpanded: [{
                type: Input
            }], noHeader: [{
                type: Input
            }], refreshTrigger: [{
                type: Input
            }], lazyLoad: [{
                type: Input
            }], headerTemplate: [{
                type: Input
            }], bodyTemplate: [{
                type: Input
            }], actionsTemplate: [{
                type: Input
            }], title: [{
                type: Input
            }], errors: [{
                type: Input
            }], icon: [{
                type: Input
            }], loadingContainerMinHeight: [{
                type: Input
            }], itemsGetter: [{
                type: Input
            }], itemsLoaded: [{
                type: Output
            }], itemsCounterConfig: [{
                type: Input
            }] } });

/**
 * Base implementation for component that will convert the entities into
 * display items (e.g. item having lable/sublable etc).
 */
class BaseEntityDisplayItemAwareComponent {
    displayDataResolver;
    injector;
    textField = 'name';
    valueField = 'id';
    displaySubLabel = true;
    displayImage = false;
    excludeIds;
    showCacheRefreshButton;
    showPageButtons;
    cacheType;
    pageInfoPosition;
    configuratorType;
    configurator;
    isLoading = true;
    filteredData;
    pageInfo;
    lastFilterValue;
    destroyed$ = new Subject();
    service;
    initialized;
    displayDataResolverGetter;
    displayItemAwareComponent;
    constructor(displayDataResolver, injector) {
        this.displayDataResolver = displayDataResolver;
        this.injector = injector;
        this.displayDataResolverGetter = this.injector.get(DisplayDataResolverGetterService);
    }
    _data;
    set data(value) {
        if (value) {
            this._data = value;
            this.setFilteredData(value);
            this.setPageInfo({}, { data: this._data, count: this._data.length });
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        if (this.configurator) {
            this.configurator.displayItemAwareComponent = undefined;
        }
    }
    convertToDropDownItem(value, shouldFixItem = true) {
        if (!value) {
            return value;
        }
        let resolver = this.displayDataResolver;
        if (!resolver && this.configurator?.useDisplayResolverGetter) {
            resolver = this.displayDataResolverGetter.get(value['typeName'], false);
        }
        if (!resolver) {
            return {
                label: value[this.textField],
                id: value[this.valueField],
                item: value,
                needFixing: shouldFixItem //Object.keys(value).length === 1 && !!value[this.valueField]
            };
        }
        const dropDownItem = {
            label: resolver.getTitle(value),
            id: this.configurator?.dropdownItemIdGenerator
                ? this.configurator.dropdownItemIdGenerator(value)
                : value.id,
            ...(this.displaySubLabel && {
                subLabel: resolver.getSubTitle(value)?.substring(0, 100)
            }),
            icon: resolver.getIcon(value),
            image: resolver.getImage(value),
            item: value,
            needFixing: shouldFixItem //Object.keys(value).length === 1 && !!value.id
        };
        if (this.configurator?.processDropdownItem) {
            return this.configurator.processDropdownItem(dropDownItem);
        }
        return dropDownItem;
    }
    ngOnInit() {
        this.internalInit();
    }
    handleGetById(ids, force = false) {
        if (this.configurator?.handleGetByIds !== undefined) {
            return this.configurator.handleGetByIds(ids, this.service, force);
        }
        if (!this.service) {
            throw new Error('HandleGetById only supported when service is provided. Please set configurators.handleGetById to provide custom implementation.');
        }
        const obs = !force && this.service instanceof BaseCacheableApiService
            ? this.service.getCached(ids)
            : this.service.getAll({
                filter: {
                    filters: ids.map((id) => ({
                        field: 'id',
                        operator: 'eq',
                        value: id
                    })),
                    logic: 'or'
                }
            });
        return obs.pipe(takeUntil(this.destroyed$));
    }
    handleFilter(value, force = false, applyPageInfo = false) {
        this.lastFilterValue = value;
        if (this.configurator?.handleFilterOverride !== undefined) {
            this.isLoading = true;
            return this.configurator.handleFilterOverride(value, this.service, this.setFilteredData.bind(this), this.setPageInfo.bind(this), force, this.pageInfo);
        }
        if (!this.service) {
            if (!this._data) {
                throw new Error('Please either supply data (data input) or provide service instance or override handleFilter');
            }
            this.setFilteredData(this._data.filter((item) => item[this.textField].toLowerCase().includes(value.toLowerCase())));
            this.setPageInfo({}, { data: this._data, count: this._data.length });
            return;
        }
        this.isLoading = true;
        const state = this.configurator.getDataServiceQueryStateForFilter(value, this.pageInfo);
        if (applyPageInfo) {
            state.skip = this.pageInfo.skip;
            state.take = this.pageInfo.take;
        }
        let obs = undefined;
        switch (this.cacheType) {
            case 'allData':
                if (!(this.service instanceof BaseCacheableApiService)) {
                    throw new Error('AllData cacheType requested but resolved service is not instance of BaseCacheableApiService. Please make sure that data service is of BaseCacheableApiService type.');
                }
                obs = this.service.getAllRecursiveCached(state, force);
                break;
            case 'requests':
                if (!(this.service instanceof BaseCacheableApiService)) {
                    throw new Error('requests cacheType requested but resolved service is not instance of BaseCacheableApiService. Please make sure that data service is of BaseCacheableApiService type.');
                }
                obs = this.service.getAllCached(state, force);
                break;
            default:
                obs = this.service.getAllPaginated(state);
        }
        if (!obs) {
            throw new Error('Cannot build request for data.');
        }
        obs
            .pipe(takeUntil(this.destroyed$))
            .subscribe((e) => {
            this.setPageInfo(state, e);
            this.setFilteredData(e.data);
        });
    }
    refreshCache(filterValue) {
        if (!(this.service instanceof BaseCacheableApiService)) {
            throw new Error('refreshCache method called but resolved service is not instance of BaseCacheableApiService. Please make sure that data service is of BaseCacheableApiService type.');
        }
        this.service.clearCache();
        this.handleFilter(filterValue || this.lastFilterValue || '', true);
    }
    updatePageInfo(pageInfo) {
        this.pageInfo = pageInfo;
        this.handleFilter(this.lastFilterValue || '', false, true);
    }
    convertFromDisplayItemToEntity(value) {
        return Array.isArray(value)
            ? value.map((i) => this.convertFromDropDownItem(i))
            : this.convertFromDropDownItem(value);
    }
    internalInit() {
        this.initializeProperties();
        this.initializeData();
    }
    initializeData() {
        this.handleFilter('');
    }
    convertFromDropDownItem(value) {
        if (this.configurator?.convertFromDisplayItemOverride != undefined) {
            return this.configurator.convertFromDisplayItemOverride(value);
        }
        return value?.item;
    }
    setFilteredData(filteredData) {
        this.filteredData = this.filteredData || new BehaviorSubject(null);
        this.filteredData.next(this.processFilteredData(filteredData).map((e) => this.convertToDropDownItem(e, false)));
        this.isLoading = false;
    }
    processFilteredData(data) {
        if (this.configurator?.processFilteredData !== undefined) {
            data = this.configurator.processFilteredData(data);
        }
        if (this.configurator?.processFilteredDataHandlesExcludeIds) {
            return data;
        }
        return data.filter((item) => !this.excludeIds || !this.excludeIds.includes(item.id));
    }
    findItemById(id) {
        return this.filteredData.value?.filter((a) => a.id === id)[0];
    }
    initializeProperties() {
        this.configurator = this.configurator || new this.configuratorType();
        if (this.configurator.displayItemAwareComponent && this.configurator.displayItemAwareComponent !== this) {
            throw new Error('The configurator was already used with another component. Multi component usages are not supported at the moment. ');
        }
        this.configurator.displayItemAwareComponent = this;
        this.service = this.configurator.dataServiceType
            ? this.injector.get(this.configurator.dataServiceType)
            : this.configurator.dataServiceFactory
                ? this.configurator.dataServiceFactory()
                : undefined;
        this.displayDataResolver = this.configurator.displayDataResolverType
            ? this.injector.get(this.configurator.displayDataResolverType)
            : undefined;
        this.textField = this.configurator.textField;
        this.valueField = this.configurator.valueField;
        this.displaySubLabel = this.configurator.displaySubLabel;
        this.showCacheRefreshButton = this.configurator.showCacheRefreshButton;
        this.cacheType = this.configurator.cacheType;
        this.pageInfoPosition = this.configurator.pageInfoPosition;
        this.filteredData = new BehaviorSubject([]);
        this.initialized = true;
        this.configurator.initialize(this.service);
    }
    setPageInfo(state, e) {
        this.pageInfo = {
            allDataLoaded: e.data?.length === e.count,
            totalCount: e.count,
            skip: state?.skip || 0,
            take: state?.take || e.data?.length
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityDisplayItemAwareComponent, deps: [{ token: 'EMPTY_RESOLVER' }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseEntityDisplayItemAwareComponent, selector: "app-base-entity-display-item-aware", inputs: { textField: "textField", valueField: "valueField", displaySubLabel: "displaySubLabel", displayImage: "displayImage", excludeIds: "excludeIds", showCacheRefreshButton: "showCacheRefreshButton", showPageButtons: "showPageButtons", cacheType: "cacheType", pageInfoPosition: "pageInfoPosition", configuratorType: "configuratorType", configurator: "configurator", data: "data" }, ngImport: i0, template: '<div>Base Details Component. Override template in your implementation!!!.</div>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityDisplayItemAwareComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-entity-display-item-aware',
                    template: '<div>Base Details Component. Override template in your implementation!!!.</div>'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['EMPTY_RESOLVER']
                }] }, { type: i0.Injector }]; }, propDecorators: { textField: [{
                type: Input
            }], valueField: [{
                type: Input
            }], displaySubLabel: [{
                type: Input
            }], displayImage: [{
                type: Input
            }], excludeIds: [{
                type: Input
            }], showCacheRefreshButton: [{
                type: Input
            }], showPageButtons: [{
                type: Input
            }], cacheType: [{
                type: Input
            }], pageInfoPosition: [{
                type: Input
            }], configuratorType: [{
                type: Input
            }], configurator: [{
                type: Input
            }], data: [{
                type: Input
            }] } });

class BaseEntityHierarchicalDisplayItemAwareComponent extends BaseEntityDisplayItemAwareComponent {
    filterable;
    /**
     * Used for kendoDropDownTreeFlatBinding to link item with it's parent item.
     * Default 'parentId'.
     *
     * The parentIdField property should exist on EntityDropdownItem
     */
    parentIdField;
    /**
     * Used for kendoDropDownTreeHierarchyBinding to get child entities from data.
     * Default 'children'.
     *
     * The childrenField property should exist on EntityDropdownItem
     */
    childrenField;
    dataBindingType;
    checkableSettings = {
        checkChildren: false
    };
    flatItemsList;
    customItemTemplate;
    constructor(displayDataResolver, injector) {
        super(displayDataResolver, injector);
    }
    expandOnFilter;
    static convertToDropDownItem(component, result, value, shouldFixItem = true) {
        if (result && component.parentIdField) {
            result.parentId = value[component.parentIdField];
        }
        if (result && component.childrenField) {
            result.children = value[component.childrenField]?.map((e) => component.convertToDropDownItem(e, shouldFixItem));
        }
        if (result && component.configurator?.isItemSelectable) {
            result.isNotSelectable = !component.configurator.isItemSelectable(result);
        }
    }
    static initializeProperties(component) {
        if (component.configurator) {
            component.filterable =
                component.filterable !== undefined
                    ? component.filterable
                    : component.configurator.filterable || false;
            component.dataBindingType =
                component.dataBindingType !== undefined
                    ? component.dataBindingType
                    : component.configurator.dataBindingType;
            component.parentIdField =
                component.parentIdField !== undefined
                    ? component.parentIdField
                    : component.configurator.parentIdField;
            component.childrenField =
                component.childrenField !== undefined
                    ? component.childrenField
                    : component.configurator.childrenField;
            component.checkableSettings =
                component.configurator.checkableSettings || component.checkableSettings;
            component.expandOnFilter =
                component.configurator.expandOnFilter || component.expandOnFilter;
            component.customItemTemplate =
                component.configurator.customItemTemplate ||
                    component.customItemTemplate;
        }
    }
    static fetchChildren(component, $event) {
        if (component.dataBindingType !== 'custom') {
            throw new Error('FetchChildren called in BaseTreeViewDropdownComponent - but dataBindingType not set to custom.');
        }
        if (!component.configurator?.fetchChildren) {
            throw new Error('Configurator for BaseTreeViewDropdownComponent was not passed or fetchChildren method in configurator not provided. Please either provide fetchChildren method or set the dataBindingType to type that does not require configurator.');
        }
        return component.configurator
            .fetchChildren($event)
            .pipe(map((e) => e.map((i) => component.convertToDropDownItem(i))));
    }
    static hasChildren(component, $event) {
        if (component.dataBindingType !== 'custom') {
            throw new Error('FetchChildren called in BaseTreeViewDropdownComponent - but dataBindingType not set to custom.');
        }
        if (!component.configurator?.hasChildren) {
            throw new Error('Configurator for BaseTreeViewDropdownComponent was not passed or hasChildren method in configurator not provided. Please either provide fetchChildren method or set the dataBindingType to type that does not require configurator.');
        }
        return component.configurator.hasChildren($event);
    }
    static findItemByIdOrDataItemProperty(component, idOrPropertyValue, dataItemPropertyName) {
        function getItems(items) {
            if (!items || items.length == 0) {
                return [];
            }
            return items.concat(_.flatten(items.map((i) => getItems(i.children))));
        }
        if (!component.flatItemsList) {
            component.flatItemsList = getItems(component.filteredData
                .value);
        }
        return component.flatItemsList?.filter((a) => dataItemPropertyName
            ? a.item[dataItemPropertyName] === idOrPropertyValue
            : a.id === idOrPropertyValue)[0];
    }
    convertToDropDownItem(value, shouldFixItem = true) {
        const result = super.convertToDropDownItem(value, shouldFixItem);
        BaseEntityHierarchicalDisplayItemAwareComponent.convertToDropDownItem(this, result, value, shouldFixItem);
        return result;
    }
    initializeProperties() {
        super.initializeProperties();
        BaseEntityHierarchicalDisplayItemAwareComponent.initializeProperties(this);
    }
    fetchChildren($event) {
        return BaseEntityHierarchicalDisplayItemAwareComponent.fetchChildren(this, $event);
    }
    hasChildren($event) {
        return BaseEntityHierarchicalDisplayItemAwareComponent.hasChildren(this, $event);
    }
    setFilteredData(filteredData) {
        this.flatItemsList = undefined;
        return super.setFilteredData(filteredData);
    }
    findItemById(idOrPropertyValue, dataItemPropertyName) {
        return BaseEntityHierarchicalDisplayItemAwareComponent.findItemByIdOrDataItemProperty(this, idOrPropertyValue, dataItemPropertyName);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityHierarchicalDisplayItemAwareComponent, deps: [{ token: 'EMPTY_RESOLVER' }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseEntityHierarchicalDisplayItemAwareComponent, selector: "app-base-entity-hierarchical-display-item-aware", inputs: { filterable: "filterable", customItemTemplate: "customItemTemplate" }, usesInheritance: true, ngImport: i0, template: '<div>BaseEntityHierarchicalDisplayItemAwareComponent. Override template in your implementation!!!.</div>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityHierarchicalDisplayItemAwareComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-entity-hierarchical-display-item-aware',
                    template: '<div>BaseEntityHierarchicalDisplayItemAwareComponent. Override template in your implementation!!!.</div>'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['EMPTY_RESOLVER']
                }] }, { type: i0.Injector }]; }, propDecorators: { filterable: [{
                type: Input
            }], customItemTemplate: [{
                type: Input
            }] } });

const variantClassesMap = {
    PRIMARY: 'bg-tag-primary text-white tag',
    GREEN: 'bg-tag-green text-white text-center tag',
    GREY: 'bg-tag-grey text-white text-center tag',
    'GREY-OUTLINE': 'bg-tag-grey-outline text-grey text-center tag',
    'PINK-OUTLINE': 'bg-tag-pink-outline text-pink text-center tag',
    PURPLE: 'bg-tag-purple text-white text-center tag',
    'LIGHT-BLUE': 'bg-tag-light-blue text-white text-center tag',
    'LIGHT-GREEN': 'bg-tag-light-green text-white text-center tag',
    JADE: 'bg-tag-jade text-white text-center tag',
    ORANGE: 'bg-tag-orange text-white text-center tag',
    RED: 'bg-tag-red text-white text-center tag'
};
const tagPaddingClassesMap = {
    SMALL: 'tag-small',
    MEDIUM: 'tag-medium',
    LARGE: 'tag-large'
};
const tagIconSizesMap = {
    SMALL: '8px',
    MEDIUM: '12px',
    LARGE: '16px'
};
const tagRoundedClassesMap = {
    PILL: 'tag-rounded-pill',
    STANDARD: 'tag-rounded-standard'
};
class PlTagComponent {
    variant = 'PRIMARY';
    size = 'SMALL';
    rounded = 'STANDARD';
    icon;
    iconColor = 'inherit';
    tooltip = '';
    tagFontSizesMap = tagIconSizesMap;
    get cssClasses() {
        return `justify-center text-center gap-1 align-center px-2 ${variantClassesMap[this.variant]} ${tagRoundedClassesMap[this.rounded]} ${tagPaddingClassesMap[this.size]}`;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlTagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlTagComponent, selector: "pl-tag", inputs: { variant: "variant", size: "size", rounded: "rounded", icon: "icon", iconColor: "iconColor", tooltip: "tooltip" }, ngImport: i0, template: `<span [class]="cssClasses" [title]="tooltip" kendoTooltip>
    <pl-icon
      *ngIf="icon"
      [icon]="icon!"
      [color]="iconColor"
      [size]="tagFontSizesMap[size]"
    ></pl-icon>
    <ng-content></ng-content
  ></span>`, isInline: true, styles: [":host{width:-moz-fit-content;width:fit-content}.tag{font-weight:400;display:block;align-items:center;text-align:center;padding:2px 6px}.tag-small{font-size:11px}.bg-tag-primary{background:linear-gradient(90deg,var(--tb-kendo-primary-100) 0%,var(--tb-kendo-warning-100) 103.29%)}.bg-tag-green{background:var(--tb-kendo-success-100)}.bg-tag-grey{background:var(--kendo-neutral-40)}.bg-tag-grey-outline{border:1px solid var(--kendo-neutral-40)}.bg-tag-pink-outline{border:1px solid var(--tb-kendo-primary-100)}.bg-tag-purple{background:#7030a0}.bg-tag-light-blue{background:#00b0f0}.bg-tag-jade{background:#00b050}.bg-tag-light-green{background:#92d050}.bg-tag-orange{background:#ffc000}.bg-tag-red{background:red}.tag-rounded-standard{border-radius:4px}.tag-rounded-pill{border-radius:50px}.text-white{color:#fff}.text-pink{color:var(--tb-kendo-primary-100)}.text-grey{color:var(--kendo-neutral-40)}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "component", type: PlIconComponent, selector: "pl-icon", inputs: ["type", "icon", "size", "color", "src"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlTagComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-tag', template: `<span [class]="cssClasses" [title]="tooltip" kendoTooltip>
    <pl-icon
      *ngIf="icon"
      [icon]="icon!"
      [color]="iconColor"
      [size]="tagFontSizesMap[size]"
    ></pl-icon>
    <ng-content></ng-content
  ></span>`, styles: [":host{width:-moz-fit-content;width:fit-content}.tag{font-weight:400;display:block;align-items:center;text-align:center;padding:2px 6px}.tag-small{font-size:11px}.bg-tag-primary{background:linear-gradient(90deg,var(--tb-kendo-primary-100) 0%,var(--tb-kendo-warning-100) 103.29%)}.bg-tag-green{background:var(--tb-kendo-success-100)}.bg-tag-grey{background:var(--kendo-neutral-40)}.bg-tag-grey-outline{border:1px solid var(--kendo-neutral-40)}.bg-tag-pink-outline{border:1px solid var(--tb-kendo-primary-100)}.bg-tag-purple{background:#7030a0}.bg-tag-light-blue{background:#00b0f0}.bg-tag-jade{background:#00b050}.bg-tag-light-green{background:#92d050}.bg-tag-orange{background:#ffc000}.bg-tag-red{background:red}.tag-rounded-standard{border-radius:4px}.tag-rounded-pill{border-radius:50px}.text-white{color:#fff}.text-pink{color:var(--tb-kendo-primary-100)}.text-grey{color:var(--kendo-neutral-40)}\n"] }]
        }], propDecorators: { variant: [{
                type: Input
            }], size: [{
                type: Input
            }], rounded: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], tooltip: [{
                type: Input
            }] } });

class BasePLAvatarComponent {
    loaded = false;
    renderAvatar = false;
    avatarURL;
    initials;
    size = '35px';
    constructor() { }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BasePLAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BasePLAvatarComponent, selector: "base-pl-avatar", inputs: { loaded: "loaded", renderAvatar: "renderAvatar", avatarURL: "avatarURL", initials: "initials", size: "size" }, ngImport: i0, template: "<pl-loader *ngIf=\"!loaded\" [fullPage]=\"false\"></pl-loader>\n<ng-container *ngIf=\"loaded && renderAvatar && avatarURL else initialsAvatar\">\n  <kendo-avatar\n    [imageSrc]=\"avatarURL\"\n    shape=\"rounded\"\n    [width]=\"size\"\n    [height]=\"size\">\n  </kendo-avatar>\n</ng-container>\n<ng-template #initialsAvatar>\n  <kendo-avatar\n    *ngIf=\"initials && loaded && !renderAvatar\"\n    [initials]=\"initials\"\n    shape=\"rounded\"\n    [width]=\"size\"\n    [height]=\"size\">\n  </kendo-avatar>\n</ng-template>\n\n", dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.AvatarComponent, selector: "kendo-avatar", inputs: ["shape", "size", "rounded", "themeColor", "fillMode", "fill", "border", "iconClass", "width", "height", "cssStyle", "initials", "icon", "imageSrc", "svgIcon"] }, { kind: "component", type: LoaderComponent, selector: "pl-loader", inputs: ["fullPage", "noShading"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BasePLAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'base-pl-avatar', template: "<pl-loader *ngIf=\"!loaded\" [fullPage]=\"false\"></pl-loader>\n<ng-container *ngIf=\"loaded && renderAvatar && avatarURL else initialsAvatar\">\n  <kendo-avatar\n    [imageSrc]=\"avatarURL\"\n    shape=\"rounded\"\n    [width]=\"size\"\n    [height]=\"size\">\n  </kendo-avatar>\n</ng-container>\n<ng-template #initialsAvatar>\n  <kendo-avatar\n    *ngIf=\"initials && loaded && !renderAvatar\"\n    [initials]=\"initials\"\n    shape=\"rounded\"\n    [width]=\"size\"\n    [height]=\"size\">\n  </kendo-avatar>\n</ng-template>\n\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { loaded: [{
                type: Input
            }], renderAvatar: [{
                type: Input
            }], avatarURL: [{
                type: Input
            }], initials: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class BaseEditActionHandler {
    baseEntityListComponent;
    constructor(baseEntityListComponent) {
        this.baseEntityListComponent = baseEntityListComponent;
    }
    editFormGroup;
    editedRowIndex;
    addHandler({ sender }, context) {
        //TODO: implement editing
        throw new Error('Not implemented in BaseEntityList. Please migrate from data-grid.');
        // this.baseEntityListComponent.closeEditor(sender, undefined, true);
        // this.editFormGroup = this.baseEntityListComponent.configurator.editFormGetter(undefined, this, context);
        // sender.addRow(this.editFormGroup);
        // this.visibleActions = this.getVisibleActions();
    }
    editHandler({ sender, rowIndex, dataItem }) {
        //TODO: implement editing
        throw new Error('Not implemented in BaseEntityList. Please migrate from data-grid.');
        // this.closeEditor(sender, undefined, true);
        //
        // this.editedRowIndex = rowIndex;
        // this.editFormGroup = this.baseEntityListComponent.configurator.editFormGetter(dataItem, this, undefined);
        //
        // sender.editRow(rowIndex, this.editFormGroup);
        // this.visibleActions = this.getVisibleActions();
    }
    cancelHandler({ sender, rowIndex }) {
        //TODO: implement editing
        throw new Error('Not implemented in BaseEntityList. Please migrate from data-grid.');
        // this.closeEditor(sender, rowIndex);
    }
    saveHandler({ sender, rowIndex, formGroup, isNew }) {
        //TODO: implement editing
        throw new Error('Not implemented in BaseEntityList. Please migrate from data-grid.');
        // this.editFinished.emit({
        //     sender: this,
        //     formGroup: formGroup,
        //     isNew,
        //     rowIndex,
        //     item:
        //         rowIndex !== undefined && this.data
        //             ? (Array.isArray(this.data) ? this.data : this.data.data)[rowIndex]
        //             : undefined,
        //     clickedItemData: undefined
        // });
        //
        // this.closeEditor(sender, rowIndex);
    }
    raiseAdd(context) {
        if (!this.baseEntityListComponent.canEdit) {
            console.log('RaiseAdd called on grid but grid is not editable or user does not have permission to edit.');
            return;
        }
        if (this.baseEntityListComponent.configurator.editActionHandlers
            ?.handleAddItemRequest) {
            this.baseEntityListComponent.configurator.editActionHandlers.handleAddItemRequest({
                sender: this,
                clickedItemData: context,
                selectedKeys: this.baseEntityListComponent.selectedItemsKeys,
                selectedItems: this.baseEntityListComponent.selectedItems,
                baseHandler: (e) => e.sender.addHandler({ sender: e.sender.baseGrid }, e.clickedItemData)
            });
        }
        else {
            this.addHandler({ sender: this.baseEntityListComponent.baseComponent }, context);
        }
    }
    raiseEdit(context) {
        if (!this.baseEntityListComponent.canEdit) {
            console.log('raiseEdit called on grid but grid is not editable or user does not have permission to edit.');
            return;
        }
        if (this.baseEntityListComponent.configurator.editActionHandlers
            ?.handleEditItemRequest) {
            this.baseEntityListComponent.configurator.editActionHandlers.handleEditItemRequest({
                sender: this,
                selectedKeys: this.baseEntityListComponent.selectedItemsKeys,
                selectedItems: this.baseEntityListComponent.selectedItems,
                clickedItemData: context,
                //TODO: pass row index etc.
                baseHandler: (e) => e.sender.editHandler({ sender: e.sender.baseGrid })
            });
        }
        else {
            //TODO: pass row index etc.
            this.editHandler({
                sender: this.baseEntityListComponent.baseComponent
            });
        }
    }
    raiseDelete(context) {
        this.baseEntityListComponent.configurator.editActionHandlers.handleDeleteItemRequest({
            sender: this,
            selectedKeys: this.baseEntityListComponent.selectedItemsKeys,
            selectedItems: this.baseEntityListComponent.selectedItems,
            clickedItemData: context
        });
        this.baseEntityListComponent.selectedItemsKeys = [];
    }
    raiseSave(context) {
        if (!this.baseEntityListComponent.canEdit) {
            console.log('raiseSave called on grid but grid is not editable or user does not have permission to edit.');
            return;
        }
        if (this.baseEntityListComponent.configurator.editActionHandlers
            ?.handleEditFinished) {
            this.baseEntityListComponent.configurator.editActionHandlers.handleEditFinished({
                sender: this,
                selectedKeys: this.baseEntityListComponent.selectedItemsKeys,
                selectedItems: this.baseEntityListComponent.selectedItems,
                formGroup: this.editFormGroup,
                isNew: undefined,
                rowIndex: undefined,
                clickedItemData: context
            });
        }
        else {
            this.saveHandler({
                sender: this.baseEntityListComponent.baseComponent,
                formGroup: this.editFormGroup,
                isNew: this.editedRowIndex !== undefined,
                rowIndex: this.editedRowIndex
            });
        }
    }
    raiseCancel(context) {
        if (!this.baseEntityListComponent.canEdit) {
            console.log('raiseCancel called on grid but grid is not editable or user does not have permission to edit.');
            return;
        }
        if (this.baseEntityListComponent.configurator.editActionHandlers
            ?.handleEditCanceled) {
            this.baseEntityListComponent.configurator.editActionHandlers.handleEditCanceled({
                sender: this,
                selectedKeys: this.baseEntityListComponent.selectedItemsKeys,
                selectedItems: this.baseEntityListComponent.selectedItems,
                isNew: undefined,
                rowIndex: undefined,
                clickedItemData: context
            });
        }
        else {
            //TODO: pass row index etc.
            this.cancelHandler({
                sender: this.baseEntityListComponent.baseComponent,
                rowIndex: 0
            });
        }
    }
    isEditing() {
        return !!this.editFormGroup;
    }
}

class BaseEntityListFilterBuilderComponent {
    trimPipe;
    dynamicLabelPipe;
    translatePipe;
    _baseList;
    get baseList() {
        return this._baseList;
    }
    set baseList(value) {
        this._baseList = value;
        this.calculateFilterExpressions();
    }
    filterValue = { logic: 'and', filters: [] };
    changedValue;
    /**
     * Definitions that will be passed to Kendo Filter component.
     * Those will be ignored if dataGrid property is set.
     */
    filterDefinitions;
    filterValueChange = new EventEmitter();
    constructor(trimPipe, dynamicLabelPipe, translatePipe) {
        this.trimPipe = trimPipe;
        this.dynamicLabelPipe = dynamicLabelPipe;
        this.translatePipe = translatePipe;
    }
    ngOnInit() { }
    calculateFilterExpressions() {
        this.filterDefinitions = this.baseList.configurator.columns
            .filter((e) => e.filterable)
            .map((c) => {
            return {
                field: this.baseList.getColumnFilterField(c),
                title: this.translatePipe.transform(this.dynamicLabelPipe.transform(c.title || 'pl.generic.' + this.trimPipe.transform(c.field)), this.baseList.configurator.labelsType, this.baseList.configurator.labelsSubType),
                editor: c.filter == 'text'
                    ? 'string'
                    : c.filter == 'numeric'
                        ? 'number'
                        : c.filter || 'string',
                editorFormat: c.format,
                editorTemplate: this.baseList?.defaultGetCustomFilterTemplate(c)
            };
        });
        this.filterValue = this._baseList.state.filter || this.filterValue;
    }
    applyFilter(value) {
        this.filterValueChange.emit(value || this.changedValue);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityListFilterBuilderComponent, deps: [{ token: TrimToFieldNamePipe }, { token: DynamicLabelPipe }, { token: i2$1.TranslatePipe }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseEntityListFilterBuilderComponent, selector: "pl-lib-data-grid-filter-builder", inputs: { baseList: "baseList", filterValue: "filterValue", filterDefinitions: "filterDefinitions" }, outputs: { filterValueChange: "filterValueChange" }, providers: [TranslatePipe], ngImport: i0, template: "<div class=\"content\">\n    <kendo-filter *ngIf=\"baseList\" #filter [filters]=\"filterDefinitions\" [value]=\"filterValue\" (valueChange)=\"changedValue = $event\">\n    </kendo-filter>\n</div>\n", styles: [".content{max-height:600px;overflow:auto}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$1.FilterComponent, selector: "kendo-filter", inputs: ["filters", "value"], outputs: ["valueChange"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityListFilterBuilderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lib-data-grid-filter-builder', providers: [TranslatePipe], template: "<div class=\"content\">\n    <kendo-filter *ngIf=\"baseList\" #filter [filters]=\"filterDefinitions\" [value]=\"filterValue\" (valueChange)=\"changedValue = $event\">\n    </kendo-filter>\n</div>\n", styles: [".content{max-height:600px;overflow:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: TrimToFieldNamePipe }, { type: DynamicLabelPipe }, { type: i2$1.TranslatePipe }]; }, propDecorators: { baseList: [{
                type: Input
            }], filterValue: [{
                type: Input
            }], filterDefinitions: [{
                type: Input
            }], filterValueChange: [{
                type: Output
            }] } });

/**
 * Base implementation for component that handles list of entities
 */
class BaseEntityListComponent {
    router;
    route;
    baseComponentQuery;
    isLoading = true;
    resizable = true;
    messages;
    state = {
        skip: 0,
        take: 100
    };
    processedData;
    visibleActions;
    toolbarTemplate;
    filterableSettings;
    searchText = '';
    selectedItemsKeysChange = new EventEmitter();
    selectedItemsChange = new EventEmitter();
    dataStateChanged = new EventEmitter();
    groupsInitiallyExpanded = true;
    actionHandler = new BaseEditActionHandler(this);
    baseActions = {
        add: {
            themeColor: 'primary',
            text: 'Add',
            icon: 'plus',
            size: 'small',
            permissionAction: PermissionActions.Create,
            onClick: (i) => this.actionHandler.raiseAdd(i)
        },
        edit: {
            themeColor: 'primary',
            title: 'Edit',
            icon: 'edit',
            size: 'small',
            permissionAction: PermissionActions.Write,
            disabled: true,
            onClick: (i) => this.actionHandler.raiseEdit(i)
        },
        delete: {
            themeColor: 'primary',
            icon: 'delete',
            title: 'Remove',
            size: 'small',
            permissionAction: PermissionActions.Delete,
            disabled: true,
            onClick: (i) => this.actionHandler.raiseDelete(i)
        },
        deleteSelected: {
            themeColor: 'primary',
            icon: 'delete',
            title: 'Remove Selected',
            size: 'small',
            disabled: true,
            onClick: (i) => this.actionHandler.raiseDelete(i)
        },
        save: {
            themeColor: 'primary',
            text: 'Save',
            icon: 'check',
            title: 'Save',
            size: 'small',
            permissionAction: PermissionActions.Write,
            onClick: (i) => this.actionHandler.raiseSave(i)
        },
        cancel: {
            themeColor: 'primary',
            text: 'Cancel',
            icon: 'cancel',
            title: 'Cancel',
            size: 'small',
            onClick: (i) => this.actionHandler.raiseCancel(i)
        },
        toggleFilters: {
            themeColor: 'base',
            size: 'small',
            title: 'Toggle Filters',
            icon: 'filter',
            onClick: this.toggleFiltersRow.bind(this)
        },
        toggleGroupsExpand: {
            themeColor: 'base',
            icon: 'kpi',
            title: 'Toggle Group Expand',
            size: 'small',
            onClick: this.toggleGroupsExpand.bind(this)
        },
        showAdvancedFilters: {
            themeColor: 'base',
            size: 'small',
            title: 'Filter Builder',
            icon: 'filter',
            onClick: this.showAdvancedFilters.bind(this)
        },
        clearFilters: {
            themeColor: 'base',
            size: 'small',
            title: 'Clear Filters',
            icon: 'filter-clear',
            onClick: this.clearFilters.bind(this)
        },
        export: {
            themeColor: 'base',
            type: 'export',
            icon: 'download',
            size: 'small',
            permissionAction: PermissionActions.Create,
            onClick: (i) => null
        },
        refresh: {
            themeColor: 'base',
            icon: 'reload',
            title: 'Refresh',
            size: 'small',
            onClick: () => {
                this.fetch();
                this.secureGrid();
            }
        }
    };
    /**
     * Calculated actions to be available in grid.
     * Consists of all baseActions plus actions from configurator.
     * ShowsActions will be applied to this object as well
     *
     * To Secure Actions the permissionProperties can be used which will be passed to hasPermission directive.
     *
     * For BaseActions the 'subject' property of hasPermission directive will be automatically populated with either actions.permissionOrEntity or dataItem for each row
     *
     * the permission check will ONLY be executed if actions.permissionAction and actions.permissionOrEntity are populated.
     *
     */
    actions;
    fetchedData;
    _shouldShowFilterRow = false;
    obs$;
    countObs$;
    countResult;
    /**
     * Raised when table is searched.
     * By default, this will apply the text input as a 'CONTAINS' filter on all columns defined within the searchable data-grid JSON.
     * This can be overridden.
     */
    queuedSearch;
    constructor(router, route) {
        this.router = router;
        this.route = route;
    }
    _currentColumns;
    get currentColumns() {
        return this._currentColumns;
    }
    _selectedItemsKeys;
    get selectedItemsKeys() {
        return this._selectedItemsKeys;
    }
    set selectedItemsKeys(value) {
        this._selectedItemsKeys = value;
        this.selectedItems = this.generateSelectedItems() || [];
        this.selectedItemsKeysChange.emit(value);
        this.setupActiveActions();
        if (this.configurator.selectedItemsChangedHandler) {
            this.configurator.selectedItemsChangedHandler(this.selectedItems);
        }
    }
    _selectedItems;
    get selectedItems() {
        return this._selectedItems;
    }
    set selectedItems(value) {
        this._selectedItems = value;
        this.selectedItemsChange.emit(value);
    }
    _baseComponent;
    get baseComponent() {
        return this._baseComponent;
    }
    set baseComponent(value) {
        this._baseComponent = value;
    }
    _configurator;
    get configurator() {
        return this._configurator;
    }
    set configurator(value) {
        this._configurator = value;
        this.setPropertiesFromConfigurator();
    }
    get canEdit() {
        return (!!this.configurator.editableSettings &&
            this.configurator.editableSettings.editable &&
            this.configurator.securityConfig?.canEdit !== false);
    }
    get canDelete() {
        return (this.configurator.deletable &&
            this.configurator.securityConfig?.canDelete !== false);
    }
    searchHandler = (input) => {
        const scope = this;
        clearTimeout(this.queuedSearch);
        this.queuedSearch = setTimeout(() => {
            const filterableColumns = scope.configurator.filtersSettings.searchBox?.columns.map((column) => ({
                field: column,
                operator: 'contains',
                value: input
            })) || [];
            this.filterChange({
                logic: 'and',
                filters: [
                    {
                        logic: 'or',
                        filters: filterableColumns
                    }
                ]
            });
        }, 500);
    };
    async ngOnInit() {
        if (!this.configurator) {
            throw new Error('Configurator is required on BaseEntityListComponent.');
        }
        this.configurator.list = this;
        this.setupActions();
        this.setupFilterableSettings(!!(this.state?.filter?.filters && this.state.filter.filters.length > 0));
        this.setupColumns();
        this.secureGrid();
        if (!this.configurator.loadOnInit) {
            await this.showMessages();
            return;
        }
        this.fetch();
    }
    ngAfterViewInit() {
        this.baseComponentQuery.changes.subscribe((comps) => {
            this.baseComponent = comps.first;
        });
        this.baseComponent = this.baseComponentQuery.first;
    }
    async showMessages(messages) {
        if (this.configurator.getMessages) {
            this.messages = ((await this.configurator.getMessages()) || []).concat(messages || []);
        }
        else {
            this.messages = messages || [];
        }
    }
    count() {
        const { count } = this.getItemsGetterObservable();
        this.countObs$ = count.pipe(shareReplay({ bufferSize: 1, refCount: true }));
        this.countObs$.subscribe({
            next: async (result) => {
                this.countResult = result;
                this.countObs$ = undefined;
            },
            error: async (e) => {
                await this.showMessages([
                    { message: e?.message || e, status: 'error' }
                ]);
            }
        });
        return this.countObs$;
    }
    async fetchAll() {
        const state = _.cloneDeep(this.state);
        delete state.skip;
        delete state.take;
        const { data } = this.getItemsGetterObservable(state, true);
        return await firstValueFrom(data.pipe(map((e) => {
            return {
                data: process(e.data, {
                    filter: this.state.filter,
                    group: this.state.group,
                    sort: this.state.sort
                }).data,
                total: e.count
            };
        })));
    }
    fetch() {
        if (this.isLoading && this.obs$) {
            return this.obs$;
        }
        this.isLoading = true;
        const { data } = this.getItemsGetterObservable();
        this.obs$ = data.pipe(shareReplay({ bufferSize: 1, refCount: true }));
        this.obs$.subscribe({
            next: async (result) => {
                try {
                    await this.showMessages();
                    this.fetchedData = await this.prepareFetchedData(result);
                    await this.assignProcessedData();
                    this.isLoading = false;
                    this.obs$ = undefined;
                    setTimeout(() => (this.selectedItems = this.generateSelectedItems() || []), 1);
                }
                catch (e) {
                    this.isLoading = false;
                    await this.showMessages([
                        { message: e?.error?.message || e?.message || e, status: 'error' }
                    ]);
                }
            },
            error: async (e) => {
                this.isLoading = false;
                await this.showMessages([
                    { message: e?.error?.message || e?.message || e, status: 'error' }
                ]);
            }
        });
        return this.obs$;
    }
    cellClickHandler(entity) {
        if (this.configurator.selectable) {
            return;
        }
        if (this.configurator.cellClickHandler) {
            return this.configurator.cellClickHandler(entity, this.router, this.route);
        }
        const url = this.configurator.displayDataResolver.getItemHref(entity);
        if (url) {
            this.router.navigateByUrl(url);
        }
    }
    defaultRowClass() {
        return undefined;
    }
    sortChange(sort) {
        this.state.sort = sort;
        this.applyDataStateChange();
        this.dataStateChanged.emit(this.state);
    }
    filterChange(event) {
        this.state.filter = this.applyCaseSensitivity(event);
        this.state.skip = 0;
        this.applyDataStateChange();
        this.dataStateChanged.emit(this.state);
    }
    pageChange(event) {
        this.state.skip = event.skip;
        this.state.take = event.take;
        this.applyDataStateChange();
        this.dataStateChanged.emit(this.state);
    }
    getPageSize() {
        if (typeof this.configurator.pageableSettings === 'boolean' ||
            typeof this.configurator.pageableSettings?.pageSizes === 'boolean') {
            return this.state?.take;
        }
        if (this.configurator.pageableSettings?.pageSizes &&
            this.configurator.pageableSettings.pageSizes?.length > 0) {
            return this.configurator.pageableSettings.pageSizes[0];
        }
        return undefined;
    }
    getColumnFilterField(column) {
        return column.attributes?.customFilterValueField || column.field;
    }
    defaultGetCustomFilterTemplate(column) {
        if (this.configurator.getCustomFilterTemplate) {
            const t = this.configurator.getCustomFilterTemplate(column);
            if (t) {
                return t;
            }
        }
        // TODO: add default filters templates
        // if (
        //     column.filterable &&
        //     column.attributes &&
        //     column.attributes['customFilter'] === 'season'
        // ) {
        //     return this.seasonFilterTemplate;
        // }
        // if (column.filterable && column.type === 'enum') {
        //     return this.enumFilterTemplate;
        // }
        return null;
    }
    isHandlerOfType(handlerName, handlerType) {
        if (this.configurator.editableSettings.actionButtonsPlacement[handlerName]) {
            return (this.configurator.editableSettings.actionButtonsPlacement[handlerName] === handlerType);
        }
        return (this.configurator.editableSettings.actionButtonsPlacement.default ===
            handlerType);
    }
    menuItemClickedHandler(dataItem, $event) {
        if (!this.configurator.menuItemClicked) {
            throw new Error('Menu Item clicked handle requested but not provided in configurator.');
        }
        this.configurator.menuItemClicked(dataItem, $event);
    }
    shouldColumnCellUseDefaultKendoTemplate(column) {
        const templateOverridden = column.type === 'picture' ||
            (column.type === 'date' &&
                column.attributes &&
                column.attributes['useAngularFormatting']) ||
            column.type === 'rich' ||
            column.type === 'richFull' ||
            column.type === 'enum' ||
            column.type === 'array' ||
            column.customTemplate;
        return !templateOverridden;
    }
    /**
     * method that can manipulated data returned from the service/dataloaders
     * Called just after results received from  getItemsGetterObservable
     * Result of that method is assigned to {@link fetchedData} property
     * @param result
     * @protected
     */
    async prepareFetchedData(result) {
        if (this.configurator.fetchedDataHandler) {
            return await this.configurator.fetchedDataHandler(result);
        }
        return result;
    }
    /**
     * Method that is called just after {@link prepareFetchedData}
     * Should apply state onto the data. Default implementation uses Kendo's process method
     * Method also assigns processedData property
     * @protected
     */
    assignProcessedData() {
        this.processedData = {
            data: process(this.fetchedData.data, {
                filter: this.state.filter,
                group: this.state.group,
                sort: this.state.sort
            }).data,
            total: this.fetchedData.count
        };
    }
    /**
     * Called when {@link state} is changed.
     * Depending on the configuration it will either call {@link fetch} or {@link assignProcessedData}
     * @protected
     */
    applyDataStateChange() {
        if (this.configurator.applyStateChangeLocally) {
            if (this.fetchedData.data.length !== this.fetchedData.count &&
                this.configurator.throwOnDataLengthMismatch) {
                throw new Error('applyStateChangeLocally option should only be used if all the list data is loaded (no server site pagination)');
            }
            this.assignProcessedData();
        }
        else {
            this.fetch();
        }
    }
    generateSelectedItems() {
        if (!this.baseComponent ||
            !this.selectedItemsKeys ||
            this.selectedItemsKeys.length === 0) {
            return undefined;
        }
        let gridData = this.getDataView();
        if (this.state.group && this.state.group.length > 0) {
            gridData = _.flatten(gridData.map((e) => e.items));
        }
        return this.selectedItemsKeys?.map((e) => gridData.find((item, index) => _.isEqual(this.getSelectionKey(item), e)));
    }
    showAdvancedFilters() {
        const dialogRef = this.openDialog(this.configurator.advancedFiltersBuilderComponentType ||
            BaseEntityListFilterBuilderComponent, {
            title: 'Filter Builder',
            actions: [{ text: 'Cancel' }, { text: 'Apply', themeColor: 'primary' }]
        });
        const component = dialogRef.content
            .instance;
        const subs = component.filterValueChange.subscribe((e) => this.filterChange(e));
        component.baseList = this;
        dialogRef.result.subscribe((e) => {
            if (e.text === 'Apply') {
                component.applyFilter();
            }
            subs.unsubscribe();
        });
    }
    toggleGroupsExpand() {
        this.groupsInitiallyExpanded = !this.groupsInitiallyExpanded;
    }
    toggleFiltersRow() {
        this._shouldShowFilterRow = !this._shouldShowFilterRow;
        this.setupFilterableSettings(this._shouldShowFilterRow);
    }
    clearFilters() {
        this.searchText = '';
        this.filterChange({ logic: 'and', filters: [] });
    }
    async secureGrid() {
        if (this.configurator.secureGridHandler) {
            this.configurator.securityConfig =
                await this.configurator.secureGridHandler(this);
        }
        this.visibleActions = this.getVisibleActions();
    }
    setupFilterableSettings(shouldShowRow) {
        if (this.configurator.filtersSettings === undefined) {
            return;
        }
        let showMenu = false;
        let showRow;
        let rowToggleable;
        let showAdvanced = false;
        if (typeof this.configurator.filtersSettings == 'boolean') {
            showRow = this.configurator.filtersSettings;
            rowToggleable = this.configurator.filtersSettings;
        }
        else {
            showRow = !!this.configurator.filtersSettings.row;
            rowToggleable = this.configurator.filtersSettings.row === 'toggleable';
            showMenu = !!this.configurator.filtersSettings.menu;
            showAdvanced = !!this.configurator.filtersSettings.advancedFilters;
        }
        if (rowToggleable) {
            showRow =
                shouldShowRow !== undefined && rowToggleable ? shouldShowRow : showRow;
        }
        this.filterableSettings = this.getFilterableSettings(showRow, showMenu);
        this.configurator.showActions.showAdvancedFilters =
            this.configurator.showActions.showAdvancedFilters === undefined
                ? showAdvanced
                    ? 100
                    : -1
                : this.configurator.showActions.showAdvancedFilters;
        if (this.configurator.showActions.showAdvancedFilters) {
            this.configurator.showActions.clearFilters =
                this.configurator.showActions.clearFilters === undefined
                    ? this.configurator.showActions.showAdvancedFilters
                    : this.configurator.showActions.clearFilters;
        }
        this.baseActions.toggleFilters.icon = showRow ? 'filter-clear' : 'filter';
    }
    setupActions() {
        if (this.configurator.actions) {
            _.each(this.configurator.actions, (value, key, collection) => {
                // @ts-ignore
                if (value === undefined || value === true || value === false) {
                    return;
                }
                if (this.baseActions[key]) {
                    this.baseActions[key] = _.assign(this.baseActions[key], value);
                }
                else {
                    this.actions = this.actions || {};
                    const a = { id: key, ...value };
                    a.onClick = this.customActionHandler(a).bind(this);
                    this.actions[key] = a;
                }
            });
        }
        this.visibleActions = this.getVisibleActions();
    }
    customActionHandler(action) {
        if (!this.configurator.customActionClicked) {
            throw new Error('Custom Action Clicked handle requested but not provided in configurator.');
        }
        return (dropdownItem) => this.configurator.customActionClicked({
            action,
            dropdownItemClicked: dropdownItem
        });
    }
    getItemsGetterObservable(state, forceAllRecords) {
        function getData(service) {
            return forceAllRecords
                ? fromPromise(service.getAllRecursive(state)).pipe(map((e) => ({ data: e, count: e.length })))
                : service.getAllPaginated(state);
        }
        state = state || this.state;
        if (state && state.sort) {
            const serverOrderBy = state.sort.filter((e) => this.configurator.getColumnByField(e.field)?.sortable !== 'clientOnly');
            if (serverOrderBy.length !== state.sort.length) {
                state = _.cloneDeep(state);
                state.sort = serverOrderBy;
            }
        }
        if (this.configurator.dataLoaderType === 'baseApiService') {
            if (!this.configurator.dataLoaderService &&
                !this.configurator.dataLoaderServiceType) {
                throw new Error("Configurator with dataLoaderType==='baseApiService' has to have dataLoaderService or dataLoaderServiceType property provided.");
            }
            return {
                data: getData(this.configurator.dataLoaderService ||
                    appInjector().get(this.configurator.dataLoaderServiceType)),
                count: (this.configurator.dataLoaderService ||
                    appInjector().get(this.configurator.dataLoaderServiceType)).count(state)
            };
        }
        if (this.configurator.dataLoaderType === 'custom') {
            if (!this.configurator.dataLoaderFunction) {
                throw new Error("Configurator with dataLoaderType==='custom' has to have dataLoaderFunction provided.");
            }
            const sharedDataLoader = this.configurator
                .dataLoaderFunction(state, forceAllRecords)
                .pipe(shareReplay({
                bufferSize: 1,
                refCount: true
            }));
            return {
                data: sharedDataLoader,
                count: this.configurator.countLoaderFunction
                    ? this.configurator.countLoaderFunction(state)
                    : sharedDataLoader.pipe(map((res) => res.count))
            };
        }
        throw new Error('Not supported grid configuration.');
    }
    getVisibleActions() {
        const visibleEditActions = {};
        if (this.canEdit &&
            this.configurator.editableSettings.actionButtonsPlacement.default !==
                'custom') {
            if (this.actionHandler.isEditing()) {
                visibleEditActions.add = false;
                visibleEditActions.edit = false;
                visibleEditActions.cancel = this.isHandlerOfType('cancel', 'gridActionsInToolbar');
                visibleEditActions.save = this.isHandlerOfType('save', 'gridActionsInToolbar');
            }
            else {
                visibleEditActions.add = true;
                visibleEditActions.edit = this.isHandlerOfType('edit', 'gridActionsInToolbar');
                visibleEditActions.delete = this.isHandlerOfType('delete', 'gridActionsInToolbar');
            }
        }
        if (!this.canEdit && this.canDelete) {
            visibleEditActions.delete = this.isHandlerOfType('delete', 'gridActionsInToolbar');
        }
        const editActions = _.map(visibleEditActions, (value, key, collection) => value ? this.baseActions[key] : undefined).filter((e) => e !== undefined);
        const baseVisibleActions = _.chain(this.configurator.showActions)
            .map((value, key, collection) => {
            if (value !== undefined && value >= 0) {
                return {
                    action: (this.actions || {})[key] || this.baseActions[key],
                    order: value
                };
            }
            return undefined;
        })
            .filter((e) => e !== undefined)
            .orderBy((e) => e?.order)
            .map((e) => e?.action)
            .value();
        return _.uniq(editActions.concat(baseVisibleActions));
    }
    setPropertiesFromConfigurator() {
        this.state = this.configurator.initialState
            ? _.cloneDeep(this.configurator.initialState)
            : this.state;
        this.groupsInitiallyExpanded = this.configurator.initiallyExpanded;
    }
    applyCaseSensitivity(filter) {
        const newFilters = _.cloneDeep(filter);
        const allFilters = flatten(newFilters);
        for (const filter of allFilters) {
            if (filter.ignoreCase !== undefined) {
                continue;
            }
            const columnConfig = (this.configurator.columns || []).find((column) => column.field === filter.field);
            if (!columnConfig) {
                filter.ignoreCase = true;
                continue;
            }
            if (columnConfig.attributes && columnConfig.attributes.caseSensitive)
                continue;
            if (columnConfig.type &&
                columnConfig.type !== 'default' &&
                columnConfig.type !== 'rich' &&
                columnConfig.type !== 'richFull')
                continue;
            filter.ignoreCase = true;
        }
        return newFilters;
    }
    setupColumns() {
        this._currentColumns = this.configurator.columns;
        this.configurator.columns?.forEach((c) => {
            if (this.configurator.getCustomColumnTemplate) {
                c.customTemplate =
                    c.customTemplate ||
                        this.configurator.getCustomColumnTemplate(c) ||
                        undefined;
            }
            c.useKendoTemplate = this.shouldColumnCellUseDefaultKendoTemplate(c);
        });
    }
    setupActiveActions() {
        this.baseActions.deleteSelected.disabled =
            this.selectedItemsKeys?.length === 0;
        this.baseActions.delete.disabled = this.selectedItemsKeys?.length === 0;
        this.baseActions.edit.disabled = this.selectedItemsKeys?.length !== 1;
        [
            this.baseActions.delete,
            this.baseActions.deleteSelected,
            this.baseActions.edit
        ].forEach((action) => {
            if (this.visibleActions.indexOf(action) >= 0 &&
                this.configurator.securityConfig?.checkPermissionPerSelection) {
                if (action === this.baseActions.edit) {
                    action.permissionAction = PermissionActions.Delete;
                }
                action.permissionOrEntity = this.selectedItems;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityListComponent, deps: [{ token: i1.Router }, { token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseEntityListComponent, selector: "app-base-entity-list", inputs: { toolbarTemplate: "toolbarTemplate", selectedItemsKeys: "selectedItemsKeys", configurator: "configurator", searchHandler: "searchHandler" }, outputs: { selectedItemsKeysChange: "selectedItemsKeysChange", selectedItemsChange: "selectedItemsChange", dataStateChanged: "dataStateChanged" }, viewQueries: [{ propertyName: "baseComponentQuery", predicate: ["baseList"], descendants: true }], ngImport: i0, template: '<div>Base List Component. Override template in your implementation!!!.</div>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-entity-list',
                    template: '<div>Base List Component. Override template in your implementation!!!.</div>'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1.ActivatedRoute }]; }, propDecorators: { baseComponentQuery: [{
                type: ViewChildren,
                args: ['baseList']
            }], toolbarTemplate: [{
                type: Input
            }], selectedItemsKeysChange: [{
                type: Output
            }], selectedItemsChange: [{
                type: Output
            }], dataStateChanged: [{
                type: Output
            }], selectedItemsKeys: [{
                type: Input
            }], configurator: [{
                type: Input
            }], searchHandler: [{
                type: Input
            }] } });

class BaseEntityHierarchicalListComponent extends BaseEntityListComponent {
    static fetchChildren(component, $event) {
        if (component.configurator.dataBindingType !== 'custom') {
            throw new Error('FetchChildren called in BaseTreeViewDropdownComponent - but dataBindingType not set to custom.');
        }
        if (!component.configurator?.fetchChildren) {
            throw new Error('Configurator for BaseTreeViewDropdownComponent was not passed or fetchChildren method in configurator not provided. Please either provide fetchChildren method or set the dataBindingType to type that does not require configurator.');
        }
        return component.configurator.fetchChildren($event);
    }
    static hasChildren(component, $event) {
        if (component.configurator.dataBindingType !== 'custom') {
            throw new Error('FetchChildren called in BaseTreeViewDropdownComponent - but dataBindingType not set to custom.');
        }
        if (!component.configurator?.hasChildren) {
            throw new Error('Configurator for BaseTreeViewDropdownComponent was not passed or hasChildren method in configurator not provided. Please either provide fetchChildren method or set the dataBindingType to type that does not require configurator.');
        }
        return component.configurator.hasChildren($event);
    }
    fetchChildren($event) {
        return BaseEntityHierarchicalListComponent.fetchChildren(this, $event);
    }
    hasChildren($event) {
        return BaseEntityHierarchicalListComponent.hasChildren(this, $event);
    }
    assignProcessedData() {
        if (this.configurator.dataBindingType !== 'custom') {
            this.processedData = this.fetchedData.data;
            return;
        }
        super.assignProcessedData();
    }
    applyDataStateChange() {
        if (this.configurator.dataBindingType !== 'custom') {
            return;
        }
        super.applyDataStateChange();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityHierarchicalListComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseEntityHierarchicalListComponent, selector: "app-base-entity-hierarchy-list", usesInheritance: true, ngImport: i0, template: '<div>Base Entity hierarchy List Component. Override template in your implementation!!!.</div>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseEntityHierarchicalListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-base-entity-hierarchy-list',
                    template: '<div>Base Entity hierarchy List Component. Override template in your implementation!!!.</div>'
                }]
        }] });

class PlTemplateLibraryComponent {
    templateLibraryService;
    templatesQuery;
    context;
    override;
    templatesAdded = new EventEmitter();
    constructor(templateLibraryService) {
        this.templateLibraryService = templateLibraryService;
    }
    ngAfterContentInit() {
        this.templateLibraryService.add(this.context, this.templatesQuery.map((e) => ({
            template: e,
            keys: e._declarationTContainer.localNames.filter((i) => i !== -1)
        })), this.override);
        this.templatesAdded.emit();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlTemplateLibraryComponent, deps: [{ token: TemplateLibraryService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlTemplateLibraryComponent, selector: "pl-lib-pl-template-library", inputs: { context: "context", override: "override" }, outputs: { templatesAdded: "templatesAdded" }, queries: [{ propertyName: "templatesQuery", predicate: TemplateRef, read: TemplateRef }], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlTemplateLibraryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lib-pl-template-library', template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: TemplateLibraryService }]; }, propDecorators: { templatesQuery: [{
                type: ContentChildren,
                args: [TemplateRef, { read: TemplateRef }]
            }], context: [{
                type: Input
            }], override: [{
                type: Input
            }], templatesAdded: [{
                type: Output
            }] } });

class BaseObservablesFeedbackComponent {
    dialog;
    observables;
    autoClose;
    results = [];
    runningItems;
    destroyed$ = new Subject();
    constructor(dialog) {
        this.dialog = dialog;
    }
    static mapObservablesToResults(observables) {
        return observables.map((oi) => {
            const id = v4();
            return {
                correlationId: id,
                input: oi,
                observable: oi.observable.pipe(map((e) => ({
                    correlationId: id,
                    success: true,
                    context: oi.context,
                    result: e
                })), catchError((e) => {
                    if (oi.errorHandler) {
                        const m = oi.errorHandler(e, oi);
                        return of({
                            correlationId: id,
                            success: !!m.result,
                            error: e,
                            context: oi.context,
                            result: m.result,
                            errorHandlerResult: m
                        });
                    }
                    return of({
                        correlationId: id,
                        success: false,
                        error: e,
                        context: e.context
                    });
                }))
            };
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
    }
    ngOnInit() {
        const r = BaseObservablesFeedbackComponent.mapObservablesToResults(this.observables);
        this.runningItems = r.map((o) => ({
            status: 'inProgress',
            hideDismissButton: true,
            message: o.input.text,
            correlationId: o.correlationId
        }));
        const runningItemsById = _.keyBy(this.runningItems, 'correlationId');
        const inputsById = _.keyBy(r, 'correlationId');
        merge(...r.map((e) => e.observable))
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
            next: (e) => {
                this.results.push(e);
                const m = runningItemsById[e.correlationId];
                const input = inputsById[e.correlationId].input;
                m.status = e.success ? 'success' : 'error';
                m.message = e.success ? input.successText : input.failedText;
                m.details = e.error;
                if (e.errorHandlerResult) {
                    _.merge(e.errorHandlerResult.message, _.merge(m, e.errorHandlerResult.message));
                    runningItemsById[e.correlationId] = e.errorHandlerResult.message;
                    this.runningItems = _.values(runningItemsById);
                }
                if (this.autoClose &&
                    this.runningItems.filter((i) => i.status === 'success').length ===
                        this.runningItems.length &&
                    this.dialog) {
                    this.dialog.close();
                }
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseObservablesFeedbackComponent, deps: [{ token: i5.DialogRef, optional: true }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BaseObservablesFeedbackComponent, selector: "pl-lib-base-observables-feedback-component", inputs: { observables: "observables", autoClose: "autoClose" }, ngImport: i0, template: "<pl-feedback-bar [messages]=\"runningItems\"></pl-feedback-bar>", styles: [":host{max-height:100%;overflow:auto}pl-feedback-bar{margin:2rem;min-width:500px}\n"], dependencies: [{ kind: "component", type: FeedbackBarComponent, selector: "pl-feedback-bar", inputs: ["messages"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseObservablesFeedbackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lib-base-observables-feedback-component', template: "<pl-feedback-bar [messages]=\"runningItems\"></pl-feedback-bar>", styles: [":host{max-height:100%;overflow:auto}pl-feedback-bar{margin:2rem;min-width:500px}\n"] }]
        }], ctorParameters: function () { return [{ type: i5.DialogRef, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { observables: [{
                type: Input
            }], autoClose: [{
                type: Input
            }] } });

class PlCodeViewerComponent {
    code;
    language = 'json';
    copyable;
    showLineNumbers;
    codeWithPre;
    highlighted = false;
    defaultLanguage = 'json';
    ngOnChanges(changes) {
        if (changes['code'] &&
            // changes['code'].firstChange &&
            changes['code'].currentValue) {
            this.highlighted = false;
            this.codeWithPre = `<pre class="${this.showLineNumbers ? 'line-numbers' : ''} language-${this.language ?? this.defaultLanguage}"><code>${this.code}</code></pre>`;
        }
    }
    ngAfterViewChecked() {
        if (!this.highlighted && this.code) {
            Prism.highlightAll();
            this.highlighted = true;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCodeViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlCodeViewerComponent, selector: "pl-code-viewer", inputs: { code: "code", language: "language", copyable: "copyable", showLineNumbers: "showLineNumbers" }, usesOnChanges: true, ngImport: i0, template: `<div *ngIf="code" [innerHTML]="codeWithPre"></div>`, isInline: true, styles: [":host{width:-moz-fit-content;width:fit-content}code[class*=language-],pre[class*=language-]{color:#000;background:none;text-shadow:0 1px white;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;line-height:1.5;tab-size:4;hyphens:none}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{text-shadow:none;background:#b3d4fc}@media print{code[class*=language-],pre[class*=language-]{text-shadow:none}}pre[class*=language-]{padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#f5f2f0}:not(pre)>code[class*=language-]{padding:.1em;border-radius:.3em;white-space:normal}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#708090}.token.punctuation{color:#999}.token.namespace{opacity:.7}.token.property,.token.tag,.token.boolean,.token.number,.token.constant,.token.symbol,.token.deleted{color:#905}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#690}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string{color:#9a6e3a;background:#ffffff80}.token.atrule,.token.attr-value,.token.keyword{color:#07a}.token.function,.token.class-name{color:#dd4a68}.token.regex,.token.important,.token.variable{color:#e90}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}div.code-toolbar{position:relative}div.code-toolbar>.toolbar{position:absolute;z-index:10;top:.3em;right:.2em;transition:opacity .3s ease-in-out;opacity:0}div.code-toolbar:hover>.toolbar{opacity:1}div.code-toolbar:focus-within>.toolbar{opacity:1}div.code-toolbar>.toolbar>.toolbar-item{display:inline-block}div.code-toolbar>.toolbar>.toolbar-item>a{cursor:pointer}div.code-toolbar>.toolbar>.toolbar-item>button{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}div.code-toolbar>.toolbar>.toolbar-item>a,div.code-toolbar>.toolbar>.toolbar-item>button,div.code-toolbar>.toolbar>.toolbar-item>span{color:#bbb;font-size:.8em;padding:0 .5em;background:#f5f2f0;background:#e0e0e033;box-shadow:0 2px #0003;border-radius:.5em}div.code-toolbar>.toolbar>.toolbar-item>a:hover,div.code-toolbar>.toolbar>.toolbar-item>a:focus,div.code-toolbar>.toolbar>.toolbar-item>button:hover,div.code-toolbar>.toolbar>.toolbar-item>button:focus,div.code-toolbar>.toolbar>.toolbar-item>span:hover,div.code-toolbar>.toolbar>.toolbar-item>span:focus{color:inherit;text-decoration:none}pre[class*=language-].line-numbers{position:relative;padding-left:3.8em;counter-reset:linenumber}pre[class*=language-].line-numbers>code{position:relative;white-space:inherit}.line-numbers .line-numbers-rows{position:absolute;pointer-events:none;top:0;font-size:100%;left:-3.8em;width:3em;letter-spacing:-1px;border-right:1px solid #999;-webkit-user-select:none;user-select:none}.line-numbers-rows>span{display:block;counter-increment:linenumber}.line-numbers-rows>span:before{content:counter(linenumber);color:#999;display:block;padding-right:.8em;text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCodeViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-code-viewer', template: `<div *ngIf="code" [innerHTML]="codeWithPre"></div>`, encapsulation: ViewEncapsulation.None, styles: [":host{width:-moz-fit-content;width:fit-content}code[class*=language-],pre[class*=language-]{color:#000;background:none;text-shadow:0 1px white;font-family:Consolas,Monaco,Andale Mono,Ubuntu Mono,monospace;font-size:1em;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;word-wrap:normal;line-height:1.5;tab-size:4;hyphens:none}pre[class*=language-]::selection,pre[class*=language-] ::selection,code[class*=language-]::selection,code[class*=language-] ::selection{text-shadow:none;background:#b3d4fc}@media print{code[class*=language-],pre[class*=language-]{text-shadow:none}}pre[class*=language-]{padding:1em;overflow:auto}:not(pre)>code[class*=language-],pre[class*=language-]{background:#f5f2f0}:not(pre)>code[class*=language-]{padding:.1em;border-radius:.3em;white-space:normal}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#708090}.token.punctuation{color:#999}.token.namespace{opacity:.7}.token.property,.token.tag,.token.boolean,.token.number,.token.constant,.token.symbol,.token.deleted{color:#905}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#690}.token.operator,.token.entity,.token.url,.language-css .token.string,.style .token.string{color:#9a6e3a;background:#ffffff80}.token.atrule,.token.attr-value,.token.keyword{color:#07a}.token.function,.token.class-name{color:#dd4a68}.token.regex,.token.important,.token.variable{color:#e90}.token.important,.token.bold{font-weight:700}.token.italic{font-style:italic}.token.entity{cursor:help}div.code-toolbar{position:relative}div.code-toolbar>.toolbar{position:absolute;z-index:10;top:.3em;right:.2em;transition:opacity .3s ease-in-out;opacity:0}div.code-toolbar:hover>.toolbar{opacity:1}div.code-toolbar:focus-within>.toolbar{opacity:1}div.code-toolbar>.toolbar>.toolbar-item{display:inline-block}div.code-toolbar>.toolbar>.toolbar-item>a{cursor:pointer}div.code-toolbar>.toolbar>.toolbar-item>button{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}div.code-toolbar>.toolbar>.toolbar-item>a,div.code-toolbar>.toolbar>.toolbar-item>button,div.code-toolbar>.toolbar>.toolbar-item>span{color:#bbb;font-size:.8em;padding:0 .5em;background:#f5f2f0;background:#e0e0e033;box-shadow:0 2px #0003;border-radius:.5em}div.code-toolbar>.toolbar>.toolbar-item>a:hover,div.code-toolbar>.toolbar>.toolbar-item>a:focus,div.code-toolbar>.toolbar>.toolbar-item>button:hover,div.code-toolbar>.toolbar>.toolbar-item>button:focus,div.code-toolbar>.toolbar>.toolbar-item>span:hover,div.code-toolbar>.toolbar>.toolbar-item>span:focus{color:inherit;text-decoration:none}pre[class*=language-].line-numbers{position:relative;padding-left:3.8em;counter-reset:linenumber}pre[class*=language-].line-numbers>code{position:relative;white-space:inherit}.line-numbers .line-numbers-rows{position:absolute;pointer-events:none;top:0;font-size:100%;left:-3.8em;width:3em;letter-spacing:-1px;border-right:1px solid #999;-webkit-user-select:none;user-select:none}.line-numbers-rows>span{display:block;counter-increment:linenumber}.line-numbers-rows>span:before{content:counter(linenumber);color:#999;display:block;padding-right:.8em;text-align:right}\n"] }]
        }], propDecorators: { code: [{
                type: Input
            }], language: [{
                type: Input
            }], copyable: [{
                type: Input
            }], showLineNumbers: [{
                type: Input
            }] } });

class PlCodeDiffComponent {
    diffService;
    old;
    current;
    filename = '';
    format = 'side-by-side';
    style = 'word';
    diffChange = new EventEmitter();
    diff;
    diffHTML;
    constructor(diffService) {
        this.diffService = diffService;
    }
    ngOnInit() {
        this.getDiff();
    }
    ngOnChanges(changes) {
        if (this.propHasChanged(changes['old']) ||
            this.propHasChanged(changes['current'])) {
            this.getDiff();
        }
        else if (this.propHasChanged(changes['style']) ||
            this.propHasChanged(changes['format'])) {
            this.refreshDiffHTML();
        }
    }
    propHasChanged(change) {
        return (change &&
            !change.isFirstChange() &&
            change.currentValue !== change.previousValue);
    }
    getDiff() {
        this.diff = this.diffService.getDiff(this.old, this.current, this.filename);
        this.refreshDiffHTML();
        this.diffChange.emit(this.diff);
    }
    refreshDiffHTML() {
        this.diffHTML = this.diffService.diffToHTML(this.diff, this.format, this.style);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCodeDiffComponent, deps: [{ token: CodeDiffService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlCodeDiffComponent, selector: "pl-diff-viewer", inputs: { old: "old", current: "current", filename: "filename", format: "format", style: "style" }, outputs: { diffChange: "diffChange" }, usesOnChanges: true, ngImport: i0, template: `<div [innerHtml]="diffHTML | safe: 'html'"></div>`, isInline: true, styles: [".d2h-file-header{display:none}\n", ":root{--d2h-bg-color:#fff;--d2h-border-color:#ddd;--d2h-dim-color:rgba(0,0,0,.3);--d2h-line-border-color:#eee;--d2h-file-header-bg-color:#f7f7f7;--d2h-file-header-border-color:#d8d8d8;--d2h-empty-placeholder-bg-color:#f1f1f1;--d2h-empty-placeholder-border-color:#e1e1e1;--d2h-selected-color:#c8e1ff;--d2h-ins-bg-color:#dfd;--d2h-ins-border-color:#b4e2b4;--d2h-ins-highlight-bg-color:#97f295;--d2h-ins-label-color:#399839;--d2h-del-bg-color:#fee8e9;--d2h-del-border-color:#e9aeae;--d2h-del-highlight-bg-color:#ffb6ba;--d2h-del-label-color:#c33;--d2h-change-del-color:#fdf2d0;--d2h-change-ins-color:#ded;--d2h-info-bg-color:#f8fafd;--d2h-info-border-color:#d5e4f2;--d2h-change-label-color:#d0b44c;--d2h-moved-label-color:#3572b0;--d2h-dark-color:#e6edf3;--d2h-dark-bg-color:#0d1117;--d2h-dark-border-color:#30363d;--d2h-dark-dim-color:#6e7681;--d2h-dark-line-border-color:#21262d;--d2h-dark-file-header-bg-color:#161b22;--d2h-dark-file-header-border-color:#30363d;--d2h-dark-empty-placeholder-bg-color:hsla(215,8%,47%,.1);--d2h-dark-empty-placeholder-border-color:#30363d;--d2h-dark-selected-color:rgba(56,139,253,.1);--d2h-dark-ins-bg-color:rgba(46,160,67,.15);--d2h-dark-ins-border-color:rgba(46,160,67,.4);--d2h-dark-ins-highlight-bg-color:rgba(46,160,67,.4);--d2h-dark-ins-label-color:#3fb950;--d2h-dark-del-bg-color:rgba(248,81,73,.1);--d2h-dark-del-border-color:rgba(248,81,73,.4);--d2h-dark-del-highlight-bg-color:rgba(248,81,73,.4);--d2h-dark-del-label-color:#f85149;--d2h-dark-change-del-color:rgba(210,153,34,.2);--d2h-dark-change-ins-color:rgba(46,160,67,.25);--d2h-dark-info-bg-color:rgba(56,139,253,.1);--d2h-dark-info-border-color:rgba(56,139,253,.4);--d2h-dark-change-label-color:#d29922;--d2h-dark-moved-label-color:#3572b0}.d2h-wrapper{text-align:left}.d2h-file-header{background-color:#f7f7f7;background-color:var(--d2h-file-header-bg-color);border-bottom:1px solid #d8d8d8;border-bottom:1px solid var(--d2h-file-header-border-color);display:flex;font-family:Source Sans Pro,Helvetica Neue,Helvetica,Arial,sans-serif;height:35px;padding:5px 10px}.d2h-file-header.d2h-sticky-header{position:sticky;top:0;z-index:1}.d2h-file-stats{display:flex;font-size:14px;margin-left:auto}.d2h-lines-added{border:1px solid #b4e2b4;border:1px solid var(--d2h-ins-border-color);border-radius:5px 0 0 5px;color:#399839;color:var(--d2h-ins-label-color);padding:2px;text-align:right;vertical-align:middle}.d2h-lines-deleted{border:1px solid #e9aeae;border:1px solid var(--d2h-del-border-color);border-radius:0 5px 5px 0;color:#c33;color:var(--d2h-del-label-color);margin-left:1px;padding:2px;text-align:left;vertical-align:middle}.d2h-file-name-wrapper{align-items:center;display:flex;font-size:15px;width:100%}.d2h-file-name{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}.d2h-file-wrapper{border:1px solid #ddd;border:1px solid var(--d2h-border-color);border-radius:3px;margin-bottom:1em}.d2h-file-collapse{-webkit-box-pack:end;-ms-flex-pack:end;align-items:center;border:1px solid #ddd;border:1px solid var(--d2h-border-color);border-radius:3px;cursor:pointer;display:none;font-size:12px;justify-content:flex-end;padding:4px 8px}.d2h-file-collapse.d2h-selected{background-color:#c8e1ff;background-color:var(--d2h-selected-color)}.d2h-file-collapse-input{margin:0 4px 0 0}.d2h-diff-table{border-collapse:collapse;font-family:Menlo,Consolas,monospace;font-size:13px;width:100%}.d2h-files-diff{display:flex;width:100%}.d2h-file-diff{overflow-y:hidden}.d2h-file-diff.d2h-d-none,.d2h-files-diff.d2h-d-none{display:none}.d2h-file-side-diff{display:inline-block;overflow-x:scroll;overflow-y:hidden;width:50%}.d2h-code-line{padding:0 8em;width:calc(100% - 16em)}.d2h-code-line,.d2h-code-side-line{display:inline-block;-webkit-user-select:none;user-select:none;white-space:nowrap}.d2h-code-side-line{padding:0 4.5em;width:calc(100% - 9em)}.d2h-code-line-ctn{word-wrap:normal;background:none;display:inline-block;padding:0;-webkit-user-select:text;user-select:text;vertical-align:middle;white-space:pre;width:100%}.d2h-code-line del,.d2h-code-side-line del{background-color:#ffb6ba;background-color:var(--d2h-del-highlight-bg-color)}.d2h-code-line del,.d2h-code-line ins,.d2h-code-side-line del,.d2h-code-side-line ins{border-radius:.2em;display:inline-block;margin-top:-1px;-webkit-text-decoration:none;text-decoration:none}.d2h-code-line ins,.d2h-code-side-line ins{background-color:#97f295;background-color:var(--d2h-ins-highlight-bg-color);text-align:left}.d2h-code-line-prefix{word-wrap:normal;background:none;display:inline;padding:0;white-space:pre}.line-num1{float:left}.line-num1,.line-num2{box-sizing:border-box;overflow:hidden;padding:0 .5em;text-overflow:ellipsis;width:3.5em}.line-num2{float:right}.d2h-code-linenumber{background-color:#fff;background-color:var(--d2h-bg-color);border:solid #eee;border:solid var(--d2h-line-border-color);border-width:0 1px;box-sizing:border-box;color:#0000004d;color:var(--d2h-dim-color);cursor:pointer;display:inline-block;position:absolute;text-align:right;width:7.5em}.d2h-code-linenumber:after{content:\"\\200b\"}.d2h-code-side-linenumber{background-color:#fff;background-color:var(--d2h-bg-color);border:solid #eee;border:solid var(--d2h-line-border-color);border-width:0 1px;box-sizing:border-box;color:#0000004d;color:var(--d2h-dim-color);cursor:pointer;display:inline-block;overflow:hidden;padding:0 .5em;position:absolute;text-align:right;text-overflow:ellipsis;width:4em}.d2h-code-side-linenumber:after{content:\"\\200b\"}.d2h-code-side-emptyplaceholder,.d2h-emptyplaceholder{background-color:#f1f1f1;background-color:var(--d2h-empty-placeholder-bg-color);border-color:#e1e1e1;border-color:var(--d2h-empty-placeholder-border-color)}.d2h-code-line-prefix,.d2h-code-linenumber,.d2h-code-side-linenumber,.d2h-emptyplaceholder{-webkit-user-select:none;user-select:none}.d2h-code-linenumber,.d2h-code-side-linenumber{direction:rtl}.d2h-del{background-color:#fee8e9;background-color:var(--d2h-del-bg-color);border-color:#e9aeae;border-color:var(--d2h-del-border-color)}.d2h-ins{background-color:#dfd;background-color:var(--d2h-ins-bg-color);border-color:#b4e2b4;border-color:var(--d2h-ins-border-color)}.d2h-info{background-color:#f8fafd;background-color:var(--d2h-info-bg-color);border-color:#d5e4f2;border-color:var(--d2h-info-border-color);color:#0000004d;color:var(--d2h-dim-color)}.d2h-file-diff .d2h-del.d2h-change{background-color:#fdf2d0;background-color:var(--d2h-change-del-color)}.d2h-file-diff .d2h-ins.d2h-change{background-color:#ded;background-color:var(--d2h-change-ins-color)}.d2h-file-list-wrapper{margin-bottom:10px}.d2h-file-list-wrapper a{-webkit-text-decoration:none;text-decoration:none}.d2h-file-list-wrapper a,.d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-moved-label-color)}.d2h-file-list-header{text-align:left}.d2h-file-list-title{font-weight:700}.d2h-file-list-line{display:flex;text-align:left}.d2h-file-list{display:block;list-style:none;margin:0;padding:0}.d2h-file-list>li{border-bottom:1px solid #ddd;border-bottom:1px solid var(--d2h-border-color);margin:0;padding:5px 10px}.d2h-file-list>li:last-child{border-bottom:none}.d2h-file-switch{cursor:pointer;display:none;font-size:10px}.d2h-icon{fill:currentColor;margin-right:10px;vertical-align:middle}.d2h-deleted{color:#c33;color:var(--d2h-del-label-color)}.d2h-added{color:#399839;color:var(--d2h-ins-label-color)}.d2h-changed{color:#d0b44c;color:var(--d2h-change-label-color)}.d2h-moved{color:#3572b0;color:var(--d2h-moved-label-color)}.d2h-tag{background-color:#fff;background-color:var(--d2h-bg-color);display:flex;font-size:10px;margin-left:5px;padding:0 2px}.d2h-deleted-tag{border:1px solid #c33;border:1px solid var(--d2h-del-label-color)}.d2h-added-tag{border:1px solid #399839;border:1px solid var(--d2h-ins-label-color)}.d2h-changed-tag{border:1px solid #d0b44c;border:1px solid var(--d2h-change-label-color)}.d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-moved-label-color)}.d2h-dark-color-scheme{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);color:#e6edf3;color:var(--d2h-dark-color)}.d2h-dark-color-scheme .d2h-file-header{background-color:#161b22;background-color:var(--d2h-dark-file-header-bg-color);border-bottom:#30363d;border-bottom:var(--d2h-dark-file-header-border-color)}.d2h-dark-color-scheme .d2h-lines-added{border:1px solid rgba(46,160,67,.4);border:1px solid var(--d2h-dark-ins-border-color);color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-lines-deleted{border:1px solid rgba(248,81,73,.4);border:1px solid var(--d2h-dark-del-border-color);color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-code-line del,.d2h-dark-color-scheme .d2h-code-side-line del{background-color:#f8514966;background-color:var(--d2h-dark-del-highlight-bg-color)}.d2h-dark-color-scheme .d2h-code-line ins,.d2h-dark-color-scheme .d2h-code-side-line ins{background-color:#2ea04366;background-color:var(--d2h-dark-ins-highlight-bg-color)}.d2h-dark-color-scheme .d2h-diff-tbody{border-color:#30363d;border-color:var(--d2h-dark-border-color)}.d2h-dark-color-scheme .d2h-code-side-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-files-diff .d2h-code-side-emptyplaceholder,.d2h-dark-color-scheme .d2h-files-diff .d2h-emptyplaceholder{background-color:#6e76811a;background-color:var(--d2h-dark-empty-placeholder-bg-color);border-color:#30363d;border-color:var(--d2h-dark-empty-placeholder-border-color)}.d2h-dark-color-scheme .d2h-code-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-del{background-color:#f851491a;background-color:var(--d2h-dark-del-bg-color);border-color:#f8514966;border-color:var(--d2h-dark-del-border-color)}.d2h-dark-color-scheme .d2h-ins{background-color:#2ea04326;background-color:var(--d2h-dark-ins-bg-color);border-color:#2ea04366;border-color:var(--d2h-dark-ins-border-color)}.d2h-dark-color-scheme .d2h-info{background-color:#388bfd1a;background-color:var(--d2h-dark-info-bg-color);border-color:#388bfd66;border-color:var(--d2h-dark-info-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-file-diff .d2h-del.d2h-change{background-color:#d2992233;background-color:var(--d2h-dark-change-del-color)}.d2h-dark-color-scheme .d2h-file-diff .d2h-ins.d2h-change{background-color:#2ea04340;background-color:var(--d2h-dark-change-ins-color)}.d2h-dark-color-scheme .d2h-file-wrapper{border:1px solid #30363d;border:1px solid var(--d2h-dark-border-color)}.d2h-dark-color-scheme .d2h-file-collapse{border:1px solid #0d1117;border:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-file-collapse.d2h-selected{background-color:#388bfd1a;background-color:var(--d2h-dark-selected-color)}.d2h-dark-color-scheme .d2h-file-list-wrapper a,.d2h-dark-color-scheme .d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-dark-color-scheme .d2h-file-list>li{border-bottom:1px solid #0d1117;border-bottom:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted{color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-added{color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-changed{color:#d29922;color:var(--d2h-dark-change-label-color)}.d2h-dark-color-scheme .d2h-moved{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-dark-color-scheme .d2h-tag{background-color:#0d1117;background-color:var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted-tag{border:1px solid #f85149;border:1px solid var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-added-tag{border:1px solid #3fb950;border:1px solid var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-changed-tag{border:1px solid #d29922;border:1px solid var(--d2h-dark-change-label-color)}.d2h-dark-color-scheme .d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-dark-moved-label-color)}@media (prefers-color-scheme:dark){.d2h-auto-color-scheme{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);color:#e6edf3;color:var(--d2h-dark-color)}.d2h-auto-color-scheme .d2h-file-header{background-color:#161b22;background-color:var(--d2h-dark-file-header-bg-color);border-bottom:#30363d;border-bottom:var(--d2h-dark-file-header-border-color)}.d2h-auto-color-scheme .d2h-lines-added{border:1px solid rgba(46,160,67,.4);border:1px solid var(--d2h-dark-ins-border-color);color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-lines-deleted{border:1px solid rgba(248,81,73,.4);border:1px solid var(--d2h-dark-del-border-color);color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-code-line del,.d2h-auto-color-scheme .d2h-code-side-line del{background-color:#f8514966;background-color:var(--d2h-dark-del-highlight-bg-color)}.d2h-auto-color-scheme .d2h-code-line ins,.d2h-auto-color-scheme .d2h-code-side-line ins{background-color:#2ea04366;background-color:var(--d2h-dark-ins-highlight-bg-color)}.d2h-auto-color-scheme .d2h-diff-tbody{border-color:#30363d;border-color:var(--d2h-dark-border-color)}.d2h-auto-color-scheme .d2h-code-side-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-files-diff .d2h-code-side-emptyplaceholder,.d2h-auto-color-scheme .d2h-files-diff .d2h-emptyplaceholder{background-color:#6e76811a;background-color:var(--d2h-dark-empty-placeholder-bg-color);border-color:#30363d;border-color:var(--d2h-dark-empty-placeholder-border-color)}.d2h-auto-color-scheme .d2h-code-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-del{background-color:#f851491a;background-color:var(--d2h-dark-del-bg-color);border-color:#f8514966;border-color:var(--d2h-dark-del-border-color)}.d2h-auto-color-scheme .d2h-ins{background-color:#2ea04326;background-color:var(--d2h-dark-ins-bg-color);border-color:#2ea04366;border-color:var(--d2h-dark-ins-border-color)}.d2h-auto-color-scheme .d2h-info{background-color:#388bfd1a;background-color:var(--d2h-dark-info-bg-color);border-color:#388bfd66;border-color:var(--d2h-dark-info-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-file-diff .d2h-del.d2h-change{background-color:#d2992233;background-color:var(--d2h-dark-change-del-color)}.d2h-auto-color-scheme .d2h-file-diff .d2h-ins.d2h-change{background-color:#2ea04340;background-color:var(--d2h-dark-change-ins-color)}.d2h-auto-color-scheme .d2h-file-wrapper{border:1px solid #30363d;border:1px solid var(--d2h-dark-border-color)}.d2h-auto-color-scheme .d2h-file-collapse{border:1px solid #0d1117;border:1px solid var(--d2h-dark-bg-color)}.d2h-auto-color-scheme .d2h-file-collapse.d2h-selected{background-color:#388bfd1a;background-color:var(--d2h-dark-selected-color)}.d2h-auto-color-scheme .d2h-file-list-wrapper a,.d2h-auto-color-scheme .d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-auto-color-scheme .d2h-file-list>li{border-bottom:1px solid #0d1117;border-bottom:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted{color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-added{color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-changed{color:#d29922;color:var(--d2h-dark-change-label-color)}.d2h-auto-color-scheme .d2h-moved{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-auto-color-scheme .d2h-tag{background-color:#0d1117;background-color:var(--d2h-dark-bg-color)}.d2h-auto-color-scheme .d2h-deleted-tag{border:1px solid #f85149;border:1px solid var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-added-tag{border:1px solid #3fb950;border:1px solid var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-changed-tag{border:1px solid #d29922;border:1px solid var(--d2h-dark-change-label-color)}.d2h-auto-color-scheme .d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-dark-moved-label-color)}}\n"], dependencies: [{ kind: "pipe", type: SafePipe, name: "safe" }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCodeDiffComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-diff-viewer', template: `<div [innerHtml]="diffHTML | safe: 'html'"></div>`, encapsulation: ViewEncapsulation.None, styles: [".d2h-file-header{display:none}\n", ":root{--d2h-bg-color:#fff;--d2h-border-color:#ddd;--d2h-dim-color:rgba(0,0,0,.3);--d2h-line-border-color:#eee;--d2h-file-header-bg-color:#f7f7f7;--d2h-file-header-border-color:#d8d8d8;--d2h-empty-placeholder-bg-color:#f1f1f1;--d2h-empty-placeholder-border-color:#e1e1e1;--d2h-selected-color:#c8e1ff;--d2h-ins-bg-color:#dfd;--d2h-ins-border-color:#b4e2b4;--d2h-ins-highlight-bg-color:#97f295;--d2h-ins-label-color:#399839;--d2h-del-bg-color:#fee8e9;--d2h-del-border-color:#e9aeae;--d2h-del-highlight-bg-color:#ffb6ba;--d2h-del-label-color:#c33;--d2h-change-del-color:#fdf2d0;--d2h-change-ins-color:#ded;--d2h-info-bg-color:#f8fafd;--d2h-info-border-color:#d5e4f2;--d2h-change-label-color:#d0b44c;--d2h-moved-label-color:#3572b0;--d2h-dark-color:#e6edf3;--d2h-dark-bg-color:#0d1117;--d2h-dark-border-color:#30363d;--d2h-dark-dim-color:#6e7681;--d2h-dark-line-border-color:#21262d;--d2h-dark-file-header-bg-color:#161b22;--d2h-dark-file-header-border-color:#30363d;--d2h-dark-empty-placeholder-bg-color:hsla(215,8%,47%,.1);--d2h-dark-empty-placeholder-border-color:#30363d;--d2h-dark-selected-color:rgba(56,139,253,.1);--d2h-dark-ins-bg-color:rgba(46,160,67,.15);--d2h-dark-ins-border-color:rgba(46,160,67,.4);--d2h-dark-ins-highlight-bg-color:rgba(46,160,67,.4);--d2h-dark-ins-label-color:#3fb950;--d2h-dark-del-bg-color:rgba(248,81,73,.1);--d2h-dark-del-border-color:rgba(248,81,73,.4);--d2h-dark-del-highlight-bg-color:rgba(248,81,73,.4);--d2h-dark-del-label-color:#f85149;--d2h-dark-change-del-color:rgba(210,153,34,.2);--d2h-dark-change-ins-color:rgba(46,160,67,.25);--d2h-dark-info-bg-color:rgba(56,139,253,.1);--d2h-dark-info-border-color:rgba(56,139,253,.4);--d2h-dark-change-label-color:#d29922;--d2h-dark-moved-label-color:#3572b0}.d2h-wrapper{text-align:left}.d2h-file-header{background-color:#f7f7f7;background-color:var(--d2h-file-header-bg-color);border-bottom:1px solid #d8d8d8;border-bottom:1px solid var(--d2h-file-header-border-color);display:flex;font-family:Source Sans Pro,Helvetica Neue,Helvetica,Arial,sans-serif;height:35px;padding:5px 10px}.d2h-file-header.d2h-sticky-header{position:sticky;top:0;z-index:1}.d2h-file-stats{display:flex;font-size:14px;margin-left:auto}.d2h-lines-added{border:1px solid #b4e2b4;border:1px solid var(--d2h-ins-border-color);border-radius:5px 0 0 5px;color:#399839;color:var(--d2h-ins-label-color);padding:2px;text-align:right;vertical-align:middle}.d2h-lines-deleted{border:1px solid #e9aeae;border:1px solid var(--d2h-del-border-color);border-radius:0 5px 5px 0;color:#c33;color:var(--d2h-del-label-color);margin-left:1px;padding:2px;text-align:left;vertical-align:middle}.d2h-file-name-wrapper{align-items:center;display:flex;font-size:15px;width:100%}.d2h-file-name{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}.d2h-file-wrapper{border:1px solid #ddd;border:1px solid var(--d2h-border-color);border-radius:3px;margin-bottom:1em}.d2h-file-collapse{-webkit-box-pack:end;-ms-flex-pack:end;align-items:center;border:1px solid #ddd;border:1px solid var(--d2h-border-color);border-radius:3px;cursor:pointer;display:none;font-size:12px;justify-content:flex-end;padding:4px 8px}.d2h-file-collapse.d2h-selected{background-color:#c8e1ff;background-color:var(--d2h-selected-color)}.d2h-file-collapse-input{margin:0 4px 0 0}.d2h-diff-table{border-collapse:collapse;font-family:Menlo,Consolas,monospace;font-size:13px;width:100%}.d2h-files-diff{display:flex;width:100%}.d2h-file-diff{overflow-y:hidden}.d2h-file-diff.d2h-d-none,.d2h-files-diff.d2h-d-none{display:none}.d2h-file-side-diff{display:inline-block;overflow-x:scroll;overflow-y:hidden;width:50%}.d2h-code-line{padding:0 8em;width:calc(100% - 16em)}.d2h-code-line,.d2h-code-side-line{display:inline-block;-webkit-user-select:none;user-select:none;white-space:nowrap}.d2h-code-side-line{padding:0 4.5em;width:calc(100% - 9em)}.d2h-code-line-ctn{word-wrap:normal;background:none;display:inline-block;padding:0;-webkit-user-select:text;user-select:text;vertical-align:middle;white-space:pre;width:100%}.d2h-code-line del,.d2h-code-side-line del{background-color:#ffb6ba;background-color:var(--d2h-del-highlight-bg-color)}.d2h-code-line del,.d2h-code-line ins,.d2h-code-side-line del,.d2h-code-side-line ins{border-radius:.2em;display:inline-block;margin-top:-1px;-webkit-text-decoration:none;text-decoration:none}.d2h-code-line ins,.d2h-code-side-line ins{background-color:#97f295;background-color:var(--d2h-ins-highlight-bg-color);text-align:left}.d2h-code-line-prefix{word-wrap:normal;background:none;display:inline;padding:0;white-space:pre}.line-num1{float:left}.line-num1,.line-num2{box-sizing:border-box;overflow:hidden;padding:0 .5em;text-overflow:ellipsis;width:3.5em}.line-num2{float:right}.d2h-code-linenumber{background-color:#fff;background-color:var(--d2h-bg-color);border:solid #eee;border:solid var(--d2h-line-border-color);border-width:0 1px;box-sizing:border-box;color:#0000004d;color:var(--d2h-dim-color);cursor:pointer;display:inline-block;position:absolute;text-align:right;width:7.5em}.d2h-code-linenumber:after{content:\"\\200b\"}.d2h-code-side-linenumber{background-color:#fff;background-color:var(--d2h-bg-color);border:solid #eee;border:solid var(--d2h-line-border-color);border-width:0 1px;box-sizing:border-box;color:#0000004d;color:var(--d2h-dim-color);cursor:pointer;display:inline-block;overflow:hidden;padding:0 .5em;position:absolute;text-align:right;text-overflow:ellipsis;width:4em}.d2h-code-side-linenumber:after{content:\"\\200b\"}.d2h-code-side-emptyplaceholder,.d2h-emptyplaceholder{background-color:#f1f1f1;background-color:var(--d2h-empty-placeholder-bg-color);border-color:#e1e1e1;border-color:var(--d2h-empty-placeholder-border-color)}.d2h-code-line-prefix,.d2h-code-linenumber,.d2h-code-side-linenumber,.d2h-emptyplaceholder{-webkit-user-select:none;user-select:none}.d2h-code-linenumber,.d2h-code-side-linenumber{direction:rtl}.d2h-del{background-color:#fee8e9;background-color:var(--d2h-del-bg-color);border-color:#e9aeae;border-color:var(--d2h-del-border-color)}.d2h-ins{background-color:#dfd;background-color:var(--d2h-ins-bg-color);border-color:#b4e2b4;border-color:var(--d2h-ins-border-color)}.d2h-info{background-color:#f8fafd;background-color:var(--d2h-info-bg-color);border-color:#d5e4f2;border-color:var(--d2h-info-border-color);color:#0000004d;color:var(--d2h-dim-color)}.d2h-file-diff .d2h-del.d2h-change{background-color:#fdf2d0;background-color:var(--d2h-change-del-color)}.d2h-file-diff .d2h-ins.d2h-change{background-color:#ded;background-color:var(--d2h-change-ins-color)}.d2h-file-list-wrapper{margin-bottom:10px}.d2h-file-list-wrapper a{-webkit-text-decoration:none;text-decoration:none}.d2h-file-list-wrapper a,.d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-moved-label-color)}.d2h-file-list-header{text-align:left}.d2h-file-list-title{font-weight:700}.d2h-file-list-line{display:flex;text-align:left}.d2h-file-list{display:block;list-style:none;margin:0;padding:0}.d2h-file-list>li{border-bottom:1px solid #ddd;border-bottom:1px solid var(--d2h-border-color);margin:0;padding:5px 10px}.d2h-file-list>li:last-child{border-bottom:none}.d2h-file-switch{cursor:pointer;display:none;font-size:10px}.d2h-icon{fill:currentColor;margin-right:10px;vertical-align:middle}.d2h-deleted{color:#c33;color:var(--d2h-del-label-color)}.d2h-added{color:#399839;color:var(--d2h-ins-label-color)}.d2h-changed{color:#d0b44c;color:var(--d2h-change-label-color)}.d2h-moved{color:#3572b0;color:var(--d2h-moved-label-color)}.d2h-tag{background-color:#fff;background-color:var(--d2h-bg-color);display:flex;font-size:10px;margin-left:5px;padding:0 2px}.d2h-deleted-tag{border:1px solid #c33;border:1px solid var(--d2h-del-label-color)}.d2h-added-tag{border:1px solid #399839;border:1px solid var(--d2h-ins-label-color)}.d2h-changed-tag{border:1px solid #d0b44c;border:1px solid var(--d2h-change-label-color)}.d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-moved-label-color)}.d2h-dark-color-scheme{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);color:#e6edf3;color:var(--d2h-dark-color)}.d2h-dark-color-scheme .d2h-file-header{background-color:#161b22;background-color:var(--d2h-dark-file-header-bg-color);border-bottom:#30363d;border-bottom:var(--d2h-dark-file-header-border-color)}.d2h-dark-color-scheme .d2h-lines-added{border:1px solid rgba(46,160,67,.4);border:1px solid var(--d2h-dark-ins-border-color);color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-lines-deleted{border:1px solid rgba(248,81,73,.4);border:1px solid var(--d2h-dark-del-border-color);color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-code-line del,.d2h-dark-color-scheme .d2h-code-side-line del{background-color:#f8514966;background-color:var(--d2h-dark-del-highlight-bg-color)}.d2h-dark-color-scheme .d2h-code-line ins,.d2h-dark-color-scheme .d2h-code-side-line ins{background-color:#2ea04366;background-color:var(--d2h-dark-ins-highlight-bg-color)}.d2h-dark-color-scheme .d2h-diff-tbody{border-color:#30363d;border-color:var(--d2h-dark-border-color)}.d2h-dark-color-scheme .d2h-code-side-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-files-diff .d2h-code-side-emptyplaceholder,.d2h-dark-color-scheme .d2h-files-diff .d2h-emptyplaceholder{background-color:#6e76811a;background-color:var(--d2h-dark-empty-placeholder-bg-color);border-color:#30363d;border-color:var(--d2h-dark-empty-placeholder-border-color)}.d2h-dark-color-scheme .d2h-code-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-del{background-color:#f851491a;background-color:var(--d2h-dark-del-bg-color);border-color:#f8514966;border-color:var(--d2h-dark-del-border-color)}.d2h-dark-color-scheme .d2h-ins{background-color:#2ea04326;background-color:var(--d2h-dark-ins-bg-color);border-color:#2ea04366;border-color:var(--d2h-dark-ins-border-color)}.d2h-dark-color-scheme .d2h-info{background-color:#388bfd1a;background-color:var(--d2h-dark-info-bg-color);border-color:#388bfd66;border-color:var(--d2h-dark-info-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-dark-color-scheme .d2h-file-diff .d2h-del.d2h-change{background-color:#d2992233;background-color:var(--d2h-dark-change-del-color)}.d2h-dark-color-scheme .d2h-file-diff .d2h-ins.d2h-change{background-color:#2ea04340;background-color:var(--d2h-dark-change-ins-color)}.d2h-dark-color-scheme .d2h-file-wrapper{border:1px solid #30363d;border:1px solid var(--d2h-dark-border-color)}.d2h-dark-color-scheme .d2h-file-collapse{border:1px solid #0d1117;border:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-file-collapse.d2h-selected{background-color:#388bfd1a;background-color:var(--d2h-dark-selected-color)}.d2h-dark-color-scheme .d2h-file-list-wrapper a,.d2h-dark-color-scheme .d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-dark-color-scheme .d2h-file-list>li{border-bottom:1px solid #0d1117;border-bottom:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted{color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-added{color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-changed{color:#d29922;color:var(--d2h-dark-change-label-color)}.d2h-dark-color-scheme .d2h-moved{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-dark-color-scheme .d2h-tag{background-color:#0d1117;background-color:var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted-tag{border:1px solid #f85149;border:1px solid var(--d2h-dark-del-label-color)}.d2h-dark-color-scheme .d2h-added-tag{border:1px solid #3fb950;border:1px solid var(--d2h-dark-ins-label-color)}.d2h-dark-color-scheme .d2h-changed-tag{border:1px solid #d29922;border:1px solid var(--d2h-dark-change-label-color)}.d2h-dark-color-scheme .d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-dark-moved-label-color)}@media (prefers-color-scheme:dark){.d2h-auto-color-scheme{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);color:#e6edf3;color:var(--d2h-dark-color)}.d2h-auto-color-scheme .d2h-file-header{background-color:#161b22;background-color:var(--d2h-dark-file-header-bg-color);border-bottom:#30363d;border-bottom:var(--d2h-dark-file-header-border-color)}.d2h-auto-color-scheme .d2h-lines-added{border:1px solid rgba(46,160,67,.4);border:1px solid var(--d2h-dark-ins-border-color);color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-lines-deleted{border:1px solid rgba(248,81,73,.4);border:1px solid var(--d2h-dark-del-border-color);color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-code-line del,.d2h-auto-color-scheme .d2h-code-side-line del{background-color:#f8514966;background-color:var(--d2h-dark-del-highlight-bg-color)}.d2h-auto-color-scheme .d2h-code-line ins,.d2h-auto-color-scheme .d2h-code-side-line ins{background-color:#2ea04366;background-color:var(--d2h-dark-ins-highlight-bg-color)}.d2h-auto-color-scheme .d2h-diff-tbody{border-color:#30363d;border-color:var(--d2h-dark-border-color)}.d2h-auto-color-scheme .d2h-code-side-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-files-diff .d2h-code-side-emptyplaceholder,.d2h-auto-color-scheme .d2h-files-diff .d2h-emptyplaceholder{background-color:#6e76811a;background-color:var(--d2h-dark-empty-placeholder-bg-color);border-color:#30363d;border-color:var(--d2h-dark-empty-placeholder-border-color)}.d2h-auto-color-scheme .d2h-code-linenumber{background-color:#0d1117;background-color:var(--d2h-dark-bg-color);border-color:#21262d;border-color:var(--d2h-dark-line-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-del{background-color:#f851491a;background-color:var(--d2h-dark-del-bg-color);border-color:#f8514966;border-color:var(--d2h-dark-del-border-color)}.d2h-auto-color-scheme .d2h-ins{background-color:#2ea04326;background-color:var(--d2h-dark-ins-bg-color);border-color:#2ea04366;border-color:var(--d2h-dark-ins-border-color)}.d2h-auto-color-scheme .d2h-info{background-color:#388bfd1a;background-color:var(--d2h-dark-info-bg-color);border-color:#388bfd66;border-color:var(--d2h-dark-info-border-color);color:#6e7681;color:var(--d2h-dark-dim-color)}.d2h-auto-color-scheme .d2h-file-diff .d2h-del.d2h-change{background-color:#d2992233;background-color:var(--d2h-dark-change-del-color)}.d2h-auto-color-scheme .d2h-file-diff .d2h-ins.d2h-change{background-color:#2ea04340;background-color:var(--d2h-dark-change-ins-color)}.d2h-auto-color-scheme .d2h-file-wrapper{border:1px solid #30363d;border:1px solid var(--d2h-dark-border-color)}.d2h-auto-color-scheme .d2h-file-collapse{border:1px solid #0d1117;border:1px solid var(--d2h-dark-bg-color)}.d2h-auto-color-scheme .d2h-file-collapse.d2h-selected{background-color:#388bfd1a;background-color:var(--d2h-dark-selected-color)}.d2h-auto-color-scheme .d2h-file-list-wrapper a,.d2h-auto-color-scheme .d2h-file-list-wrapper a:visited{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-auto-color-scheme .d2h-file-list>li{border-bottom:1px solid #0d1117;border-bottom:1px solid var(--d2h-dark-bg-color)}.d2h-dark-color-scheme .d2h-deleted{color:#f85149;color:var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-added{color:#3fb950;color:var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-changed{color:#d29922;color:var(--d2h-dark-change-label-color)}.d2h-auto-color-scheme .d2h-moved{color:#3572b0;color:var(--d2h-dark-moved-label-color)}.d2h-auto-color-scheme .d2h-tag{background-color:#0d1117;background-color:var(--d2h-dark-bg-color)}.d2h-auto-color-scheme .d2h-deleted-tag{border:1px solid #f85149;border:1px solid var(--d2h-dark-del-label-color)}.d2h-auto-color-scheme .d2h-added-tag{border:1px solid #3fb950;border:1px solid var(--d2h-dark-ins-label-color)}.d2h-auto-color-scheme .d2h-changed-tag{border:1px solid #d29922;border:1px solid var(--d2h-dark-change-label-color)}.d2h-auto-color-scheme .d2h-moved-tag{border:1px solid #3572b0;border:1px solid var(--d2h-dark-moved-label-color)}}\n"] }]
        }], ctorParameters: function () { return [{ type: CodeDiffService }]; }, propDecorators: { old: [{
                type: Input
            }], current: [{
                type: Input
            }], filename: [{
                type: Input
            }], format: [{
                type: Input
            }], style: [{
                type: Input
            }], diffChange: [{
                type: Output
            }] } });

class ProcessStageBarComponent {
    /**
     * the stages to show in the bar
     */
    processStages;
    buttonProps;
    onButtonClick = new EventEmitter();
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProcessStageBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ProcessStageBarComponent, selector: "pl-process-stage-bar", inputs: { processStages: "processStages", buttonProps: "buttonProps" }, outputs: { onButtonClick: "onButtonClick" }, ngImport: i0, template: "<div class=\"container\">\n  <div class=\"process-stages\">\n    <ng-container *ngFor=\"let ps of processStages\">\n      <div\n        class=\"process-stage\"\n        [title]=\"ps.tooltipText\"\n        kendoTooltip\n        [tooltipTemplate]=\"template\"\n      >\n      <ng-template #template >{{ps.tooltipText}}</ng-template>\n        <div\n          class=\"status\"\n          [ngClass]=\"{\n            'status-submitted': ps.status === 'submitted',\n            'status-pending': ps.status === 'pending'\n          }\"\n        ></div>\n        <h2>{{ ps.season }}</h2>\n        <div>\n          <p>{{ ps.text1 }}</p>\n          <p>{{ ps.text2 }}</p>\n        </div>\n        <pl-icon type=\"kendo\" [icon]=\"ps.icon\" size=\"16px\"></pl-icon>\n      </div>\n    </ng-container>\n  </div>\n  <pl-button\n    [themeColor]=\"buttonProps.themeColor\"\n    (onClick)=\"onButtonClick.emit($event)\"\n    size=\"small\"\n  >\n    {{ buttonProps.text }}\n  </pl-button>\n</div>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.container{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:4px 10px;gap:12px;overflow-x:auto}.process-stages{display:flex}.process-stages .process-stage{height:44px;min-width:140px;display:flex;gap:4px;align-items:center;cursor:pointer}.process-stages .process-stage:nth-child(1){opacity:.4}.process-stages .process-stage h2{transform:rotate(-90deg);font-size:larger}.process-stages .process-stage p{font-size:12px;line-height:5px}.process-stages .process-stage p:nth-child(2){font-size:10px}.process-stages .process-stage .status{width:2px;height:100%;display:block;border-left:2px solid}.process-stages .process-stage .status-pending{border-color:#6c757d;border-left-style:dotted}.process-stages .process-stage .status-submitted{border-color:#00ff87}.process-stages .process-stage pl-icon{opacity:.2}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "component", type: PlIconComponent, selector: "pl-icon", inputs: ["type", "icon", "size", "color", "src"] }, { kind: "component", type: PlButtonComponent, selector: "pl-button", inputs: ["themeColor", "fillMode", "disabled", "size", "rounded", "icon", "title", "ignoreBreakpoint", "hoverMode", "tooltip", "ignoreMobileStyle"], outputs: ["onClick"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProcessStageBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-process-stage-bar', template: "<div class=\"container\">\n  <div class=\"process-stages\">\n    <ng-container *ngFor=\"let ps of processStages\">\n      <div\n        class=\"process-stage\"\n        [title]=\"ps.tooltipText\"\n        kendoTooltip\n        [tooltipTemplate]=\"template\"\n      >\n      <ng-template #template >{{ps.tooltipText}}</ng-template>\n        <div\n          class=\"status\"\n          [ngClass]=\"{\n            'status-submitted': ps.status === 'submitted',\n            'status-pending': ps.status === 'pending'\n          }\"\n        ></div>\n        <h2>{{ ps.season }}</h2>\n        <div>\n          <p>{{ ps.text1 }}</p>\n          <p>{{ ps.text2 }}</p>\n        </div>\n        <pl-icon type=\"kendo\" [icon]=\"ps.icon\" size=\"16px\"></pl-icon>\n      </div>\n    </ng-container>\n  </div>\n  <pl-button\n    [themeColor]=\"buttonProps.themeColor\"\n    (onClick)=\"onButtonClick.emit($event)\"\n    size=\"small\"\n  >\n    {{ buttonProps.text }}\n  </pl-button>\n</div>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.container{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:4px 10px;gap:12px;overflow-x:auto}.process-stages{display:flex}.process-stages .process-stage{height:44px;min-width:140px;display:flex;gap:4px;align-items:center;cursor:pointer}.process-stages .process-stage:nth-child(1){opacity:.4}.process-stages .process-stage h2{transform:rotate(-90deg);font-size:larger}.process-stages .process-stage p{font-size:12px;line-height:5px}.process-stages .process-stage p:nth-child(2){font-size:10px}.process-stages .process-stage .status{width:2px;height:100%;display:block;border-left:2px solid}.process-stages .process-stage .status-pending{border-color:#6c757d;border-left-style:dotted}.process-stages .process-stage .status-submitted{border-color:#00ff87}.process-stages .process-stage pl-icon{opacity:.2}\n"] }]
        }], propDecorators: { processStages: [{
                type: Input
            }], buttonProps: [{
                type: Input
            }], onButtonClick: [{
                type: Output
            }] } });

class PlCardComponent {
    headerTemplate;
    noHeader = false;
    title = '';
    icon;
    themeColor;
    get isSuccess() { return this.themeColor === 'success'; }
    ;
    get isWarning() { return this.themeColor === 'warning'; }
    ;
    get isError() { return this.themeColor === 'error'; }
    ;
    constructor() { }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlCardComponent, selector: "pl-card", inputs: { headerTemplate: "headerTemplate", noHeader: "noHeader", title: "title", icon: "icon", themeColor: "themeColor" }, host: { properties: { "class.success": "this.isSuccess", "class.warning": "this.isWarning", "class.error": "this.isError" } }, ngImport: i0, template: "\n<ng-container *ngIf=\"!noHeader\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate ? headerTemplate : defaultHeader; context:{ title, icon }\"></ng-container>\n</ng-container>\n<div class=\"body\">\n    <ng-content></ng-content>\n</div>\n\n<ng-template #defaultHeader>\n    <div class=\"header\">\n        <img [src]=\"icon\" class=\"h-5\" />\n        <span class=\"title\">{{title}}</span>\n    </div>\n</ng-template>", styles: [":host{display:flex;flex-direction:column;position:relative;overflow:hidden;border-style:solid;box-sizing:border-box;outline:0;background:var(--kendo-component-bg, initial);color:var(--kendo-component-text, initial);border-color:var(--kendo-component-border, initial);border-width:1px;border-radius:var(--kendo-card-border-radius, .375rem);font-size:var(--kendo-font-size, inherit);line-height:var(--kendo-line-height, normal);padding:12px}:host.success{border-color:var(--kendo-success-100, initial);background:var(--tb-kendo-success-10, initial)}:host.warning{border-color:var(--kendo-warning-100, initial);background:var(--kendo-warning-10, initial)}:host.error{border-color:var(--kendo-error-100, initial);background:var(--kendo-error-10, initial)}:host .body{padding:1rem}:host .header{display:flex;flex:1;width:100%;align-items:center;border-bottom:1px solid var(--kendo-component-border, initial);padding-bottom:8px;margin-bottom:8px}:host .header img{padding-right:6px;max-height:1.25rem}:host .title{font-weight:700;font-size:16px;flex:1}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-card', template: "\n<ng-container *ngIf=\"!noHeader\">\n    <ng-container *ngTemplateOutlet=\"headerTemplate ? headerTemplate : defaultHeader; context:{ title, icon }\"></ng-container>\n</ng-container>\n<div class=\"body\">\n    <ng-content></ng-content>\n</div>\n\n<ng-template #defaultHeader>\n    <div class=\"header\">\n        <img [src]=\"icon\" class=\"h-5\" />\n        <span class=\"title\">{{title}}</span>\n    </div>\n</ng-template>", styles: [":host{display:flex;flex-direction:column;position:relative;overflow:hidden;border-style:solid;box-sizing:border-box;outline:0;background:var(--kendo-component-bg, initial);color:var(--kendo-component-text, initial);border-color:var(--kendo-component-border, initial);border-width:1px;border-radius:var(--kendo-card-border-radius, .375rem);font-size:var(--kendo-font-size, inherit);line-height:var(--kendo-line-height, normal);padding:12px}:host.success{border-color:var(--kendo-success-100, initial);background:var(--tb-kendo-success-10, initial)}:host.warning{border-color:var(--kendo-warning-100, initial);background:var(--kendo-warning-10, initial)}:host.error{border-color:var(--kendo-error-100, initial);background:var(--kendo-error-10, initial)}:host .body{padding:1rem}:host .header{display:flex;flex:1;width:100%;align-items:center;border-bottom:1px solid var(--kendo-component-border, initial);padding-bottom:8px;margin-bottom:8px}:host .header img{padding-right:6px;max-height:1.25rem}:host .title{font-weight:700;font-size:16px;flex:1}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { headerTemplate: [{
                type: Input
            }], noHeader: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], themeColor: [{
                type: Input
            }], isSuccess: [{
                type: HostBinding,
                args: ['class.success']
            }], isWarning: [{
                type: HostBinding,
                args: ['class.warning']
            }], isError: [{
                type: HostBinding,
                args: ['class.error']
            }] } });

class BrandedBannerComponent {
    banner;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BrandedBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BrandedBannerComponent, selector: "pl-branded-banner", inputs: { banner: "banner" }, ngImport: i0, template: "<header class=\"banner\" [ngClass]=\"banner.background\">\n  <img [src]=\"banner.logoUrl\" />\n  <h1 class=\"title\">{{ banner.title }}</h1>\n</header>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.blue-graphic{background-image:url(https://www.premierleague.com/resources/v1.0.9/i/svg-files/elements/backgrounds/brand-vector-wide-lighter.svg);background-size:cover}.blue-graphic:after{content:\"\";position:absolute;inset:0;background:linear-gradient(90deg,#953bff,#05f0ff)!important;z-index:-1;border-radius:10px}.banner{position:relative;display:flex;align-items:center;padding:20px;color:#37003c;border:2px solid white;border-radius:10px}.banner img{height:40px;margin-right:20px}.banner .title{font-family:PremierLeague,Arial,sans-serif;font-weight:900;line-height:1;font-size:32px;margin:0;color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BrandedBannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-branded-banner', template: "<header class=\"banner\" [ngClass]=\"banner.background\">\n  <img [src]=\"banner.logoUrl\" />\n  <h1 class=\"title\">{{ banner.title }}</h1>\n</header>\n", styles: [":root{--pl-nav-item-box-shadow: 0 0 0 #FFF;--pl-sidebar-color: $purple;--pl-sidebar-background: #FAFAFA}.blue-graphic{background-image:url(https://www.premierleague.com/resources/v1.0.9/i/svg-files/elements/backgrounds/brand-vector-wide-lighter.svg);background-size:cover}.blue-graphic:after{content:\"\";position:absolute;inset:0;background:linear-gradient(90deg,#953bff,#05f0ff)!important;z-index:-1;border-radius:10px}.banner{position:relative;display:flex;align-items:center;padding:20px;color:#37003c;border:2px solid white;border-radius:10px}.banner img{height:40px;margin-right:20px}.banner .title{font-family:PremierLeague,Arial,sans-serif;font-weight:900;line-height:1;font-size:32px;margin:0;color:#fff}\n"] }]
        }], propDecorators: { banner: [{
                type: Input
            }] } });

class UserPresenceComponent {
    users;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserPresenceComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: UserPresenceComponent, selector: "pl-lib-user-presence", inputs: { users: "users" }, ngImport: i0, template: "<div class=\"online-users-container\">\n  <div class=\"online-users-list\" [@userList]=\"users?.length\">\n    <ng-container *ngIf=\"users?.length\">\n      <div *ngFor=\"let user of users\" class=\"user-item\">\n        <div kendoTooltip title [tooltipTemplate]=\"template\">\n          <div\n            class=\"user-status\"\n            [attr.data-testid]=\"'user-status-' + user.id\"\n          >\n            {{ user.initials }}\n            <span\n              class=\"status-dot\"\n              [class.same-page]=\"user.isOnSamePage\"\n            ></span>\n          </div>\n          <ng-template #template>\n            <div class=\"tooltip-content\">\n              <div class=\"user-name\">{{ user.name }}</div>\n              <div class=\"user-email\"><a href=\"mailto:{{ user.email }}\">{{ user.email }}</a></div>\n              <div class=\"user-last-seen\">\n                <pl-icon type=\"kendo\" [icon]=\"'k-i-eye'\"></pl-icon>\n                {{ user.lastSeenFormatted }}\n              </div>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n", styles: [".online-users-container .online-users-list{display:flex;flex-direction:row;align-items:center;gap:.25rem;padding:0 .25rem;position:relative;min-height:32px}.online-users-container .online-users-list .user-item{display:flex;align-items:center;padding:0;cursor:pointer;position:relative}.online-users-container .online-users-list .user-item .user-status{cursor:pointer;display:inline-block;position:relative;width:32px;height:32px;background-color:#ff2882;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-size:12px;font-weight:500}.online-users-container .online-users-list .user-item .user-status .status-dot{position:absolute;bottom:-2px;right:-2px;display:inline-block;width:12px;height:12px;border-radius:50%;background-color:#4caf50;border:2px solid white}.online-users-container .online-users-list .user-item .user-status .status-dot.same-page{background-color:#2196f3;animation:pulse 2s infinite}.online-users-container .online-users-list .no-users{color:var(--pl-color-text-secondary);font-size:.9rem}::ng-deep .tooltip-content{padding:.25rem}::ng-deep .tooltip-content .user-name{font-weight:500;font-size:.9rem;margin-bottom:.25rem}::ng-deep .tooltip-content .user-email{font-size:.75rem;text-align:left}::ng-deep .tooltip-content .user-email a{text-decoration:none;color:#444}::ng-deep .tooltip-content .user-email a:hover{text-decoration:underline;cursor:pointer}::ng-deep .tooltip-content .user-last-seen{font-size:.75rem;color:#999;display:flex;align-items:center;gap:.25rem;justify-content:flex-end}::ng-deep .tooltip-content .same-page-indicator{font-size:.9rem;color:#2196f3;margin-top:.25rem}@keyframes pulse{0%{box-shadow:0 0 #2196f366}70%{box-shadow:0 0 0 6px #2196f300}to{box-shadow:0 0 #2196f300}}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.TooltipDirective, selector: "[kendoTooltip]", inputs: ["filter", "position", "titleTemplate", "showOn", "showAfter", "callout", "closable", "offset", "tooltipWidth", "tooltipHeight", "tooltipClass", "collision", "closeTitle", "tooltipTemplate"], exportAs: ["kendoTooltip"] }, { kind: "component", type: PlIconComponent, selector: "pl-icon", inputs: ["type", "icon", "size", "color", "src"] }], animations: [
            trigger('userList', [
                transition('* => *', [
                    query(':enter', [
                        style({ opacity: 0, transform: 'scale(0.8)' }),
                        stagger('60ms', [
                            animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
                        ])
                    ], { optional: true }),
                    query(':leave', [
                        animate('150ms ease-in', style({
                            opacity: 0,
                            transform: 'scale(0.8)',
                            position: 'absolute' // prevents layout shift during animation
                        }))
                    ], { optional: true })
                ])
            ])
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserPresenceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-lib-user-presence', animations: [
                        trigger('userList', [
                            transition('* => *', [
                                query(':enter', [
                                    style({ opacity: 0, transform: 'scale(0.8)' }),
                                    stagger('60ms', [
                                        animate('150ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
                                    ])
                                ], { optional: true }),
                                query(':leave', [
                                    animate('150ms ease-in', style({
                                        opacity: 0,
                                        transform: 'scale(0.8)',
                                        position: 'absolute' // prevents layout shift during animation
                                    }))
                                ], { optional: true })
                            ])
                        ])
                    ], template: "<div class=\"online-users-container\">\n  <div class=\"online-users-list\" [@userList]=\"users?.length\">\n    <ng-container *ngIf=\"users?.length\">\n      <div *ngFor=\"let user of users\" class=\"user-item\">\n        <div kendoTooltip title [tooltipTemplate]=\"template\">\n          <div\n            class=\"user-status\"\n            [attr.data-testid]=\"'user-status-' + user.id\"\n          >\n            {{ user.initials }}\n            <span\n              class=\"status-dot\"\n              [class.same-page]=\"user.isOnSamePage\"\n            ></span>\n          </div>\n          <ng-template #template>\n            <div class=\"tooltip-content\">\n              <div class=\"user-name\">{{ user.name }}</div>\n              <div class=\"user-email\"><a href=\"mailto:{{ user.email }}\">{{ user.email }}</a></div>\n              <div class=\"user-last-seen\">\n                <pl-icon type=\"kendo\" [icon]=\"'k-i-eye'\"></pl-icon>\n                {{ user.lastSeenFormatted }}\n              </div>\n            </div>\n          </ng-template>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n", styles: [".online-users-container .online-users-list{display:flex;flex-direction:row;align-items:center;gap:.25rem;padding:0 .25rem;position:relative;min-height:32px}.online-users-container .online-users-list .user-item{display:flex;align-items:center;padding:0;cursor:pointer;position:relative}.online-users-container .online-users-list .user-item .user-status{cursor:pointer;display:inline-block;position:relative;width:32px;height:32px;background-color:#ff2882;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-size:12px;font-weight:500}.online-users-container .online-users-list .user-item .user-status .status-dot{position:absolute;bottom:-2px;right:-2px;display:inline-block;width:12px;height:12px;border-radius:50%;background-color:#4caf50;border:2px solid white}.online-users-container .online-users-list .user-item .user-status .status-dot.same-page{background-color:#2196f3;animation:pulse 2s infinite}.online-users-container .online-users-list .no-users{color:var(--pl-color-text-secondary);font-size:.9rem}::ng-deep .tooltip-content{padding:.25rem}::ng-deep .tooltip-content .user-name{font-weight:500;font-size:.9rem;margin-bottom:.25rem}::ng-deep .tooltip-content .user-email{font-size:.75rem;text-align:left}::ng-deep .tooltip-content .user-email a{text-decoration:none;color:#444}::ng-deep .tooltip-content .user-email a:hover{text-decoration:underline;cursor:pointer}::ng-deep .tooltip-content .user-last-seen{font-size:.75rem;color:#999;display:flex;align-items:center;gap:.25rem;justify-content:flex-end}::ng-deep .tooltip-content .same-page-indicator{font-size:.9rem;color:#2196f3;margin-top:.25rem}@keyframes pulse{0%{box-shadow:0 0 #2196f366}70%{box-shadow:0 0 0 6px #2196f300}to{box-shadow:0 0 #2196f300}}\n"] }]
        }], propDecorators: { users: [{
                type: Input
            }] } });

/**
 * Service that manages step state for the card stepper component
 *
 * Features:
 * - Manages current active step
 * - Tracks completion status of each step
 * - Provides dynamic subtitles for steps
 * - Tracks validation states for form-based steps
 * - Exposes observable streams for reactive UI updates
 *
 * Validation States:
 * The service supports four validation states for each step:
 * - 'valid': Step content has been validated and is error-free
 * - 'invalid': Step content has validation errors that need to be fixed
 * - 'pending': Step validation is in progress (useful for async validation)
 * - null: Default state, no validation information available
 *
 * Visual indicators in the component will change based on these states:
 * - Valid steps show a styled checkmark
 * - Invalid steps show a warning icon
 * - Pending steps show a clock/time icon
 * - Null falls back to showing completion status or step number
 *
 * This service should be provided at the component level, not globally,
 * to allow multiple independent steppers in the same application.
 */
class StepIndicatorService {
    // Default steps moved to configuration
    baseSteps = [];
    currentStepSubject = new BehaviorSubject('');
    stepCompletionSubject = new BehaviorSubject({});
    stepSubtitlesSubject = new BehaviorSubject({});
    /**
     * Subject containing validation state for each step
     *
     * Maps each step ID to its current validation state:
     * - 'valid': Step has passed validation
     * - 'invalid': Step has validation errors
     * - 'pending': Validation in progress
     * - null: No validation information
     */
    stepValidationSubject = new BehaviorSubject({});
    config = {
        steps: [],
        initialStep: '',
        allowSkipSteps: false,
        animationDuration: 300
    };
    /**
     * Observable stream of all steps with current state
     *
     * This stream emits an array of steps with their current state (active, complete, subtitle)
     * based on the current step and completion state.
     */
    steps$ = combineLatest([
        this.currentStepSubject,
        this.stepCompletionSubject,
        this.stepSubtitlesSubject,
        this.stepValidationSubject
    ]).pipe(map$1(([currentStep, completionState, subtitles, validationState]) => this.baseSteps.map(step => ({
        ...step,
        isActive: step.id === currentStep,
        isComplete: completionState[step.id],
        subtitle: subtitles[step.id],
        validationState: validationState[step.id]
    }))));
    // Expose individual step state streams that components can directly subscribe to
    getStepState$(stepId) {
        return combineLatest([
            this.currentStepSubject,
            this.stepCompletionSubject,
            this.stepSubtitlesSubject,
            this.stepValidationSubject
        ]).pipe(map$1(([currentStep, completionState, subtitles, validationState]) => ({
            isActive: stepId === currentStep,
            isComplete: completionState[stepId],
            subtitle: subtitles[stepId],
            validationState: validationState[stepId]
        })));
    }
    currentStep$ = this.currentStepSubject.asObservable();
    constructor() {
    }
    /**
     * Initialize the stepper with a configuration
     *
     * @param config Configuration for this stepper instance
     */
    initialize(config) {
        this.config = { ...this.config, ...config };
        if (this.config.steps && this.config.steps.length > 0) {
            this.baseSteps = this.config.steps;
        }
        if (this.config.initialStep) {
            this.setStep(this.config.initialStep);
        }
        // Reset step states with all configured steps
        const completionState = {};
        const subtitleState = {};
        const validationState = {};
        this.baseSteps.forEach(step => {
            completionState[step.id] = false;
            subtitleState[step.id] = step.defaultSubtitle || '';
            validationState[step.id] = null;
        });
        this.stepCompletionSubject.next(completionState);
        this.stepSubtitlesSubject.next(subtitleState);
        this.stepValidationSubject.next(validationState);
    }
    /**
     * Set the current active step
     *
     * @param stepId ID of the step to set as current
     */
    setStep(stepId) {
        if (stepId !== this.currentStepSubject.value) {
            this.currentStepSubject.next(stepId);
        }
    }
    /**
     * Mark a step as complete or incomplete
     *
     * @param stepId ID of the step to mark
     * @param isComplete Whether the step is complete
     */
    markStepComplete(stepId, isComplete = true) {
        const currentState = this.stepCompletionSubject.value;
        if (currentState[stepId] !== isComplete) {
            this.stepCompletionSubject.next({
                ...currentState,
                [stepId]: isComplete
            });
        }
    }
    /**
     * Get the current step ID
     */
    get currentStep() {
        return this.currentStepSubject.value;
    }
    /**
     * Set the base steps (used for configuration)
     *
     * @param steps Array of step definitions
     */
    setSteps(steps) {
        this.baseSteps = steps;
    }
    /**
     * Get a snapshot of all steps with current state
     *
     * @returns Array of steps with current state applied
     */
    getSteps() {
        // Create a snapshot of current steps with all state applied
        const currentStep = this.currentStepSubject.value;
        const completionState = this.stepCompletionSubject.value;
        const subtitles = this.stepSubtitlesSubject.value;
        const validationState = this.stepValidationSubject.value;
        return this.baseSteps.map(step => ({
            ...step,
            isActive: step.id === currentStep,
            isComplete: completionState[step.id],
            subtitle: subtitles[step.id],
            validationState: validationState[step.id]
        }));
    }
    /**
     * Update the subtitle for a specific step
     *
     * @param stepId The ID of the step to update
     * @param subtitle The new subtitle text
     */
    updateStepSubtitle(stepId, subtitle) {
        const currentSubtitles = this.stepSubtitlesSubject.value;
        if (currentSubtitles[stepId] !== subtitle) {
            this.stepSubtitlesSubject.next({
                ...currentSubtitles,
                [stepId]: subtitle
            });
        }
    }
    /**
     * Update multiple step subtitles at once
     *
     * @param subtitles An object mapping step IDs to their subtitles
     */
    updateStepSubtitles(subtitles) {
        const currentSubtitles = this.stepSubtitlesSubject.value;
        let hasChanges = false;
        // Create new subtitles object with updated values
        const newSubtitles = { ...currentSubtitles };
        // Update each provided subtitle
        Object.entries(subtitles).forEach(([key, value]) => {
            const stepId = key;
            if (value !== undefined && currentSubtitles[stepId] !== value) {
                newSubtitles[stepId] = value;
                hasChanges = true;
            }
        });
        // Only update if changes were made
        if (hasChanges) {
            this.stepSubtitlesSubject.next(newSubtitles);
        }
    }
    /**
     * Update validation state for a specific step
     *
     * Sets the validation state for a single step, which affects how the
     * step is visually displayed in the stepper.
     *
     * @param stepId The ID of the step to update
     * @param validationState The new validation state:
     *   - 'valid': Step has passed validation checks (shows checkmark)
     *   - 'invalid': Step has validation errors (shows warning icon)
     *   - 'pending': Validation in progress (shows clock/time icon)
     *   - null: Reset to default state (shows completion status or step number)
     *
     * @example
     * // Mark a step as valid after successful validation
     * stepIndicatorService.updateStepValidation('personalInfo', 'valid');
     *
     * // Mark a step as having validation errors
     * stepIndicatorService.updateStepValidation('paymentDetails', 'invalid');
     *
     * // Show pending state during async validation
     * stepIndicatorService.updateStepValidation('addressVerification', 'pending');
     *
     * // Reset validation state
     * stepIndicatorService.updateStepValidation('preferences', null);
     */
    updateStepValidation(stepId, validationState) {
        const currentValidation = this.stepValidationSubject.value;
        if (currentValidation[stepId] !== validationState) {
            this.stepValidationSubject.next({
                ...currentValidation,
                [stepId]: validationState
            });
        }
    }
    /**
     * Update validation states for multiple steps at once
     *
     * Efficiently updates validation states for multiple steps in a single operation.
     * This is useful when validating a form with multiple sections or when navigation
     * between steps requires validation of previous steps.
     *
     * @param validation An object mapping step IDs to their validation states
     *
     * @example
     * // Update multiple steps in one operation
     * stepIndicatorService.updateStepValidations({
     *   'personalInfo': 'valid',
     *   'addressInfo': 'valid',
     *   'paymentDetails': 'invalid',
     *   'preferences': null
     * });
     *
     * @note Only changed states will trigger updates in the observable streams,
     * making this method efficient for bulk updates.
     */
    updateStepValidations(validation) {
        const currentValidation = this.stepValidationSubject.value;
        let hasChanges = false;
        // Create new validation object with updated values
        const newValidation = { ...currentValidation };
        // Update each provided validation state
        Object.entries(validation).forEach(([key, value]) => {
            const stepId = key;
            // Only update if value is defined and different from current value
            if (value !== undefined && currentValidation[stepId] !== value) {
                newValidation[stepId] = value;
                hasChanges = true;
            }
        });
        // Only update if changes were made
        if (hasChanges) {
            this.stepValidationSubject.next(newValidation);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepIndicatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepIndicatorService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepIndicatorService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Premier League Card Stepper Component
 *
 * A modern, card-based stepper for multi-step forms and wizards.
 * Features:
 * - Interactive step cards with gradient backgrounds
 * - Progress indicator
 * - Responsive design
 * - Auto-collapse on scroll
 * - Animated transitions
 * - Customizable via service configuration
 */
class PlCardStepperComponent {
    stepIndicatorService;
    elementRef;
    ngZone;
    cdr;
    canNavigateToStep = () => true;
    isStepComplete;
    autoCollapseOnScroll = true;
    showStepIndicatorBar = true;
    expandedHeight = '140px';
    collapsedHeight = '100px';
    stepSelected = new EventEmitter();
    // Internal state
    steps = [];
    heightState = 'expanded';
    currentStep = null;
    previousStep = null;
    // Expose observable streams
    steps$;
    currentStep$;
    // Private subjects for handling value changes
    destroy$ = new BehaviorSubject(false);
    // Subscriptions management
    subscriptions = new Subscription();
    observer;
    scrollSubscription;
    scrollableParent = null;
    resizeSubscription;
    constructor(stepIndicatorService, elementRef, ngZone, cdr) {
        this.stepIndicatorService = stepIndicatorService;
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this.cdr = cdr;
        this.steps$ = this.stepIndicatorService.steps$;
        this.currentStep$ = this.stepIndicatorService.currentStep$;
    }
    ngOnInit() {
        // Subscribe to step changes
        const stepSub = this.steps$.subscribe((steps) => {
            this.steps = steps;
        });
        // Subscribe to current step changes
        const currentStepSub = this.currentStep$.subscribe((currentStep) => {
            this.previousStep = this.currentStep;
            this.currentStep = currentStep;
        });
        this.subscriptions.add(stepSub);
        this.subscriptions.add(currentStepSub);
        // Set up auto collapse on scroll if enabled
        if (this.autoCollapseOnScroll) {
            this.setupScrollHandling();
        }
        // Set up resize handling
        this.setupResizeHandling();
        // Set initial animation states
        setTimeout(() => {
            this.elementRef.nativeElement.classList.remove('no-transition');
        }, 50);
    }
    ngOnChanges(changes) {
        // Handle input changes
        if (changes['expandedHeight'] || changes['collapsedHeight']) {
            this.updateHeightStyles();
        }
        if (changes['autoCollapseOnScroll']) {
            if (this.autoCollapseOnScroll) {
                this.setupScrollHandling();
            }
            else {
                this.removeScrollHandling();
            }
        }
    }
    ngOnDestroy() {
        // Clean up all subscriptions
        this.subscriptions.unsubscribe();
        this.destroy$.next(true);
        this.destroy$.complete();
        // Clean up observers
        this.removeScrollHandling();
        this.removeResizeHandling();
    }
    /**
     * Handle step click
     * @param stepId The ID of the step that was clicked
     */
    onStepClick(stepId) {
        if (this.canNavigateToStep(stepId) && stepId !== this.currentStep) {
            this.stepSelected.emit(stepId);
        }
    }
    /**
     * Track steps by their ID for ngFor optimization
     */
    trackByStepId(index, step) {
        return step.id;
    }
    /**
     * Force recalculation of step indicator position
     * Call this method if the indicator position needs to be updated
     * after DOM changes or dynamic content loading
     */
    recalculateIndicatorPosition() {
        if (this.currentStep) {
            // Trigger change detection to update the animation
            this.cdr.detectChanges();
            // Dispatch a resize event to trigger any responsive calculations
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }
    }
    get currentStepColors() {
        const step = this.steps.find((s) => s.id === this.currentStep);
        return step?.colors || { start: '#7C3AED', end: '#5B21B6' };
    }
    getStepPosition(stepId) {
        if (!this.steps || this.steps.length === 0)
            return 'translateX(0%)';
        const index = this.steps.findIndex((s) => s.id === stepId);
        if (index === -1)
            return 'translateX(0%)';
        const stepElements = this.elementRef.nativeElement.querySelectorAll('.steps-grid > .step-card');
        if (!stepElements || stepElements.length <= index) {
            return 'translateX(0%)';
        }
        const stepsContainer = this.elementRef.nativeElement
            .querySelector('.steps-container');
        if (!stepsContainer) {
            return 'translateX(0%)';
        }
        // For accurate positioning, we'll measure the actual elements
        // This accounts for any CSS-applied gaps and responsive layouts
        const containerRect = stepsContainer.getBoundingClientRect();
        const stepRect = stepElements[index].getBoundingClientRect();
        // Calculate center position of the step relative to the container
        const stepCenter = stepRect.left + (stepRect.width / 2) - containerRect.left;
        // Calculate indicator width (80% of actual step width)
        const indicatorWidth = stepRect.width * 0.8;
        // Calculate left position to center the indicator under the step
        const indicatorLeft = stepCenter - (indicatorWidth / 2);
        // Update indicator width
        const indicator = this.elementRef.nativeElement.querySelector('.step-indicator');
        if (indicator) {
            indicator.style.width = `${indicatorWidth}px`;
        }
        return `translateX(${indicatorLeft}px)`;
    }
    /**
     * Update animation parameters for the current step
     */
    getAnimationParams() {
        // If steps aren't initialized yet, return default params
        if (!this.steps || this.steps.length === 0) {
            return {
                transform: 'translateX(0%)',
                prevTransform: 'translateX(0%)',
                startColor: '#37003C',
                endColor: '#963CAD' // Default purple end color
            };
        }
        // Keep internal state for animations that need synchronous access
        const colors = this.currentStepColors;
        const currentStepValue = this.currentStep || this.steps[0]?.id;
        if (!currentStepValue) {
            return {
                transform: 'translateX(0%)',
                prevTransform: 'translateX(0%)',
                startColor: colors.start,
                endColor: colors.end
            };
        }
        // Force recalculation of position and width when animation params are requested
        const transform = this.getStepPosition(currentStepValue);
        // If there's no previous step (initial load), use the current position
        // This prevents the indicator from sliding from 0 on initial load
        const prevTransform = this.previousStep && this.previousStep !== currentStepValue
            ? this.getStepPosition(this.previousStep)
            : transform;
        const params = {
            transform: transform,
            prevTransform: prevTransform,
            startColor: colors.start,
            endColor: colors.end
        };
        return params;
    }
    /**
     * Get the index of the current step
     */
    getCurrentStepIndex() {
        return this.steps.findIndex((s) => s.id === this.currentStep);
    }
    /**
     * Get the index of the previous step
     */
    getPreviousStepIndex() {
        return this.steps.findIndex((s) => s.id === this.previousStep);
    }
    /**
     * Update height styles based on expanded/collapsed state
     */
    updateHeightStyles() {
        // Update CSS variables for heights
        const element = this.elementRef.nativeElement;
        element.style.setProperty('--expanded-height', this.expandedHeight);
        element.style.setProperty('--collapsed-height', this.collapsedHeight);
    }
    /**
     * Set up scroll handling for auto-collapsing
     */
    setupScrollHandling() {
        this.removeScrollHandling();
        // Find scrollable parent
        this.scrollableParent = this.findScrollableParent(this.elementRef.nativeElement);
        if (!this.scrollableParent)
            return;
        // Run outside Angular zone for better performance
        this.ngZone.runOutsideAngular(() => {
            // Create IntersectionObserver
            this.observer = new IntersectionObserver((entries) => {
                const [entry] = entries;
                const isVisible = entry.isIntersecting;
                // If component is not visible, collapse it
                if (!isVisible && this.heightState === 'expanded') {
                    this.ngZone.run(() => {
                        this.heightState = 'collapsed';
                        this.cdr.markForCheck();
                    });
                }
            }, { threshold: 0.5 });
            // Observe the component
            this.observer.observe(this.elementRef.nativeElement);
            // Listen for scroll events
            this.scrollSubscription = fromEvent(this.scrollableParent, 'scroll')
                .pipe(throttleTime(200))
                .subscribe(() => {
                const rect = this.elementRef.nativeElement.getBoundingClientRect();
                const isVisible = rect.top > 0 && rect.bottom < window.innerHeight;
                this.ngZone.run(() => {
                    // Expand when visible at top of viewport, collapse otherwise
                    this.heightState =
                        isVisible && rect.top < 100 ? 'expanded' : 'collapsed';
                    this.cdr.markForCheck();
                });
            });
        });
    }
    /**
     * Find the first scrollable parent of an element
     */
    findScrollableParent(node) {
        if (!node)
            return null;
        const isBody = node.nodeName === 'BODY';
        const hasScrollableContent = node.scrollHeight > node.clientHeight;
        const isScrollable = getComputedStyle(node).overflowY !== 'visible' &&
            getComputedStyle(node).overflowY !== 'hidden';
        if (isBody) {
            return window.document.documentElement;
        }
        if (hasScrollableContent && isScrollable) {
            return node;
        }
        return this.findScrollableParent(node.parentElement);
    }
    /**
     * Clean up scroll handling
     */
    removeScrollHandling() {
        if (this.observer) {
            this.observer.disconnect();
            // this.observer = null;
        }
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
            // this.scrollSubscription = null;
        }
    }
    /**
     * Set up handling for window resize events
     */
    setupResizeHandling() {
        this.removeResizeHandling();
        this.ngZone.runOutsideAngular(() => {
            this.resizeSubscription = fromEvent(window, 'resize')
                .pipe(throttleTime(200))
                .subscribe(() => {
                this.ngZone.run(() => {
                    // Force a check for any layout changes
                    this.cdr.markForCheck();
                });
            });
        });
    }
    /**
     * Clean up resize handling
     */
    removeResizeHandling() {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
            // this.resizeSubscription = null;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCardStepperComponent, deps: [{ token: StepIndicatorService }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PlCardStepperComponent, selector: "pl-card-stepper", inputs: { canNavigateToStep: "canNavigateToStep", isStepComplete: "isStepComplete", autoCollapseOnScroll: "autoCollapseOnScroll", showStepIndicatorBar: "showStepIndicatorBar", expandedHeight: "expandedHeight", collapsedHeight: "collapsedHeight" }, outputs: { stepSelected: "stepSelected" }, usesOnChanges: true, ngImport: i0, template: "<div\n  id=\"card-stepper-component\"\n  class=\"steps-container\"\n  [attr.data-height-state]=\"heightState\"\n>\n  <div class=\"steps-grid\" kendoRippleContainer>\n    <!-- Debug section to check if steps are coming through -->\n    <ng-container *ngIf=\"!(steps$ | async)\">\n      <div class=\"loading-container\">Loading steps...</div>\n    </ng-container>\n\n    <!-- Regular step rendering -->\n    <div\n      *ngFor=\"let step of steps$ | async; let i = index; trackBy: trackByStepId\"\n      class=\"step-card\"\n    >\n      <a\n        (click)=\"onStepClick(step.id)\"\n        kendoRipple\n        class=\"step-card__link\"\n        [@heightTransition]=\"heightState\"\n        style=\"transition: min-height 0.3s ease-out\"\n      >\n        <div\n          class=\"step-card__background\"\n          [style.background]=\"\n            'linear-gradient(135deg, ' +\n            step.colors.start +\n            ' 0%, ' +\n            step.colors.end +\n            ' 100%)'\n          \"\n          [class.step-card__background--inactive]=\"\n            !step.isActive\n          \"\n          [class.step-card__background--active]=\"\n            step.isActive && !showStepIndicatorBar\n          \"\n        >\n          <!-- Decorative gradient overlay -->\n          <div class=\"step-card__background-overlay\"></div>\n        </div>\n        <!-- Content container that remains unaffected by scaling -->\n        <div class=\"step-card__content\">\n          <!-- Title section -->\n          <div class=\"step-card__header\">\n            <div class=\"step-card__title-wrapper\">\n              <h2 class=\"step-card__title\">\n                {{ step.title }}\n              </h2>\n            </div>\n\n            <!-- Step number indicator - hide on mobile -->\n            <div class=\"step-card__number-indicator\">\n              <!-- Use validation state indicators when available -->\n              <ng-container [ngSwitch]=\"step.validationState\">\n                <!-- Valid state takes precedence over complete -->\n                <ng-container *ngSwitchCase=\"'valid'\">\n                  <div class=\"step-card__valid-indicator\">\n                    <pl-icon icon=\"check\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Invalid state -->\n                <ng-container *ngSwitchCase=\"'invalid'\">\n                  <div class=\"step-card__invalid-indicator\">\n                    <pl-icon icon=\"warning\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Pending state -->\n                <ng-container *ngSwitchCase=\"'pending'\">\n                  <div class=\"step-card__pending-indicator\">\n                    <pl-icon icon=\"time\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Default state (null or any other value) -->\n                <ng-container *ngSwitchDefault>\n                  <!-- Use completed checkmark or step number indicator -->\n                  <ng-container *ngIf=\"step.isComplete; else stepNumber\">\n                    <div class=\"step-card__completed-indicator\">\n                      <pl-icon icon=\"check\"></pl-icon>\n                    </div>\n                  </ng-container>\n                  <ng-template #stepNumber>\n                    <div class=\"step-card__number-circle\">\n                      <span class=\"step-card__number\">{{ i + 1 }}</span>\n                    </div>\n                  </ng-template>\n                </ng-container>\n              </ng-container>\n            </div>\n\n            <!-- Subtitle - only visible in expanded state -->\n            <div\n              *ngIf=\"step.subtitle && heightState === 'expanded'\"\n              class=\"step-card__subtitle\"\n              [class.step-card__subtitle--hidden]=\"heightState !== 'expanded'\"\n              [class.step-card__subtitle--visible]=\"heightState === 'expanded'\"\n            >\n              {{ step.subtitle }}\n            </div>\n          </div>\n\n          <!-- Icon - hidden on mobile -->\n          <div class=\"step-card__icon-container\">\n            <pl-icon\n              [icon]=\"step.icon\"\n              [size]=\"'28px'\"\n              class=\"step-card__icon\"\n              [color]=\"'white'\"\n            >\n            </pl-icon>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <!-- Step indicator bar with clearer structure -->\n  <div class=\"step-indicator-container\" *ngIf=\"showStepIndicatorBar\">\n    <div class=\"step-indicator-track\">\n      <div\n        class=\"step-indicator\"\n        [@stepTransition]=\"{\n          value: currentStep,\n          params: getAnimationParams()\n        }\"\n      ></div>\n    </div>\n  </div>\n</div>\n", styles: [".steps-container{position:relative;width:100%;padding:1rem 0;min-height:150px;margin-bottom:1rem}.steps-container .steps-grid{display:flex;gap:1rem;margin-bottom:1rem;position:relative;z-index:1;width:100%}@media (min-width: 768px){.steps-container .steps-grid{gap:1.5rem;margin-bottom:1.5rem}}@media (min-width: 1024px){.steps-container .steps-grid{gap:2rem}}.steps-container .steps-grid .step-card{flex:1;min-width:0}@media (max-width: 479px){.steps-container .steps-grid{flex-direction:column}.steps-container .steps-grid .step-card{margin-bottom:.5rem}}.steps-container .step-card{position:relative;width:100%;height:100%;box-sizing:border-box}.steps-container .step-card__link{display:block;width:100%;height:100%;position:relative;cursor:pointer;padding:.5rem;min-height:8rem;transition:all .3s ease-out;z-index:1;box-sizing:border-box}@media (min-width: 768px){.steps-container .step-card__link{padding:1rem}}.steps-container .step-card__link:hover .step-card__background{transform:scale(1.02);box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.steps-container .step-card__link:after{content:\"\";position:absolute;top:50%;left:50%;width:5px;height:5px;background:#ffffff80;opacity:0;border-radius:100%;transform:scale(1) translate(-50%,-50%);transform-origin:50% 50%}.steps-container .step-card__link:active:after{animation:ripple .6s ease-out}.steps-container .step-card__background{position:absolute;inset:0;color:#fff;border-radius:.5rem;box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f;transform:scale(1);transition:all .3s;opacity:.9;z-index:0;box-sizing:border-box;transform-origin:center}@media (min-width: 768px){.steps-container .step-card__background{border-radius:.75rem;box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}}.steps-container .step-card__background--active{border:2px solid #db2777}.steps-container .step-card__background--inactive{opacity:.7}.steps-container .step-card__background-overlay{position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.05),transparent);border-radius:inherit;box-sizing:border-box}.steps-container .step-card__content{position:relative;z-index:10;height:100%;width:100%;display:flex;flex-direction:column;justify-content:space-between;box-sizing:border-box;max-width:100%}.steps-container .step-card__header{display:flex;flex-direction:column;gap:.25rem}.steps-container .step-card__title-wrapper{display:flex;align-items:center;gap:.25rem;position:relative;z-index:10;max-width:100%}@media (min-width: 768px){.steps-container .step-card__title-wrapper{gap:.75rem}}.steps-container .step-card__title{font-size:.875rem;font-weight:700;display:block;letter-spacing:.025em;text-transform:capitalize;color:#ffffffe6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}@media (min-width: 768px){.steps-container .step-card__title{font-size:1.25rem}}.steps-container .step-card__number-indicator{position:absolute;top:0;right:0;z-index:10;display:block}.steps-container .step-card__number-circle{width:2rem;height:2rem;background-color:#fff3;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border-radius:9999px;display:flex;align-items:center;justify-content:center}.steps-container .step-card__number{font-size:.875rem;font-weight:700;color:#fff}.steps-container .step-card__completed-indicator{width:1.5rem;height:1.5rem;background-color:#fff;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__valid-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__valid-indicator pl-icon{color:#fff}.steps-container .step-card__invalid-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__invalid-indicator pl-icon{color:#fff}.steps-container .step-card__pending-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__pending-indicator pl-icon{color:#fff}.steps-container .step-card__subtitle{color:#fffc;font-size:.75rem;font-weight:500;z-index:10;transition:opacity .3s ease-in-out}@media (min-width: 768px){.steps-container .step-card__subtitle{font-size:.875rem}}.steps-container .step-card__subtitle--hidden{opacity:0}.steps-container .step-card__subtitle--visible{opacity:1}.steps-container .step-card__icon-container{align-self:flex-end;text-align:right;padding-right:0;z-index:10;margin-bottom:0;margin-right:0}@media (min-width: 768px){.steps-container .step-card__icon-container{padding-right:.75rem}}.steps-container .step-card__icon{display:none}@media (min-width: 768px){.steps-container .step-card__icon{display:block}}.steps-container .step-indicator-container{position:relative;width:100%;height:8px;margin-top:8px;margin-bottom:4px;display:block;z-index:20}.steps-container .step-indicator-track{position:absolute;bottom:0;left:0;width:100%;height:4px;background-color:#c8c8c84d;border-radius:2px;overflow:hidden;z-index:20;display:block;opacity:1;visibility:visible}.steps-container .step-indicator{position:absolute;top:0;left:0;height:100%;min-width:20px;background:linear-gradient(90deg,#7c3aed,#5b21b6);border-radius:2px;will-change:transform;display:block;opacity:1}.k-ripple{position:absolute;inset:0;overflow:hidden;z-index:10;pointer-events:none}@keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(25);opacity:.3}to{opacity:0;transform:scale(40)}}.no-transition{transition:none!important;animation:none!important;transform:none!important}.loading-container{text-align:center;padding:1rem;border:1px solid #e5e7eb;grid-column:span 4/span 4}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$3.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i3$3.RippleContainerDirective, selector: "[kendoRippleContainer]", inputs: ["disabled"] }, { kind: "component", type: PlIconComponent, selector: "pl-icon", inputs: ["type", "icon", "size", "color", "src"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [
            trigger('stepTransition', [
                state('*', style({
                    transform: '{{transform}}',
                    background: 'linear-gradient(90deg, {{startColor}} 0%, {{endColor}} 100%)'
                }), {
                    params: {
                        transform: 'translateX(0)',
                        startColor: '#7C3AED',
                        endColor: '#5B21B6'
                    }
                }),
                transition('* => *', [
                    style({ transform: '{{prevTransform}}' }),
                    animate('300ms ease-out')
                ])
            ]),
            trigger('heightTransition', [
                state('expanded', style({ minHeight: '140px' })),
                state('collapsed', style({ minHeight: '100px' })),
                transition('expanded <=> collapsed', [animate('300ms ease-out')])
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlCardStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-card-stepper', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('stepTransition', [
                            state('*', style({
                                transform: '{{transform}}',
                                background: 'linear-gradient(90deg, {{startColor}} 0%, {{endColor}} 100%)'
                            }), {
                                params: {
                                    transform: 'translateX(0)',
                                    startColor: '#7C3AED',
                                    endColor: '#5B21B6'
                                }
                            }),
                            transition('* => *', [
                                style({ transform: '{{prevTransform}}' }),
                                animate('300ms ease-out')
                            ])
                        ]),
                        trigger('heightTransition', [
                            state('expanded', style({ minHeight: '140px' })),
                            state('collapsed', style({ minHeight: '100px' })),
                            transition('expanded <=> collapsed', [animate('300ms ease-out')])
                        ])
                    ], template: "<div\n  id=\"card-stepper-component\"\n  class=\"steps-container\"\n  [attr.data-height-state]=\"heightState\"\n>\n  <div class=\"steps-grid\" kendoRippleContainer>\n    <!-- Debug section to check if steps are coming through -->\n    <ng-container *ngIf=\"!(steps$ | async)\">\n      <div class=\"loading-container\">Loading steps...</div>\n    </ng-container>\n\n    <!-- Regular step rendering -->\n    <div\n      *ngFor=\"let step of steps$ | async; let i = index; trackBy: trackByStepId\"\n      class=\"step-card\"\n    >\n      <a\n        (click)=\"onStepClick(step.id)\"\n        kendoRipple\n        class=\"step-card__link\"\n        [@heightTransition]=\"heightState\"\n        style=\"transition: min-height 0.3s ease-out\"\n      >\n        <div\n          class=\"step-card__background\"\n          [style.background]=\"\n            'linear-gradient(135deg, ' +\n            step.colors.start +\n            ' 0%, ' +\n            step.colors.end +\n            ' 100%)'\n          \"\n          [class.step-card__background--inactive]=\"\n            !step.isActive\n          \"\n          [class.step-card__background--active]=\"\n            step.isActive && !showStepIndicatorBar\n          \"\n        >\n          <!-- Decorative gradient overlay -->\n          <div class=\"step-card__background-overlay\"></div>\n        </div>\n        <!-- Content container that remains unaffected by scaling -->\n        <div class=\"step-card__content\">\n          <!-- Title section -->\n          <div class=\"step-card__header\">\n            <div class=\"step-card__title-wrapper\">\n              <h2 class=\"step-card__title\">\n                {{ step.title }}\n              </h2>\n            </div>\n\n            <!-- Step number indicator - hide on mobile -->\n            <div class=\"step-card__number-indicator\">\n              <!-- Use validation state indicators when available -->\n              <ng-container [ngSwitch]=\"step.validationState\">\n                <!-- Valid state takes precedence over complete -->\n                <ng-container *ngSwitchCase=\"'valid'\">\n                  <div class=\"step-card__valid-indicator\">\n                    <pl-icon icon=\"check\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Invalid state -->\n                <ng-container *ngSwitchCase=\"'invalid'\">\n                  <div class=\"step-card__invalid-indicator\">\n                    <pl-icon icon=\"warning\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Pending state -->\n                <ng-container *ngSwitchCase=\"'pending'\">\n                  <div class=\"step-card__pending-indicator\">\n                    <pl-icon icon=\"time\"></pl-icon>\n                  </div>\n                </ng-container>\n                \n                <!-- Default state (null or any other value) -->\n                <ng-container *ngSwitchDefault>\n                  <!-- Use completed checkmark or step number indicator -->\n                  <ng-container *ngIf=\"step.isComplete; else stepNumber\">\n                    <div class=\"step-card__completed-indicator\">\n                      <pl-icon icon=\"check\"></pl-icon>\n                    </div>\n                  </ng-container>\n                  <ng-template #stepNumber>\n                    <div class=\"step-card__number-circle\">\n                      <span class=\"step-card__number\">{{ i + 1 }}</span>\n                    </div>\n                  </ng-template>\n                </ng-container>\n              </ng-container>\n            </div>\n\n            <!-- Subtitle - only visible in expanded state -->\n            <div\n              *ngIf=\"step.subtitle && heightState === 'expanded'\"\n              class=\"step-card__subtitle\"\n              [class.step-card__subtitle--hidden]=\"heightState !== 'expanded'\"\n              [class.step-card__subtitle--visible]=\"heightState === 'expanded'\"\n            >\n              {{ step.subtitle }}\n            </div>\n          </div>\n\n          <!-- Icon - hidden on mobile -->\n          <div class=\"step-card__icon-container\">\n            <pl-icon\n              [icon]=\"step.icon\"\n              [size]=\"'28px'\"\n              class=\"step-card__icon\"\n              [color]=\"'white'\"\n            >\n            </pl-icon>\n          </div>\n        </div>\n      </a>\n    </div>\n  </div>\n\n  <!-- Step indicator bar with clearer structure -->\n  <div class=\"step-indicator-container\" *ngIf=\"showStepIndicatorBar\">\n    <div class=\"step-indicator-track\">\n      <div\n        class=\"step-indicator\"\n        [@stepTransition]=\"{\n          value: currentStep,\n          params: getAnimationParams()\n        }\"\n      ></div>\n    </div>\n  </div>\n</div>\n", styles: [".steps-container{position:relative;width:100%;padding:1rem 0;min-height:150px;margin-bottom:1rem}.steps-container .steps-grid{display:flex;gap:1rem;margin-bottom:1rem;position:relative;z-index:1;width:100%}@media (min-width: 768px){.steps-container .steps-grid{gap:1.5rem;margin-bottom:1.5rem}}@media (min-width: 1024px){.steps-container .steps-grid{gap:2rem}}.steps-container .steps-grid .step-card{flex:1;min-width:0}@media (max-width: 479px){.steps-container .steps-grid{flex-direction:column}.steps-container .steps-grid .step-card{margin-bottom:.5rem}}.steps-container .step-card{position:relative;width:100%;height:100%;box-sizing:border-box}.steps-container .step-card__link{display:block;width:100%;height:100%;position:relative;cursor:pointer;padding:.5rem;min-height:8rem;transition:all .3s ease-out;z-index:1;box-sizing:border-box}@media (min-width: 768px){.steps-container .step-card__link{padding:1rem}}.steps-container .step-card__link:hover .step-card__background{transform:scale(1.02);box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.steps-container .step-card__link:after{content:\"\";position:absolute;top:50%;left:50%;width:5px;height:5px;background:#ffffff80;opacity:0;border-radius:100%;transform:scale(1) translate(-50%,-50%);transform-origin:50% 50%}.steps-container .step-card__link:active:after{animation:ripple .6s ease-out}.steps-container .step-card__background{position:absolute;inset:0;color:#fff;border-radius:.5rem;box-shadow:0 4px 6px -1px #0000001a,0 2px 4px -1px #0000000f;transform:scale(1);transition:all .3s;opacity:.9;z-index:0;box-sizing:border-box;transform-origin:center}@media (min-width: 768px){.steps-container .step-card__background{border-radius:.75rem;box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}}.steps-container .step-card__background--active{border:2px solid #db2777}.steps-container .step-card__background--inactive{opacity:.7}.steps-container .step-card__background-overlay{position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,.05),transparent);border-radius:inherit;box-sizing:border-box}.steps-container .step-card__content{position:relative;z-index:10;height:100%;width:100%;display:flex;flex-direction:column;justify-content:space-between;box-sizing:border-box;max-width:100%}.steps-container .step-card__header{display:flex;flex-direction:column;gap:.25rem}.steps-container .step-card__title-wrapper{display:flex;align-items:center;gap:.25rem;position:relative;z-index:10;max-width:100%}@media (min-width: 768px){.steps-container .step-card__title-wrapper{gap:.75rem}}.steps-container .step-card__title{font-size:.875rem;font-weight:700;display:block;letter-spacing:.025em;text-transform:capitalize;color:#ffffffe6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}@media (min-width: 768px){.steps-container .step-card__title{font-size:1.25rem}}.steps-container .step-card__number-indicator{position:absolute;top:0;right:0;z-index:10;display:block}.steps-container .step-card__number-circle{width:2rem;height:2rem;background-color:#fff3;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);border-radius:9999px;display:flex;align-items:center;justify-content:center}.steps-container .step-card__number{font-size:.875rem;font-weight:700;color:#fff}.steps-container .step-card__completed-indicator{width:1.5rem;height:1.5rem;background-color:#fff;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__valid-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__valid-indicator pl-icon{color:#fff}.steps-container .step-card__invalid-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__invalid-indicator pl-icon{color:#fff}.steps-container .step-card__pending-indicator{width:1.5rem;height:1.5rem;border-radius:9999px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 6px -1px #0000001a}.steps-container .step-card__pending-indicator pl-icon{color:#fff}.steps-container .step-card__subtitle{color:#fffc;font-size:.75rem;font-weight:500;z-index:10;transition:opacity .3s ease-in-out}@media (min-width: 768px){.steps-container .step-card__subtitle{font-size:.875rem}}.steps-container .step-card__subtitle--hidden{opacity:0}.steps-container .step-card__subtitle--visible{opacity:1}.steps-container .step-card__icon-container{align-self:flex-end;text-align:right;padding-right:0;z-index:10;margin-bottom:0;margin-right:0}@media (min-width: 768px){.steps-container .step-card__icon-container{padding-right:.75rem}}.steps-container .step-card__icon{display:none}@media (min-width: 768px){.steps-container .step-card__icon{display:block}}.steps-container .step-indicator-container{position:relative;width:100%;height:8px;margin-top:8px;margin-bottom:4px;display:block;z-index:20}.steps-container .step-indicator-track{position:absolute;bottom:0;left:0;width:100%;height:4px;background-color:#c8c8c84d;border-radius:2px;overflow:hidden;z-index:20;display:block;opacity:1;visibility:visible}.steps-container .step-indicator{position:absolute;top:0;left:0;height:100%;min-width:20px;background:linear-gradient(90deg,#7c3aed,#5b21b6);border-radius:2px;will-change:transform;display:block;opacity:1}.k-ripple{position:absolute;inset:0;overflow:hidden;z-index:10;pointer-events:none}@keyframes ripple{0%{transform:scale(0);opacity:.5}20%{transform:scale(25);opacity:.3}to{opacity:0;transform:scale(40)}}.no-transition{transition:none!important;animation:none!important;transform:none!important}.loading-container{text-align:center;padding:1rem;border:1px solid #e5e7eb;grid-column:span 4/span 4}\n"] }]
        }], ctorParameters: function () { return [{ type: StepIndicatorService }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { canNavigateToStep: [{
                type: Input
            }], isStepComplete: [{
                type: Input
            }], autoCollapseOnScroll: [{
                type: Input
            }], showStepIndicatorBar: [{
                type: Input
            }], expandedHeight: [{
                type: Input
            }], collapsedHeight: [{
                type: Input
            }], stepSelected: [{
                type: Output
            }] } });

/**
 * Abstract base class for domain-specific stepper services
 *
 * This class provides common functionality for step navigation, validation,
 * and state management across different domain contexts.
 *
 * Domain implementations should extend this class and implement the abstract
 * methods to provide context-specific behavior.
 */
class BaseDomainStepperService {
    stepIndicatorService;
    slideDirectionValue = 'translateX(100%)';
    stepConfig;
    constructor(stepIndicatorService, config) {
        this.stepIndicatorService = stepIndicatorService;
        if (config) {
            this.stepConfig = config;
        }
    }
    /**
     * Return the step configuration for this specific stepper instance
     *
     * @returns StepIndicatorConfig with steps, colors, icons, etc.
     */
    getStepperConfig() {
        return this.stepConfig;
    }
    /**
     * Validate if a step is valid. Used when navigating between steps.
     *
     * @param stepId The ID of the step to validate
     * @returns boolean indicating whether the step is valid
     */
    validateStep(stepId) {
        return true;
    }
    /**
     * Return the subtitle for a given step based on form data
     *
     * @param stepId The ID of the step to get subtitle for
     * @returns String subtitle for the step
     */
    getStepSubtitle(stepId) {
        const step = this.stepConfig.steps.find(s => s.id === stepId);
        return step?.defaultSubtitle || '';
    }
    /**
     * Initialize the stepper with its configuration
     *
     * Call this method in the component's ngOnInit or constructor
     * to set up the stepper with the correct configuration.
     */
    initialize() {
        this.stepIndicatorService.initialize(this.getStepperConfig());
        this.updateAllStepSubtitles();
    }
    /**
     * Initialize with a config that overrides the one provided in the constructor
     *
     * @param config Configuration to initialize the stepper with
     */
    initializeWithConfig(config) {
        this.stepConfig = config;
        this.initialize();
    }
    /**
     * Navigate to a specific step if allowed
     *
     * @param stepId The ID of the step to navigate to
     */
    navigateToStep(stepId) {
        if (this.canNavigateToStep(stepId)) {
            const currentStep = this.stepIndicatorService.currentStep;
            const steps = this.stepIndicatorService.getSteps();
            const currentIndex = steps.findIndex(s => s.id === currentStep);
            const newIndex = steps.findIndex(s => s.id === stepId);
            if (newIndex > currentIndex) {
                this.setSlideDirection('translateX(100%)');
            }
            else if (newIndex < currentIndex) {
                this.setSlideDirection('translateX(-100%)');
            }
            this.stepIndicatorService.setStep(stepId);
        }
    }
    /**
     * Determine if navigation to a step is allowed
     *
     * Override this method in domain implementations to enforce
     * step navigation rules.
     *
     * @param stepId The ID of the step to navigate to
     * @returns boolean indicating whether navigation is allowed
     */
    canNavigateToStep(stepId) {
        return true;
    }
    /**
     * Navigate to the next step if current step is valid
     *
     * @returns boolean indicating whether navigation was successful
     */
    navigateToNextStep() {
        const currentStep = this.stepIndicatorService.currentStep;
        if (!this.validateStep(currentStep)) {
            return false;
        }
        const steps = this.stepIndicatorService.getSteps();
        const currentIndex = steps.findIndex(s => s.id === currentStep);
        if (currentIndex < steps.length - 1) {
            this.stepIndicatorService.markStepComplete(currentStep, true);
            this.setSlideDirection('translateX(100%)');
            const nextStep = steps[currentIndex + 1].id;
            this.stepIndicatorService.setStep(nextStep);
            return true;
        }
        return false;
    }
    /**
     * Navigate to the previous step
     */
    navigateToPreviousStep() {
        const currentStep = this.stepIndicatorService.currentStep;
        const steps = this.stepIndicatorService.getSteps();
        const currentIndex = steps.findIndex(s => s.id === currentStep);
        if (currentIndex > 0) {
            this.setSlideDirection('translateX(-100%)');
            const prevStep = steps[currentIndex - 1].id;
            this.stepIndicatorService.setStep(prevStep);
        }
    }
    /**
     * Check if a step is complete
     *
     * @param stepId The ID of the step to check
     * @returns boolean indicating whether the step is complete
     */
    isStepComplete(stepId) {
        const steps = this.stepIndicatorService.getSteps();
        const currentStepIndex = steps.findIndex(s => s.id === this.stepIndicatorService.currentStep);
        const targetStepIndex = steps.findIndex(s => s.id === stepId);
        return targetStepIndex < currentStepIndex;
    }
    /**
     * Get current step as an observable
     */
    get currentStep$() {
        return this.stepIndicatorService.currentStep$;
    }
    /**
     * Get current step
     */
    get currentStep() {
        return this.stepIndicatorService.currentStep;
    }
    /**
     * Set slide direction for animations
     *
     * @param direction CSS transform value for slide direction
     */
    setSlideDirection(direction) {
        this.slideDirectionValue = direction;
    }
    /**
     * Get slide direction for animations
     */
    get slideDirection() {
        return this.slideDirectionValue;
    }
    /**
     * Get slide direction as an observable
     */
    get slideDirection$() {
        // Return an observable with the current slide direction value
        return new BehaviorSubject(this.slideDirectionValue).asObservable();
    }
    /**
     * Update subtitles for all steps based on current data
     */
    updateAllStepSubtitles() {
        const config = this.getStepperConfig();
        const subtitles = {};
        config.steps.forEach(step => {
            subtitles[step.id] = this.getStepSubtitle(step.id);
        });
        this.stepIndicatorService.updateStepSubtitles(subtitles);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseDomainStepperService, deps: "invalid", target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseDomainStepperService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseDomainStepperService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StepIndicatorService }, { type: undefined }]; } });

/**
 * Public API for the stepper services
 */

class AccessControlDirective {
    templateRef;
    viewContainer;
    permissionsService;
    subject;
    action;
    constructor(templateRef, viewContainer, permissionsService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.permissionsService = permissionsService;
    }
    ngOnInit() {
        if (!this.subject || !this.action) {
            throw new Error('"Subject" and "action" inputs are required');
        }
        this.checkAccessControl();
    }
    async checkAccessControl() {
        const perms = await Promise.all((Array.isArray(this.subject) ? this.subject : [this.subject]).map(s => this.permissionsService.hasPermission(s, this.action)));
        if (perms.filter(p => p).length > 0) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccessControlDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: PermissionsService }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: AccessControlDirective, selector: "[accessControl]", inputs: { subject: ["accessControlSubject", "subject"], action: ["accessControl", "action"] }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AccessControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[accessControl]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: PermissionsService }]; }, propDecorators: { subject: [{
                type: Input,
                args: ['accessControlSubject']
            }], action: [{
                type: Input,
                args: ['accessControl']
            }] } });

class Destroy extends Observable {
    destroySubject$ = new ReplaySubject(1);
    constructor() {
        super((subscriber) => this.destroySubject$.subscribe(subscriber));
    }
    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: Destroy, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: Destroy });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: Destroy, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

/**
 * Quadratic Ease-Out Function: f(x) = x * (2 - x)
 */
const easeOutQuad = (x) => x * (2 - x);
class CountUpDirective {
    elementRef;
    renderer;
    destroy$;
    currencyPipe;
    count$ = new BehaviorSubject(0);
    duration$ = new BehaviorSubject(2000);
    currentDisplayedValue = 0;
    currentCount$ = combineLatest([
        this.count$,
        this.duration$
    ]).pipe(switchMap(([count, duration]) => {
        // get the time when animation is triggered
        const startTime = animationFrameScheduler.now();
        const startValue = this.currentDisplayedValue;
        const endValue = count;
        const valueToCount = endValue - startValue;
        return interval(0, animationFrameScheduler).pipe(
        // calculate elapsed time
        map(() => animationFrameScheduler.now() - startTime), 
        // calculate progress
        map((elapsedTime) => elapsedTime / duration), 
        // complete when progress is greater than 1
        takeWhile((progress) => progress <= 1), 
        // apply quadratic ease-out function
        // for faster start and slower end of counting
        map(easeOutQuad), 
        // calculate current count starting from previous value
        map((progress) => Math.round(startValue + progress * valueToCount)), 
        // make sure that last emitted value is count
        endWith(endValue), distinctUntilChanged(), tap(value => {
            this.currentDisplayedValue = value;
        }));
    }));
    set count(count) {
        this.count$.next(count);
    }
    set duration(duration) {
        this.duration$.next(duration);
    }
    formatType = 'count';
    currencyCode = 'GBP'; // Default currency code
    constructor(elementRef, renderer, destroy$, currencyPipe) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.destroy$ = destroy$;
        this.currencyPipe = currencyPipe;
    }
    ngOnInit() {
        this.displayCurrentCount();
    }
    transform(value) {
        switch (this.formatType) {
            case 'currency':
                return this.currencyPipe.transform(value, this.currencyCode, 'symbol', '1.0-0');
            case 'count':
                return value;
            case 'percentage':
                return `${value}%`;
            case 'shortNumber':
                return this.formatShortNumber(value);
            case 'shortCurrency':
                return this.formatShortNumber(value, true);
            default:
                return value;
        }
    }
    displayCurrentCount() {
        this.currentCount$
            .pipe(takeUntil(this.destroy$))
            .subscribe((currentCount) => {
            const roundedCount = Math.round(currentCount);
            const formattedCount = this.transform(roundedCount);
            this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', formattedCount);
        });
    }
    formatShortNumber(value, isCurrency = false) {
        const absValue = Math.abs(value);
        let formattedValue;
        let suffix;
        if (absValue >= 1000000000) {
            formattedValue = (value / 1000000000).toFixed(1);
            suffix = 'b';
        }
        else if (absValue >= 1000000) {
            formattedValue = (value / 1000000).toFixed(1);
            suffix = 'm';
        }
        else if (absValue >= 1000) {
            formattedValue = (value / 1000).toFixed(1);
            suffix = 'k';
        }
        else {
            formattedValue = value.toFixed(1);
            suffix = '';
        }
        // Remove trailing .0 if present
        formattedValue = formattedValue.replace(/\.0$/, '');
        if (isCurrency) {
            const currencySymbol = this.getCurrencySymbol();
            return `${currencySymbol}${formattedValue}${suffix}`;
        }
        else {
            return `${formattedValue}${suffix}`;
        }
    }
    getCurrencySymbol() {
        switch (this.currencyCode) {
            case 'USD': return '$';
            case 'EUR': return '€';
            case 'GBP': return '£';
            // Add more currency codes as needed
            default: return this.currencyCode;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountUpDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: Destroy }, { token: i1$3.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: CountUpDirective, selector: "[countUp]", inputs: { count: ["countUp", "count"], duration: "duration", formatType: "formatType", currencyCode: "currencyCode" }, providers: [Destroy], ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CountUpDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[countUp]',
                    providers: [Destroy]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: Destroy }, { type: i1$3.CurrencyPipe }]; }, propDecorators: { count: [{
                type: Input,
                args: ['countUp']
            }], duration: [{
                type: Input
            }], formatType: [{
                type: Input
            }], currencyCode: [{
                type: Input
            }] } });

class FallbackImageDirective {
    el;
    fallbackImage = null;
    constructor(el) {
        this.el = el;
    }
    ngOnInit() {
        if (this.fallbackImage !== null) {
            this.el.nativeElement.onerror = () => {
                this.el.nativeElement.src = this.fallbackImage;
            };
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FallbackImageDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FallbackImageDirective, selector: "img[appFallbackImage]", inputs: { fallbackImage: ["appFallbackImage", "fallbackImage"] }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FallbackImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'img[appFallbackImage]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { fallbackImage: [{
                type: Input,
                args: ['appFallbackImage']
            }] } });

class NumberToWordsDirective {
    el;
    renderer;
    numberToWords = 0;
    isCurrency = false;
    currencyName = 'pound';
    subUnitName = 'pence';
    element;
    // Maximum number of digits we can reliably handle
    MAX_DIGITS = 15;
    // Maximum value in scientific notation (determines when to show shrug)
    MAX_EXP = 15;
    // Shrug emoji response for numbers that are too large
    TOO_BIG_RESPONSE = '¯\\_(ツ)_/¯ too big!';
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.element = this.el.nativeElement;
    }
    ngOnInit() {
        this.updateText();
    }
    ngOnChanges(changes) {
        if (changes['numberToWords'] || changes['isCurrency'] ||
            changes['currencyName'] || changes['subUnitName']) {
            this.updateText();
        }
    }
    updateText() {
        // Convert the input to a string to handle large numbers correctly
        const valueStr = this.numberToWords?.toString() || '0';
        const text = this.isCurrency
            ? this.convertCurrencyToWords(valueStr)
            : this.convertToWords(valueStr);
        this.renderer.setProperty(this.element, 'textContent', text);
    }
    isTooBig(numStr) {
        // Check for scientific notation (e.g., 1e+26)
        const scientificMatch = numStr.match(/^-?(\d+\.?\d*|\.\d+)[eE]([+-]?)(\d+)$/);
        if (scientificMatch) {
            const exponent = parseInt(scientificMatch[3], 10);
            const isPositiveExp = scientificMatch[2] !== '-';
            // If it's a large positive exponent, it's too big
            if (isPositiveExp && exponent > this.MAX_EXP) {
                return true;
            }
        }
        // For regular numbers, check the number of digits
        const absStr = numStr.startsWith('-') ? numStr.substring(1) : numStr;
        const digitsOnly = absStr.replace(/[^\d]/g, '');
        return digitsOnly.length > this.MAX_DIGITS;
    }
    convertToWords(numStr) {
        // Early return for too big numbers, including scientific notation
        if (this.isTooBig(numStr)) {
            return this.TOO_BIG_RESPONSE;
        }
        // Try to convert to a standard number for processing if possible
        // Avoid floating point precision issues
        let num;
        try {
            num = Number(numStr);
            // If this is in scientific notation or too big, show the shrug
            if (!Number.isFinite(num) || Math.abs(num) > 1e15) {
                return this.TOO_BIG_RESPONSE;
            }
        }
        catch (e) {
            return this.TOO_BIG_RESPONSE;
        }
        // Handle zero
        if (num === 0)
            return 'zero';
        const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
            'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion'];
        // Check for negative number
        const isNegative = num < 0;
        const absNum = Math.abs(num);
        // Handle decimal parts
        const absNumStr = absNum.toString();
        let wholePartStr = absNumStr;
        let decimalStr = '';
        if (absNumStr.includes('.')) {
            const parts = absNumStr.split('.');
            wholePartStr = parts[0] || '0';
            decimalStr = parts[1] || '';
        }
        // Pad the string to ensure complete triplets
        const paddedStr = wholePartStr.padStart(3 * Math.ceil(wholePartStr.length / 3), '0');
        // Split into chunks of 3 digits
        const chunks = paddedStr.match(/.{3}/g) || [];
        // Check if we have too many chunks for our scales
        if (chunks.length > scales.length) {
            return this.TOO_BIG_RESPONSE;
        }
        // Process chunks
        let wordResult = [];
        // Process each chunk
        for (let i = 0; i < chunks.length; i++) {
            const chunk = parseInt(chunks[i] || '0', 10);
            const scaleIndex = chunks.length - 1 - i;
            // Skip zero chunks
            if (chunk === 0)
                continue;
            // Process this chunk
            let chunkWords = [];
            // Process hundreds
            const hundreds = Math.floor(chunk / 100);
            if (hundreds > 0) {
                chunkWords.push(`${ones[hundreds] || ''} hundred`);
            }
            // Process tens and ones
            const remainder = chunk % 100;
            if (remainder > 0) {
                if (remainder < 20) {
                    chunkWords.push(ones[remainder] || '');
                }
                else {
                    const tensDigit = Math.floor(remainder / 10);
                    const onesDigit = remainder % 10;
                    if (onesDigit > 0) {
                        chunkWords.push(`${tens[tensDigit] || ''}-${ones[onesDigit] || ''}`);
                    }
                    else {
                        chunkWords.push(tens[tensDigit] || '');
                    }
                }
            }
            // Add scale name (thousand, million, etc.)
            if (scaleIndex > 0) {
                chunkWords.push(scales[scaleIndex] || '');
            }
            // Add this chunk's words to the result
            wordResult.push(chunkWords.join(' '));
        }
        // Handle decimals
        if (decimalStr) {
            wordResult.push('point');
            for (let i = 0; i < decimalStr.length; i++) {
                const digit = parseInt(decimalStr[i] || '0', 10);
                wordResult.push(ones[digit] || '');
            }
        }
        // Return the final result with optional "negative" prefix
        return (isNegative ? 'negative ' : '') + (wordResult.join(' ') || 'zero');
    }
    convertCurrencyToWords(amountStr) {
        // Early check for too big numbers
        if (this.isTooBig(amountStr)) {
            return this.TOO_BIG_RESPONSE;
        }
        // Try to convert to a standard number for processing
        let amount;
        try {
            amount = Number(amountStr);
            // If this is in scientific notation or too big, show the shrug
            if (!Number.isFinite(amount) || Math.abs(amount) > 1e15) {
                return this.TOO_BIG_RESPONSE;
            }
        }
        catch (e) {
            return this.TOO_BIG_RESPONSE;
        }
        // Check for negative
        const isNegative = amount < 0;
        const absAmount = Math.abs(amount);
        // Split into whole and decimal parts
        const absAmountStr = absAmount.toString();
        let wholePartStr = absAmountStr;
        let decimalStr = '';
        if (absAmountStr.includes('.')) {
            const parts = absAmountStr.split('.');
            wholePartStr = parts[0] || '0';
            // Round to 2 decimal places for currency
            decimalStr = (parts[1] || '').padEnd(2, '0').substring(0, 2);
        }
        else {
            decimalStr = '00';
        }
        // Convert to integers
        const pounds = parseInt(wholePartStr, 10) || 0;
        const pence = parseInt(decimalStr, 10) || 0;
        // Handle the case where both pounds and pence are zero
        if (pounds === 0 && pence === 0) {
            return 'zero ' + this.currencyName + 's';
        }
        let result = '';
        // Handle main currency unit (pounds)
        if (pounds > 0) {
            result += this.convertToWords(pounds.toString()) + ' ' + this.currencyName;
            if (pounds !== 1) {
                result += 's';
            }
        }
        // Handle pence
        if (pence > 0) {
            if (pounds > 0) {
                result += ' and ';
            }
            result += this.convertToWords(pence.toString()) + ' ' + this.subUnitName;
        }
        return (isNegative ? 'negative ' : '') + result;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberToWordsDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: NumberToWordsDirective, selector: "[numberToWords]", inputs: { numberToWords: "numberToWords", isCurrency: "isCurrency", currencyName: "currencyName", subUnitName: "subUnitName" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NumberToWordsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[numberToWords]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { numberToWords: [{
                type: Input
            }], isCurrency: [{
                type: Input
            }], currencyName: [{
                type: Input
            }], subUnitName: [{
                type: Input
            }] } });

const directives = [
    AccessControlDirective,
    CountUpDirective,
    FallbackImageDirective,
    HasPermissionDirective,
    PreventMultipleClickDirective,
    NumberToWordsDirective
];
const pipes = [
    DynamicLabelPipe,
    FormatFileSizePipe,
    LuxonRelativePipe,
    StripHTMLPipe,
    SafePipe,
    TrimToFieldNamePipe,
    TruncatePipe
];
const components = [
    ActionButtonsSectionComponent,
    BaseEntityListFilterBuilderComponent,
    BaseObservablesFeedbackComponent,
    BasePLAvatarComponent,
    LazyLoadExpansionPanelComponent,
    LoaderComponent,
    FeedbackMessageComponent,
    PlCollapsableSectionComponent,
    PlIconComponent,
    PlTemplateLibraryComponent,
    PlTagComponent,
    FeedbackBarComponent,
    PlCodeViewerComponent,
    PlCodeDiffComponent,
    ProcessStageBarComponent,
    EntityPanelComponent,
    BrandedBannerComponent,
    PlButtonComponent,
    PlCardComponent,
    UserPresenceComponent,
    PlCardStepperComponent
];
class CommonModule {
    static forRoot(authConfig, permissionManagerConfig, dynamicLabelConfig, displayDataResolverConfig, notificationServiceProvider, environmentServiceProvider) {
        return {
            ngModule: CommonModule,
            providers: [
                WINDOW_PROVIDERS,
                environmentServiceProvider || {
                    provide: BaseEnvironmentService,
                    useClass: BaseEnvironmentService,
                    deps: [HttpClient, WINDOW]
                },
                {
                    provide: AuthConfig,
                    useValue: authConfig
                },
                {
                    provide: DisplayDataResolverConfig,
                    useValue: displayDataResolverConfig
                },
                notificationServiceProvider || {
                    provide: BaseNotificationService,
                    useClass: KendoNotificationService
                },
                {
                    provide: DynamicLabelConfig,
                    useValue: dynamicLabelConfig
                },
                {
                    provide: PermissionManagerConfig,
                    useValue: permissionManagerConfig
                },
                {
                    provide: AppTitleService,
                    useClass: AppTitleService,
                    deps: [Title, Router]
                }
            ]
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CommonModule, declarations: [ActionButtonsSectionComponent,
            BaseEntityListFilterBuilderComponent,
            BaseObservablesFeedbackComponent,
            BasePLAvatarComponent,
            LazyLoadExpansionPanelComponent,
            LoaderComponent,
            FeedbackMessageComponent,
            PlCollapsableSectionComponent,
            PlIconComponent,
            PlTemplateLibraryComponent,
            PlTagComponent,
            FeedbackBarComponent,
            PlCodeViewerComponent,
            PlCodeDiffComponent,
            ProcessStageBarComponent,
            EntityPanelComponent,
            BrandedBannerComponent,
            PlButtonComponent,
            PlCardComponent,
            UserPresenceComponent,
            PlCardStepperComponent, AccessControlDirective,
            CountUpDirective,
            FallbackImageDirective,
            HasPermissionDirective,
            PreventMultipleClickDirective,
            NumberToWordsDirective, DynamicLabelPipe,
            FormatFileSizePipe,
            LuxonRelativePipe,
            StripHTMLPipe,
            SafePipe,
            TrimToFieldNamePipe,
            TruncatePipe], imports: [CommonModule$1,
            RouterModule,
            ButtonModule,
            LayoutModule,
            ButtonsModule,
            ExcelModule,
            FilterModule,
            TooltipsModule, i2$4.MarkdownModule, ProgressBarModule,
            RippleModule, i2$1.TranslateModule], exports: [ActionButtonsSectionComponent,
            BaseEntityListFilterBuilderComponent,
            BaseObservablesFeedbackComponent,
            BasePLAvatarComponent,
            LazyLoadExpansionPanelComponent,
            LoaderComponent,
            FeedbackMessageComponent,
            PlCollapsableSectionComponent,
            PlIconComponent,
            PlTemplateLibraryComponent,
            PlTagComponent,
            FeedbackBarComponent,
            PlCodeViewerComponent,
            PlCodeDiffComponent,
            ProcessStageBarComponent,
            EntityPanelComponent,
            BrandedBannerComponent,
            PlButtonComponent,
            PlCardComponent,
            UserPresenceComponent,
            PlCardStepperComponent, AccessControlDirective,
            CountUpDirective,
            FallbackImageDirective,
            HasPermissionDirective,
            PreventMultipleClickDirective,
            NumberToWordsDirective, DynamicLabelPipe,
            FormatFileSizePipe,
            LuxonRelativePipe,
            StripHTMLPipe,
            SafePipe,
            TrimToFieldNamePipe,
            TruncatePipe] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommonModule, providers: [
            FormatFileSizePipe,
            StripHTMLPipe,
            DynamicLabelPipe,
            TrimToFieldNamePipe,
            CurrencyPipe,
            SafePipe
        ], imports: [CommonModule$1,
            RouterModule,
            ButtonModule,
            LayoutModule,
            ButtonsModule,
            ExcelModule,
            FilterModule,
            TooltipsModule,
            MarkdownModule.forChild(),
            ProgressBarModule,
            RippleModule,
            TranslateModule.forChild()] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...components, ...directives, ...pipes],
                    imports: [
                        CommonModule$1,
                        RouterModule,
                        ButtonModule,
                        LayoutModule,
                        ButtonsModule,
                        ExcelModule,
                        FilterModule,
                        TooltipsModule,
                        MarkdownModule.forChild(),
                        ProgressBarModule,
                        RippleModule,
                        TranslateModule.forChild()
                    ],
                    exports: [...components, ...directives, ...pipes],
                    providers: [
                        FormatFileSizePipe,
                        StripHTMLPipe,
                        DynamicLabelPipe,
                        TrimToFieldNamePipe,
                        CurrencyPipe,
                        SafePipe
                    ]
                }]
        }] });

class StringHelper {
    static capitalizeWords(sentence) {
        if (!Array.isArray(sentence)) {
            sentence = sentence.split(' ');
        }
        for (let i = 0; i < sentence.length; i++) {
            sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);
        }
        return sentence.join(' ');
    }
}

class AlreadyAuthenticatedGuard {
    authConfig;
    router;
    oauthService;
    constructor(authConfig, router, oauthService) {
        this.authConfig = authConfig;
        this.router = router;
        this.oauthService = oauthService;
    }
    canActivate() {
        if (this.oauthService.hasValidAccessToken() &&
            this.oauthService.hasValidIdToken()) {
            this.router.navigate([this.authConfig.authenticatedRoute ?? '/']);
            return false;
        }
        return true;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlreadyAuthenticatedGuard, deps: [{ token: AuthConfig }, { token: i1.Router }, { token: i3.OAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlreadyAuthenticatedGuard, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlreadyAuthenticatedGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AuthConfig }, { type: i1.Router }, { type: i3.OAuthService }]; } });

class AuthGuard {
    authConfig;
    router;
    oauthService;
    constructor(authConfig, router, oauthService) {
        this.authConfig = authConfig;
        this.router = router;
        this.oauthService = oauthService;
    }
    canActivate() {
        if (this.oauthService.hasValidAccessToken() &&
            this.oauthService.hasValidIdToken()) {
            return true;
        }
        else {
            const a = sessionStorage.getItem('redirectUrl');
            // this has a bit odd behaviour on Firefox/Safari. For some reason even though authentication service would
            // set redirectUrl it still would override it (almost like some race condition or something).
            if (!a) {
                sessionStorage.setItem('redirectUrl', window.location.pathname + window.location.search);
                console.log('AuthGuard - Added redirectUrl. Old ' + a);
            }
            else {
                console.log('AuthGuard - redirect url already present - skipping setting new. Old: ' + a);
            }
            this.router.navigate([this.authConfig.unauthenticatedRoute ?? '/'], {
                queryParams: this.authConfig.unauthenticatedQueryParams
            });
            return false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthGuard, deps: [{ token: AuthConfig }, { token: i1.Router }, { token: i3.OAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthGuard, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: AuthConfig }, { type: i1.Router }, { type: i3.OAuthService }]; } });

/**
 * Guard that checks if the user has permissions to do a specific action over a specific object
 */
class HasPermissionGuard {
    permissionsService;
    authConfig;
    router;
    constructor(permissionsService, authConfig, router) {
        this.permissionsService = permissionsService;
        this.authConfig = authConfig;
        this.router = router;
    }
    async canActivate(route, state) {
        const subject = route.data['subject'];
        const action = route.data['action'];
        const field = route.data['field'];
        if (!subject || !action) {
            throw new Error('Guard needs an subject and action to be evaluated');
        }
        if (await this.permissionsService.hasPermission(subject, action, field)) {
            return true;
        }
        this.router.navigate([this.authConfig.forbiddenRoute ?? '/']);
        return false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HasPermissionGuard, deps: [{ token: PermissionsService }, { token: AuthConfig }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HasPermissionGuard, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HasPermissionGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: PermissionsService }, { type: AuthConfig }, { type: i1.Router }]; } });

class CanDeactivateGuard {
    constructor() { }
    canDeactivate(component, route, state) {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CanDeactivateGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CanDeactivateGuard });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CanDeactivateGuard, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class TokenizedInterceptor {
    environmentService;
    authService;
    includedUris = [];
    urlsSet;
    constructor(environmentService, authService) {
        this.environmentService = environmentService;
        this.authService = authService;
    }
    setHeaders(request) {
        const token = this.authService.getAccessToken();
        if (token) {
            request = request.clone({
                setHeaders: {
                    // 'content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
        }
        return request;
    }
    intercept(request, next, secondTry = false) {
        if (this.includedUris.length === 0 && this.environmentService.apiHostUrl) {
            this.includedUris.push(this.environmentService.apiHostUrl);
            this.includedUris.push(this.environmentService.placApiHostUrl);
        }
        if (!this.urlsSet && this.environmentService.additionalUrlsToSetAuthTokensOn) {
            this.urlsSet = true;
            this.includedUris.push(...this.environmentService.additionalUrlsToSetAuthTokensOn);
        }
        if (!this.includedUris.find((u) => request.url.includes(u))) {
            return next.handle(request);
        }
        request = this.setHeaders(request);
        return next.handle(request).pipe(catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401 &&
                    !secondTry &&
                    this.authService.getRefreshToken()) {
                    return from(this.authService.refreshToken()).pipe(catchError(() => {
                        return from(this.authService.revokeTokenAndLogout());
                    }), switchMap(() => {
                        return this.intercept(request, next, true);
                    }));
                }
                switch (error.status) {
                    case 0:
                        return throwError({
                            status: error.status,
                            message: 'Unable to connect to server, please contact admin'
                        });
                    case 400:
                    case 401:
                    case 403:
                    case 404:
                    case 500:
                    default:
                        return throwError({
                            status: error.status,
                            message: error.message,
                            error: error.error
                        });
                }
            }
            else if (error.error instanceof ErrorEvent) {
                // Client Side Error
                return throwError({
                    status: error.status,
                    message: error.error?.message || error.message || error,
                });
            }
            else {
                // Server Side Error
                return throwError({
                    status: error.status,
                    message: error.error?.message || error.message || error,
                });
            }
        }), finalize(() => {
            // do something at the end
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TokenizedInterceptor, deps: [{ token: BaseEnvironmentService }, { token: i3.OAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TokenizedInterceptor });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TokenizedInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: BaseEnvironmentService }, { type: i3.OAuthService }]; } });

class JsonDateInterceptor {
    static dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?$/;
    static utcDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;
    supportedRequests;
    static convert(object) {
        if (!object || !(object instanceof Object)) {
            return;
        }
        if (object instanceof Array) {
            for (const item of object) {
                this.convert(item);
            }
        }
        for (const key of Object.keys(object)) {
            const value = object[key];
            if (value instanceof Array) {
                for (const item in value) {
                    this.convert(item);
                }
            }
            if (value instanceof Object) {
                this.convert(value);
            }
            if (typeof value === 'string' &&
                (this.dateRegex.test(value) || this.utcDateRegex.test(value))) {
                object[key] = new Date(value);
                if (object[key] <= new Date('0001-01-01')) {
                    object[key] = undefined;
                }
            }
        }
    }
    intercept(req, next) {
        const nextObs = next.handle(req);
        if (this.supportedRequests &&
            _.filter(this.supportedRequests, (e) => req.url.toLowerCase().indexOf(e.toLowerCase()) >= 0).length === 0) {
            return nextObs;
        }
        return nextObs.pipe(tap((val) => {
            if (val instanceof HttpResponse) {
                JsonDateInterceptor.convert(val.body);
            }
        }));
    }
}

class BaseFilterableComponentConfigurator {
    dataServiceType;
    dataServiceFactory;
    /**
     * handleFilterOverride
     *
     * Method called by component when filter is changed.
     * Once provided should override whole filter change handling steps like:
     *
     * - getting data that matches the filter criteria
     * - calling setFilteredData method
     * - setting loading flags
     */
    handleFilterOverride;
    /**
     * handleGetById
     *
     * Method called by component when it tries to fix value object and not all data is loaded and object with 'value.id' doesn't exists in current filteredData.
     */
    handleGetByIds;
    /**
     * called just before data is passed to setFilteredData method on component.
     *
     * result of this method will be filtered to exclude unwanted ids (excludeIds property in component) unless
     * processFilteredDataHandlesExcludeIds is set.
     */
    processFilteredData;
    /**
     * if set processFilteredData has to handle removal of 'excludeIds'
     */
    processFilteredDataHandlesExcludeIds;
    /**
     * when set and when displayResolver/displayResolverType are undefined
     * DisplayDataResolverGetterService will be used against all items[].entityType
     */
    useDisplayResolverGetter;
    /**
     * Allows to override id generation for dropdown items.
     *
     * If set the entityDropDownItem.id will be equal to result otherwise to value.id.
     * Should be used along with valueField (returning the same value)
     *
     */
    dropdownItemIdGenerator;
    /**
     * Allows to change generated dropdownItem, runs as a last action in convertToDropDownItem method.
     *
     * pageInfo - if set represents the prev pageInfo or pageInfo that user requested
     */
    processDropdownItem;
    getDataServiceQueryStateForFilter(value, pageInfo) {
        return {};
    }
    initialize(service) {
    }
}

class BaseDisplayItemAwareComponentConfigurator extends BaseFilterableComponentConfigurator {
    displayDataResolverType;
    textField = 'name';
    valueField = 'id';
    displaySubLabel = true;
    convertFromDisplayItemOverride;
    cacheType;
    showCacheRefreshButton;
    pageInfoPosition = 'footer';
    displayItemAwareComponent;
}

class BaseHierarchicalDisplayItemAwareComponentConfigurator extends BaseDisplayItemAwareComponentConfigurator {
    filterable;
    fetchChildren;
    hasChildren;
    dataBindingType;
    /**
     * Used for kendoDropDownTreeFlatBinding to link item with it's parent item.
     * Default 'parentId'.
     *
     * The parentIdField property should exist on EntityDropdownItem
     */
    parentIdField = 'parentId';
    /**
     * Used for kendoDropDownTreeHierarchyBinding to get child entities from data.
     * Default 'children'.
     *
     * The childrenField property should exist on EntityDropdownItem
     */
    childrenField = 'children';
    /**
     * Called for each item in the filteredData to determine if it should be possible to select that item.
     * Useful when user should only be able to select leafs
     */
    isItemSelectable;
    checkableSettings;
    idField;
    expandOnFilter;
    /**
     * allows to specify keys of the items that should be expanded by default
     */
    expandedKeys;
    /**
     * Property name or handler to define the keys that will be put into expandedKeys
     */
    expandBy;
    customItemTemplate;
}

class BaseEntityListConfigurator {
    displayDataResolver;
    rowHeight;
    get columns() {
        return this._columns;
    }
    set columns(value) {
        this.columnsByFiled = undefined;
        this._columns = value;
    }
    columnsByFiled;
    getColumnByField(field) {
        this.columnsByFiled =
            this.columnsByFiled || _.keyBy(this._columns, 'field');
        return this.columnsByFiled[field];
    }
    render = true;
    labelsType;
    labelsSubType;
    _columns;
    dataLoaderType;
    dataLoaderService;
    dataLoaderServiceType;
    dataLoaderFunction;
    countLoaderFunction;
    fetchedDataHandler;
    loadOnInit = true;
    initialState;
    list;
    getMessages;
    rowClass;
    cellClickHandler;
    showMenuColumn = false;
    menuItems;
    menuOpened;
    menuItemClicked;
    selectable;
    selectionKeyNameOrGenerator;
    checkBoxColumnSettings;
    sortableSettings;
    pageableSettings;
    filtersSettings;
    groupable;
    advancedFiltersBuilderComponentType;
    getCustomFilterTemplate;
    getCustomColumnTemplate;
    getCustomEditorTemplate;
    /**
     * When set the changes to state will be applied by calling assignProcessedData method without calling fetch.
     */
    applyStateChangeLocally;
    /**
     * if Set will throw an excpetion when fetchedData.data.length!=fetchedData.count for applyStateChangeLocally
     */
    throwOnDataLengthMismatch = true;
    /**
     * Allows to override default actions properties or add new actions.
     * default onClick action will be provided which will raise customActionClicked event.
     * onClick property can also be set in code.
     */
    actions;
    /**
     * Shows actions for which property is greater or equal 0. The value is used to specify order of actions
     * Works only if actions property is not set (default value)
     */
    showActions = {
        refresh: 10,
        toggleFilters: 20,
        toggleGroupsExpand: 11
    };
    customActionClicked;
    /**
     * When set to true it will allow editing in grid
     */
    editableSettings = {
        editable: false,
        actionButtonsPlacement: { default: 'gridActionsInToolbar' }
    };
    /**
     * When set to true it will show delete action per row
     */
    deletable = false;
    editActionHandlers;
    editFormGetter;
    securityConfig;
    // handler to override securityConfig
    secureGridHandler;
    selectedItemsChangedHandler;
    /**
     * when set the groups/children will be expanded
     */
    initiallyExpanded;
    constructor(displayDataResolver, service, dataLoaderFunction, countLoaderFunction) {
        this.displayDataResolver = displayDataResolver;
        this.dataLoaderType = service ? 'baseApiService' : 'custom';
        this.dataLoaderService = service;
        this.dataLoaderFunction = dataLoaderFunction;
        this.countLoaderFunction = countLoaderFunction;
    }
}

class BaseEntityHierarchicalListConfigurator extends BaseEntityListConfigurator {
    fetchChildren;
    hasChildren;
    /**
     * When set to kendoHierarchyBinding or kendoFlatBinding all data operations
     * will be executed by kendo directives (no need to handle state changes etc).
     */
    dataBindingType;
    parentIdField;
    childrenField;
    idField = 'id';
}

const fadeInOutAnimation = trigger('fadeInOutAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1, maxHeight: '100%' }))
    ]),
    transition(':leave', [animate('200ms', style({ opacity: 0, height: 0 }))])
]);

const staggerAnimationFromTop = trigger('staggerAnimationFromTop', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateY(20px)' }),
            stagger(100, animate('300ms', style({ opacity: 1, transform: 'none' })))
        ], { optional: true }),
        // FIXME: when navigating away from the page it page layout overlaps
        query(':leave', [
            stagger(0, [
                animate('100ms', style({ opacity: 0, transform: 'translateY(10px)' })),
                animate('100ms', style({ height: 0, margin: 0, padding: 0, opacity: 0 }))
            ])
        ], { optional: true })
    ])
]);
const staggerAnimationFromBottom = trigger('staggerAnimationFromBottom', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateY(-20px)' }),
            stagger(100, animate('300ms', style({ opacity: 1, transform: 'none' })))
        ], { optional: true }),
        // FIXME: when navigating away from the page it page layout overlaps
        query(':leave', [
            stagger(0, [
                animate('100ms', style({ opacity: 0, transform: 'translateY(10px)' })),
                animate('100ms', style({ height: 0, margin: 0, padding: 0, opacity: 0 }))
            ])
        ], { optional: true })
    ])
]);
const staggerAnimationFromLeft = trigger('staggerAnimationFromLeft', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateX(-40px)' }),
            stagger(50, animate('200ms', style({ opacity: 1, transform: 'none' })))
        ], { optional: true })
    ])
]);
const staggerAnimationFromRight = trigger('staggerAnimationFromRight', [
    transition('* => *', [
        query(':enter', [
            style({ opacity: 0, transform: 'translateX(40px)' }),
            stagger(50, animate('200ms', style({ opacity: 1, transform: 'none' })))
        ], { optional: true })
    ])
]);

const slideInOutAnimation = trigger('slideInOutAnimation', [
    transition(':enter', [
        style({ height: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', overflow: 'hidden' }))
    ]),
    transition(':leave', [
        style({ height: '*', overflow: 'hidden' }),
        animate('100ms ease-out', style({ height: 0, overflow: 'hidden' }))
    ])
]);

/**
 * Generated bundle index. Do not edit.
 */

export { AccessControlDirective, ActionButtonsSectionComponent, AlreadyAuthenticatedGuard, AppTitleService, AuthConfig, AuthGuard, AuthenticationService, BaseApiPermissionsService, BaseApiService, BaseAuditableApiService, BaseAuditableCacheableApiService, BaseAuditableDataService, BaseCacheableApiService, BaseDataService, BaseDetailComponent, BaseDisplayItemAwareComponentConfigurator, BaseDomainStepperService, BaseEditActionHandler, BaseEntityDisplayItemAwareComponent, BaseEntityHierarchicalDisplayItemAwareComponent, BaseEntityHierarchicalListComponent, BaseEntityHierarchicalListConfigurator, BaseEntityListComponent, BaseEntityListConfigurator, BaseEntityListFilterBuilderComponent, BaseEnvironmentService, BaseFilterableComponentConfigurator, BaseHierarchicalDisplayItemAwareComponentConfigurator, BaseNonEntityApiService, BaseNotificationService, BaseObservablesFeedbackComponent, BasePLAvatarComponent, BaseResolver, BaseUserAuditableCacheableApiService, BaseUserCacheableApiService, BrandedBannerComponent, CanDeactivateGuard, CodeDiffService, CommonModule, CountUpDirective, DisplayDataResolverConfig, DisplayDataResolverGetterService, DynamicLabelConfig, DynamicLabelPipe, EntityMetadata, EntityMetadataService, EntityPanelComponent, FallbackImageDirective, FeedbackBarComponent, FeedbackMessageComponent, FormatFileSizePipe, HasPermissionDirective, HasPermissionGuard, JsonDateInterceptor, KendoNotificationService, LazyLoadExpansionPanelComponent, LoaderComponent, LuxonRelativePipe, MultiPropertyCache, NotificationType, NumberToWordsDirective, PermissionManagerConfig, PermissionsService, PlButtonComponent, PlCardComponent, PlCardStepperComponent, PlCodeDiffComponent, PlCodeViewerComponent, PlCollapsableSectionComponent, PlIconComponent, PlTagComponent, PlTemplateLibraryComponent, PreventMultipleClickDirective, ProcessStageBarComponent, SafePipe, SplitPascalCasePipe, StepIndicatorService, StringHelper, StripHTMLPipe, TemplateLibraryService, TokenizedInterceptor, TrimToFieldNamePipe, TruncatePipe, UserPresenceComponent, WINDOW, WINDOW_PROVIDERS, appInjector, convertToODataString, fadeInOutAnimation, filterByField, filtersByField, flatten, getDistanceToBottom, isPresent, kendoConvertToODataString, removeFilter, setFilter, setMandatoryFilter, slideInOutAnimation, staggerAnimationFromBottom, staggerAnimationFromLeft, staggerAnimationFromRight, staggerAnimationFromTop };
